
window.sso = (function SSOService(window, service) {
  if (!window || !service) {
    return;
  }

  var AUTH_ORIGIN = 'https://accounts.mtlchild.com';
  var AUTH_SERVICE_URL = AUTH_ORIGIN + '/services/:service/auth';
  var INIT_TIMEOUT = 20000;
  var EXEC_TIMEOUT = 30000;

  var iframeUrl = AUTH_SERVICE_URL.replace(':service', service);
  var iframeSSO = null;
  var reqId = 0;
  var callbackRegistry = {};

  var response = null;
  var initComplete = false;
  var initCallbacks = [];
  var initTimeout = null;
  var initError = null;

  var api = {
    getResponse: getResponse,
    login: login,
    logout: logout,
    getState: getState
  };

  document.addEventListener('DOMContentLoaded', init);

  return {
    getInstance: function (callback) {
      initCallbacks.push(callback);
      processInitCallbacks();
    }
  };

  function processInitCallbacks() {
    if (!initComplete) {
      // check later, but only if check is not already scheduled
      if (!initTimeout) {
        initTimeout = setTimeout(function () {
          initTimeout = null;

          if (initComplete) {
            // notify of success
            return processInitCallbacks();
          }

          if (initCallbacks.length > 0) {
            do {
              var callback = initCallbacks.shift();
              callback(initError || new Error('INIT_TIMEOUT'));
            } while(initCallbacks.length);
          }
        }, INIT_TIMEOUT);
      }
    } else {
      // initialized
      clearTimeout(initTimeout);
      initTimeout = null;

      if (initCallbacks.length > 0) {
        do {
          var callback = initCallbacks.shift();
          if (initError) {
            callback(initError);
          } else {
            callback(null, api, response);
          }
        } while(initCallbacks.length);
      }
    }
  }

  function init() {
    if (iframeSSO) {
      console.log('SSOFrame already initialized');
      return;
    }

    try {
      iframeSSO = initSSO(service, iframeUrl);
    } catch (e) {
      // do something
      initError = e;
      initComplete = true;
      processInitCallbacks();
    }
  }

  function initSSO(service, iframeUrl) {
    window.addEventListener('message', function (event) {
      if (!~event.origin.indexOf(AUTH_ORIGIN)) {
        return;
      }

      if (typeof event.data !== 'object') {
        console.log('unrecognized data', event);
        return;
      }

      response = event.data;
      // strip out empty errors object
      if (isEmptyObject(response.errors)) {
        delete response.errors;
      }

      if (response.id === null && response.status) {
        if (!initComplete) {
          // console.log('init', response);
          initComplete = true;
          initResponse = response;
          return processInitCallbacks();
        }

        console.log('reinit?', response);
        return;
      }

      if (response.id) {
        // 'twas in response to an action we requested
        var handle = callbackRegistry[response.id];
        if (handle && handle.callback) {
          // console.log('found callback', response);
          delete callbackRegistry[response.id];
          clearTimeout(handle.timeout);
          return handle.callback(null, response);
        }
      }

      console.log('unhandled', response);
    }, false);

    return createIframe(iframeUrl);
  }

  function createIframe(iframeUrl) {
    var elem = document.getElementById('iframe-sso');
    if (elem) {
      return elem.contentWindow;
    }

    var iframe = document.createElement('iframe');
    iframe.id = 'iframe-sso';
    iframe.src = iframeUrl;
    iframe.scrolling = 'no';
    iframe.border = '0';
    iframe.style = 'background: transparent; width: 100%; height: 10px; overflow: hidden; border: none;';
    document.body.appendChild(iframe);
    return document.getElementById('iframe-sso').contentWindow;
  }

  function isEmptyObject(obj) {
    return typeof obj === 'object' && !Object.keys(obj).length;
  }

  function nextRequestId() {
    if (reqId > 99) {
      reqId = 0;
    }
    return ++reqId;
  }

  function exec(method, args, callback) {
    if (!iframeSSO) {
      return callback(new Error('SSO not initialized'));
    }

    var id = nextRequestId();
    callbackRegistry[id] = {
      callback: callback,
      timeout: setTimeout(function () {
        var callback = callbackRegistry[id].callback;
        if (callback) {
          delete callbackRegistry[id].callback;
          callback(new Error('EXEC_TIMEOUT'));
        }
      }, EXEC_TIMEOUT)
    };

    iframeSSO.postMessage({ id: id, method: method, args: args }, '*');
    return id;
  }

  function getResponse() {
    return response;
  }

  function login(email, password, callback) {
    if (!iframeSSO) {
      return callback(new Error('SSO not initialized'));
    }

    return exec('login', [email, password], callback);
  }

  function getState(callback) {
    if (!iframeSSO) {
      return callback(new Error('SSO not initialized'));
    }

    return exec('getState', [], callback);
  }

  function logout(callback) {
    if (!iframeSSO) {
      return callback(new Error('SSO not initialized'));
    }

    return exec('logout', [], callback);
  }

})(window, window.ssoServiceName);

(function UMDish(name, context, definition, plugins) {
  context[name] = definition.call(context);
  for (var i = 0; i < plugins.length; i++) {
    plugins[i](context[name])
  }
  if (typeof module !== "undefined" && module.exports) {
    module.exports = context[name];
  } else if (typeof define === "function" && define.amd) {
    define(function reference() { return context[name]; });
  }
})("Primus", this || {}, function wrapper() {
  var define, module, exports
    , Primus = (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
'use strict';

/**
 * Create a function that will cleanup the instance.
 *
 * @param {Array|String} keys Properties on the instance that needs to be cleared.
 * @param {Object} options Additional configuration.
 * @returns {Function} Destroy function
 * @api public
 */
module.exports = function demolish(keys, options) {
  var split = /[, ]+/;

  options = options ||  {};
  keys = keys || [];

  if ('string' === typeof keys) keys = keys.split(split);

  /**
   * Run addition cleanup hooks.
   *
   * @param {String} key Name of the clean up hook to run.
   * @param {Mixed} selfie Reference to the instance we're cleaning up.
   * @api private
   */
  function run(key, selfie) {
    if (!options[key]) return;
    if ('string' === typeof options[key]) options[key] = options[key].split(split);
    if ('function' === typeof options[key]) return options[key].call(selfie);

    for (var i = 0, type, what; i < options[key].length; i++) {
      what = options[key][i];
      type = typeof what;

      if ('function' === type) {
        what.call(selfie);
      } else if ('string' === type && 'function' === typeof selfie[what]) {
        selfie[what]();
      }
    }
  }

  /**
   * Destroy the instance completely and clean up all the existing references.
   *
   * @returns {Boolean}
   * @api public
   */
  return function destroy() {
    var selfie = this
      , i = 0
      , prop;

    if (selfie[keys[0]] === null) return false;
    run('before', selfie);

    for (; i < keys.length; i++) {
      prop = keys[i];

      if (selfie[prop]) {
        if ('function' === typeof selfie[prop].destroy) selfie[prop].destroy();
        selfie[prop] = null;
      }
    }

    if (selfie.emit) selfie.emit('destroy');
    run('after', selfie);

    return true;
  };
};

},{}],2:[function(_dereq_,module,exports){
'use strict';

/**
 * Returns a function that when invoked executes all the listeners of the
 * given event with the given arguments.
 *
 * @returns {Function} The function that emits all the things.
 * @api public
 */
module.exports = function emits() {
  var self = this
    , parser;

  for (var i = 0, l = arguments.length, args = new Array(l); i < l; i++) {
    args[i] = arguments[i];
  }

  //
  // If the last argument is a function, assume that it's a parser.
  //
  if ('function' !== typeof args[args.length - 1]) return function emitter() {
    for (var i = 0, l = arguments.length, arg = new Array(l); i < l; i++) {
      arg[i] = arguments[i];
    }

    return self.emit.apply(self, args.concat(arg));
  };

  parser = args.pop();

  /**
   * The actual function that emits the given event. It returns a boolean
   * indicating if the event was emitted.
   *
   * @returns {Boolean}
   * @api public
   */
  return function emitter() {
    for (var i = 0, l = arguments.length, arg = new Array(l + 1); i < l; i++) {
      arg[i + 1] = arguments[i];
    }

    /**
     * Async completion method for the parser.
     *
     * @param {Error} err Optional error when parsing failed.
     * @param {Mixed} returned Emit instructions.
     * @api private
     */
    arg[0] = function next(err, returned) {
      if (err) return self.emit('error', err);

      arg = returned === undefined
        ? arg.slice(1) : returned === null
          ? [] : returned;

      self.emit.apply(self, args.concat(arg));
    };

    parser.apply(self, arg);
    return true;
  };
};

},{}],3:[function(_dereq_,module,exports){
'use strict';

var has = Object.prototype.hasOwnProperty;

//
// We store our EE objects in a plain object whose properties are event names.
// If `Object.create(null)` is not supported we prefix the event names with a
// `~` to make sure that the built-in object properties are not overridden or
// used as an attack vector.
// We also assume that `Object.create(null)` is available when the event name
// is an ES6 Symbol.
//
var prefix = typeof Object.create !== 'function' ? '~' : false;

/**
 * Representation of a single EventEmitter function.
 *
 * @param {Function} fn Event handler to be called.
 * @param {Mixed} context Context for function execution.
 * @param {Boolean} [once=false] Only emit once
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal EventEmitter interface that is molded against the Node.js
 * EventEmitter interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() { /* Nothing to set */ }

/**
 * Hold the assigned EventEmitters by name.
 *
 * @type {Object}
 * @private
 */
EventEmitter.prototype._events = undefined;

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var events = this._events
    , names = []
    , name;

  if (!events) return names;

  for (name in events) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return a list of assigned event listeners.
 *
 * @param {String} event The events that should be listed.
 * @param {Boolean} exists We only need to know if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events && this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Emit an event to all registered event listeners.
 *
 * @param {String} event The name of the event.
 * @returns {Boolean} Indication if we've emitted an event.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if ('function' === typeof listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Register a new EventListener for the given event.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} [context=this] The context of the function.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;
  else {
    if (!this._events[evt].fn) this._events[evt].push(listener);
    else this._events[evt] = [
      this._events[evt], listener
    ];
  }

  return this;
};

/**
 * Add an EventListener that's only called once.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} [context=this] The context of the function.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;
  else {
    if (!this._events[evt].fn) this._events[evt].push(listener);
    else this._events[evt] = [
      this._events[evt], listener
    ];
  }

  return this;
};

/**
 * Remove event listeners.
 *
 * @param {String} event The event we want to remove.
 * @param {Function} fn The listener that we need to find.
 * @param {Mixed} context Only remove listeners matching this context.
 * @param {Boolean} once Only remove once listeners.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return this;

  var listeners = this._events[evt]
    , events = [];

  if (fn) {
    if (listeners.fn) {
      if (
           listeners.fn !== fn
        || (once && !listeners.once)
        || (context && listeners.context !== context)
      ) {
        events.push(listeners);
      }
    } else {
      for (var i = 0, length = listeners.length; i < length; i++) {
        if (
             listeners[i].fn !== fn
          || (once && !listeners[i].once)
          || (context && listeners[i].context !== context)
        ) {
          events.push(listeners[i]);
        }
      }
    }
  }

  //
  // Reset the array, or remove it completely if we have no more listeners.
  //
  if (events.length) {
    this._events[evt] = events.length === 1 ? events[0] : events;
  } else {
    delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners or only the listeners for the specified event.
 *
 * @param {String} event The event want to remove all listeners for.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  if (!this._events) return this;

  if (event) delete this._events[prefix ? prefix + event : event];
  else this._events = prefix ? {} : Object.create(null);

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Expose the module.
//
if ('undefined' !== typeof module) {
  module.exports = EventEmitter;
}

},{}],4:[function(_dereq_,module,exports){
'use strict';

var regex = new RegExp('^((?:\\d+)?\\.?\\d+) *('+ [
  'milliseconds?',
  'msecs?',
  'ms',
  'seconds?',
  'secs?',
  's',
  'minutes?',
  'mins?',
  'm',
  'hours?',
  'hrs?',
  'h',
  'days?',
  'd',
  'weeks?',
  'wks?',
  'w',
  'years?',
  'yrs?',
  'y'
].join('|') +')?$', 'i');

var second = 1000
  , minute = second * 60
  , hour = minute * 60
  , day = hour * 24
  , week = day * 7
  , year = day * 365;

/**
 * Parse a time string and return the number value of it.
 *
 * @param {String} ms Time string.
 * @returns {Number}
 * @api private
 */
module.exports = function millisecond(ms) {
  var type = typeof ms
    , amount
    , match;

  if ('number' === type) return ms;
  else if ('string' !== type || '0' === ms || !ms) return 0;
  else if (+ms) return +ms;

  //
  // We are vulnerable to the regular expression denial of service (ReDoS).
  // In order to mitigate this we don't parse the input string if it is too long.
  // See https://nodesecurity.io/advisories/46.
  //
  if (ms.length > 10000 || !(match = regex.exec(ms))) return 0;

  amount = parseFloat(match[1]);

  switch (match[2].toLowerCase()) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return amount * year;

    case 'weeks':
    case 'week':
    case 'wks':
    case 'wk':
    case 'w':
      return amount * week;

    case 'days':
    case 'day':
    case 'd':
      return amount * day;

    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return amount * hour;

    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return amount * minute;

    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return amount * second;

    default:
      return amount;
  }
};

},{}],5:[function(_dereq_,module,exports){
'use strict';

/**
 * Wrap callbacks to prevent double execution.
 *
 * @param {Function} fn Function that should only be called once.
 * @returns {Function} A wrapped callback which prevents execution.
 * @api public
 */
module.exports = function one(fn) {
  var called = 0
    , value;

  /**
   * The function that prevents double execution.
   *
   * @api private
   */
  function onetime() {
    if (called) return value;

    called = 1;
    value = fn.apply(this, arguments);
    fn = null;

    return value;
  }

  //
  // To make debugging more easy we want to use the name of the supplied
  // function. So when you look at the functions that are assigned to event
  // listeners you don't see a load of `onetime` functions but actually the
  // names of the functions that this module will call.
  //
  onetime.displayName = fn.displayName || fn.name || onetime.displayName || onetime.name;
  return onetime;
};

},{}],6:[function(_dereq_,module,exports){
'use strict';

var has = Object.prototype.hasOwnProperty;

/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */
function querystring(query) {
  var parser = /([^=?&]+)=([^&]*)/g
    , result = {}
    , part;

  //
  // Little nifty parsing hack, leverage the fact that RegExp.exec increments
  // the lastIndex property so we can continue executing this loop until we've
  // parsed all results.
  //
  for (;
    part = parser.exec(query);
    result[decodeURIComponent(part[1])] = decodeURIComponent(part[2])
  );

  return result;
}

/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */
function querystringify(obj, prefix) {
  prefix = prefix || '';

  var pairs = [];

  //
  // Optionally prefix with a '?' if needed
  //
  if ('string' !== typeof prefix) prefix = '?';

  for (var key in obj) {
    if (has.call(obj, key)) {
      pairs.push(encodeURIComponent(key) +'='+ encodeURIComponent(obj[key]));
    }
  }

  return pairs.length ? prefix + pairs.join('&') : '';
}

//
// Expose the module.
//
exports.stringify = querystringify;
exports.parse = querystring;

},{}],7:[function(_dereq_,module,exports){
'use strict';

var EventEmitter = _dereq_('eventemitter3')
  , millisecond = _dereq_('millisecond')
  , destroy = _dereq_('demolish')
  , Tick = _dereq_('tick-tock')
  , one = _dereq_('one-time');

/**
 * Returns sane defaults about a given value.
 *
 * @param {String} name Name of property we want.
 * @param {Recovery} selfie Recovery instance that got created.
 * @param {Object} opts User supplied options we want to check.
 * @returns {Number} Some default value.
 * @api private
 */
function defaults(name, selfie, opts) {
  return millisecond(
    name in opts ? opts[name] : (name in selfie ? selfie[name] : Recovery[name])
  );
}

/**
 * Attempt to recover your connection with reconnection attempt.
 *
 * @constructor
 * @param {Object} options Configuration
 * @api public
 */
function Recovery(options) {
  var recovery = this;

  if (!(recovery instanceof Recovery)) return new Recovery(options);

  options = options || {};

  recovery.attempt = null;        // Stores the current reconnect attempt.
  recovery._fn = null;            // Stores the callback.

  recovery['reconnect timeout'] = defaults('reconnect timeout', recovery, options);
  recovery.retries = defaults('retries', recovery, options);
  recovery.factor = defaults('factor', recovery, options);
  recovery.max = defaults('max', recovery, options);
  recovery.min = defaults('min', recovery, options);
  recovery.timers = new Tick(recovery);
}

Recovery.prototype = new EventEmitter();
Recovery.prototype.constructor = Recovery;

Recovery['reconnect timeout'] = '30 seconds';  // Maximum time to wait for an answer.
Recovery.max = Infinity;                       // Maximum delay.
Recovery.min = '500 ms';                       // Minimum delay.
Recovery.retries = 10;                         // Maximum amount of retries.
Recovery.factor = 2;                           // Exponential back off factor.

/**
 * Start a new reconnect procedure.
 *
 * @returns {Recovery}
 * @api public
 */
Recovery.prototype.reconnect = function reconnect() {
  var recovery = this;

  return recovery.backoff(function backedoff(err, opts) {
    opts.duration = (+new Date()) - opts.start;

    if (err) return recovery.emit('reconnect failed', err, opts);

    recovery.emit('reconnected', opts);
  }, recovery.attempt);
};

/**
 * Exponential back off algorithm for retry operations. It uses a randomized
 * retry so we don't DDOS our server when it goes down under pressure.
 *
 * @param {Function} fn Callback to be called after the timeout.
 * @param {Object} opts Options for configuring the timeout.
 * @returns {Recovery}
 * @api private
 */
Recovery.prototype.backoff = function backoff(fn, opts) {
  var recovery = this;

  opts = opts || recovery.attempt || {};

  //
  // Bailout when we already have a back off process running. We shouldn't call
  // the callback then.
  //
  if (opts.backoff) return recovery;

  opts['reconnect timeout'] = defaults('reconnect timeout', recovery, opts);
  opts.retries = defaults('retries', recovery, opts);
  opts.factor = defaults('factor', recovery, opts);
  opts.max = defaults('max', recovery, opts);
  opts.min = defaults('min', recovery, opts);

  opts.start = +opts.start || +new Date();
  opts.duration = +opts.duration || 0;
  opts.attempt = +opts.attempt || 0;

  //
  // Bailout if we are about to make too much attempts.
  //
  if (opts.attempt === opts.retries) {
    fn.call(recovery, new Error('Unable to recover'), opts);
    return recovery;
  }

  //
  // Prevent duplicate back off attempts using the same options object and
  // increment our attempt as we're about to have another go at this thing.
  //
  opts.backoff = true;
  opts.attempt++;

  recovery.attempt = opts;

  //
  // Calculate the timeout, but make it randomly so we don't retry connections
  // at the same interval and defeat the purpose. This exponential back off is
  // based on the work of:
  //
  // http://dthain.blogspot.nl/2009/02/exponential-backoff-in-distributed.html
  //
  opts.scheduled = opts.attempt !== 1
    ? Math.min(Math.round(
        (Math.random() + 1) * opts.min * Math.pow(opts.factor, opts.attempt - 1)
      ), opts.max)
    : opts.min;

  recovery.timers.setTimeout('reconnect', function delay() {
    opts.duration = (+new Date()) - opts.start;
    opts.backoff = false;
    recovery.timers.clear('reconnect, timeout');

    //
    // Create a `one` function which can only be called once. So we can use the
    // same function for different types of invocations to create a much better
    // and usable API.
    //
    var connect = recovery._fn = one(function connect(err) {
      recovery.reset();

      if (err) return recovery.backoff(fn, opts);

      fn.call(recovery, undefined, opts);
    });

    recovery.emit('reconnect', opts, connect);
    recovery.timers.setTimeout('timeout', function timeout() {
      var err = new Error('Failed to reconnect in a timely manner');
      opts.duration = (+new Date()) - opts.start;

      recovery.emit('reconnect timeout', err, opts);
      connect(err);
    }, opts['reconnect timeout']);
  }, opts.scheduled);

  //
  // Emit a `reconnecting` event with current reconnect options. This allows
  // them to update the UI and provide their users with feedback.
  //
  recovery.emit('reconnect scheduled', opts);

  return recovery;
};

/**
 * Check if the reconnection process is currently reconnecting.
 *
 * @returns {Boolean}
 * @api public
 */
Recovery.prototype.reconnecting = function reconnecting() {
  return !!this.attempt;
};

/**
 * Tell our reconnection procedure that we're passed.
 *
 * @param {Error} err Reconnection failed.
 * @returns {Recovery}
 * @api public
 */
Recovery.prototype.reconnected = function reconnected(err) {
  if (this._fn) this._fn(err);
  return this;
};

/**
 * Reset the reconnection attempt so it can be re-used again.
 *
 * @returns {Recovery}
 * @api public
 */
Recovery.prototype.reset = function reset() {
  this._fn = this.attempt = null;
  this.timers.clear('reconnect, timeout');

  return this;
};

/**
 * Clean up the instance.
 *
 * @type {Function}
 * @returns {Boolean}
 * @api public
 */
Recovery.prototype.destroy = destroy('timers attempt _fn');

//
// Expose the module.
//
module.exports = Recovery;

},{"demolish":1,"eventemitter3":8,"millisecond":4,"one-time":5,"tick-tock":10}],8:[function(_dereq_,module,exports){
'use strict';

//
// We store our EE objects in a plain object whose properties are event names.
// If `Object.create(null)` is not supported we prefix the event names with a
// `~` to make sure that the built-in object properties are not overridden or
// used as an attack vector.
// We also assume that `Object.create(null)` is available when the event name
// is an ES6 Symbol.
//
var prefix = typeof Object.create !== 'function' ? '~' : false;

/**
 * Representation of a single EventEmitter function.
 *
 * @param {Function} fn Event handler to be called.
 * @param {Mixed} context Context for function execution.
 * @param {Boolean} once Only emit once
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal EventEmitter interface that is molded against the Node.js
 * EventEmitter interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() { /* Nothing to set */ }

/**
 * Holds the assigned EventEmitters by name.
 *
 * @type {Object}
 * @private
 */
EventEmitter.prototype._events = undefined;

/**
 * Return a list of assigned event listeners.
 *
 * @param {String} event The events that should be listed.
 * @param {Boolean} exists We only need to know if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events && this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Emit an event to all registered event listeners.
 *
 * @param {String} event The name of the event.
 * @returns {Boolean} Indication if we've emitted an event.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if ('function' === typeof listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Register a new EventListener for the given event.
 *
 * @param {String} event Name of the event.
 * @param {Functon} fn Callback function.
 * @param {Mixed} context The context of the function.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;
  else {
    if (!this._events[evt].fn) this._events[evt].push(listener);
    else this._events[evt] = [
      this._events[evt], listener
    ];
  }

  return this;
};

/**
 * Add an EventListener that's only called once.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} context The context of the function.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;
  else {
    if (!this._events[evt].fn) this._events[evt].push(listener);
    else this._events[evt] = [
      this._events[evt], listener
    ];
  }

  return this;
};

/**
 * Remove event listeners.
 *
 * @param {String} event The event we want to remove.
 * @param {Function} fn The listener that we need to find.
 * @param {Mixed} context Only remove listeners matching this context.
 * @param {Boolean} once Only remove once listeners.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return this;

  var listeners = this._events[evt]
    , events = [];

  if (fn) {
    if (listeners.fn) {
      if (
           listeners.fn !== fn
        || (once && !listeners.once)
        || (context && listeners.context !== context)
      ) {
        events.push(listeners);
      }
    } else {
      for (var i = 0, length = listeners.length; i < length; i++) {
        if (
             listeners[i].fn !== fn
          || (once && !listeners[i].once)
          || (context && listeners[i].context !== context)
        ) {
          events.push(listeners[i]);
        }
      }
    }
  }

  //
  // Reset the array, or remove it completely if we have no more listeners.
  //
  if (events.length) {
    this._events[evt] = events.length === 1 ? events[0] : events;
  } else {
    delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners or only the listeners for the specified event.
 *
 * @param {String} event The event want to remove all listeners for.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  if (!this._events) return this;

  if (event) delete this._events[prefix ? prefix + event : event];
  else this._events = prefix ? {} : Object.create(null);

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Expose the module.
//
if ('undefined' !== typeof module) {
  module.exports = EventEmitter;
}

},{}],9:[function(_dereq_,module,exports){
'use strict';

/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */
module.exports = function required(port, protocol) {
  protocol = protocol.split(':')[0];
  port = +port;

  if (!port) return false;

  switch (protocol) {
    case 'http':
    case 'ws':
    return port !== 80;

    case 'https':
    case 'wss':
    return port !== 443;

    case 'ftp':
    return port !== 21;

    case 'gopher':
    return port !== 70;

    case 'file':
    return false;
  }

  return port !== 0;
};

},{}],10:[function(_dereq_,module,exports){
'use strict';

var has = Object.prototype.hasOwnProperty
  , ms = _dereq_('millisecond');

/**
 * Timer instance.
 *
 * @constructor
 * @param {Object} timer New timer instance.
 * @param {Function} clear Clears the timer instance.
 * @param {Function} duration Duration of the timer.
 * @param {Function} fn The functions that need to be executed.
 * @api private
 */
function Timer(timer, clear, duration, fn) {
  this.start = +(new Date());
  this.duration = duration;
  this.clear = clear;
  this.timer = timer;
  this.fns = [fn];
}

/**
 * Calculate the time left for a given timer.
 *
 * @returns {Number} Time in milliseconds.
 * @api public
 */
Timer.prototype.remaining = function remaining() {
  return this.duration - this.taken();
};

/**
 * Calculate the amount of time it has taken since we've set the timer.
 *
 * @returns {Number}
 * @api public
 */
Timer.prototype.taken = function taken() {
  return +(new Date()) - this.start;
};

/**
 * Custom wrappers for the various of clear{whatever} functions. We cannot
 * invoke them directly as this will cause thrown errors in Google Chrome with
 * an Illegal Invocation Error
 *
 * @see #2
 * @type {Function}
 * @api private
 */
function unsetTimeout(id) { clearTimeout(id); }
function unsetInterval(id) { clearInterval(id); }
function unsetImmediate(id) { clearImmediate(id); }

/**
 * Simple timer management.
 *
 * @constructor
 * @param {Mixed} context Context of the callbacks that we execute.
 * @api public
 */
function Tick(context) {
  if (!(this instanceof Tick)) return new Tick(context);

  this.timers = {};
  this.context = context || this;
}

/**
 * Return a function which will just iterate over all assigned callbacks and
 * optionally clear the timers from memory if needed.
 *
 * @param {String} name Name of the timer we need to execute.
 * @param {Boolean} clear Also clear from memory.
 * @returns {Function}
 * @api private
 */
Tick.prototype.tock = function ticktock(name, clear) {
  var tock = this;

  return function tickedtock() {
    if (!(name in tock.timers)) return;

    var timer = tock.timers[name]
      , fns = timer.fns.slice()
      , l = fns.length
      , i = 0;

    if (clear) tock.clear(name);
    else tock.start = +new Date();

    for (; i < l; i++) {
      fns[i].call(tock.context);
    }
  };
};

/**
 * Add a new timeout.
 *
 * @param {String} name Name of the timer.
 * @param {Function} fn Completion callback.
 * @param {Mixed} time Duration of the timer.
 * @returns {Tick}
 * @api public
 */
Tick.prototype.setTimeout = function timeout(name, fn, time) {
  var tick = this
    , tock;

  if (tick.timers[name]) {
    tick.timers[name].fns.push(fn);
    return tick;
  }

  tock = ms(time);
  tick.timers[name] = new Timer(
    setTimeout(tick.tock(name, true), ms(time)),
    unsetTimeout,
    tock,
    fn
  );

  return tick;
};

/**
 * Add a new interval.
 *
 * @param {String} name Name of the timer.
 * @param {Function} fn Completion callback.
 * @param {Mixed} time Interval of the timer.
 * @returns {Tick}
 * @api public
 */
Tick.prototype.setInterval = function interval(name, fn, time) {
  var tick = this
    , tock;

  if (tick.timers[name]) {
    tick.timers[name].fns.push(fn);
    return tick;
  }

  tock = ms(time);
  tick.timers[name] = new Timer(
    setInterval(tick.tock(name), ms(time)),
    unsetInterval,
    tock,
    fn
  );

  return tick;
};

/**
 * Add a new setImmediate.
 *
 * @param {String} name Name of the timer.
 * @param {Function} fn Completion callback.
 * @returns {Tick}
 * @api public
 */
Tick.prototype.setImmediate = function immediate(name, fn) {
  var tick = this;

  if ('function' !== typeof setImmediate) return tick.setTimeout(name, fn, 0);

  if (tick.timers[name]) {
    tick.timers[name].fns.push(fn);
    return tick;
  }

  tick.timers[name] = new Timer(
    setImmediate(tick.tock(name, true)),
    unsetImmediate,
    0,
    fn
  );

  return tick;
};

/**
 * Check if we have a timer set.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api public
 */
Tick.prototype.active = function active(name) {
  return name in this.timers;
};

/**
 * Properly clean up all timeout references. If no arguments are supplied we
 * will attempt to clear every single timer that is present.
 *
 * @param {Arguments} ..args.. The names of the timeouts we need to clear
 * @returns {Tick}
 * @api public
 */
Tick.prototype.clear = function clear() {
  var args = arguments.length ? arguments : []
    , tick = this
    , timer, i, l;

  if (args.length === 1 && 'string' === typeof args[0]) {
    args = args[0].split(/[, ]+/);
  }

  if (!args.length) {
    for (timer in tick.timers) {
      if (has.call(tick.timers, timer)) args.push(timer);
    }
  }

  for (i = 0, l = args.length; i < l; i++) {
    timer = tick.timers[args[i]];

    if (!timer) continue;
    timer.clear(timer.timer);

    timer.fns = timer.timer = timer.clear = null;
    delete tick.timers[args[i]];
  }

  return tick;
};

/**
 * Adjust a timeout or interval to a new duration.
 *
 * @returns {Tick}
 * @api public
 */
Tick.prototype.adjust = function adjust(name, time) {
  var interval
    , tick = this
    , tock = ms(time)
    , timer = tick.timers[name];

  if (!timer) return tick;

  interval = timer.clear === unsetInterval;
  timer.clear(timer.timer);
  timer.start = +(new Date());
  timer.duration = tock;
  timer.timer = (interval ? setInterval : setTimeout)(tick.tock(name, !interval), tock);

  return tick;
};

/**
 * We will no longer use this module, prepare your self for global cleanups.
 *
 * @returns {Boolean}
 * @api public
 */
Tick.prototype.end = Tick.prototype.destroy = function end() {
  if (!this.context) return false;

  this.clear();
  this.context = this.timers = null;

  return true;
};

//
// Expose the timer factory.
//
Tick.Timer = Timer;
module.exports = Tick;

},{"millisecond":4}],11:[function(_dereq_,module,exports){
'use strict';

var required = _dereq_('requires-port')
  , lolcation = _dereq_('./lolcation')
  , qs = _dereq_('querystringify')
  , relativere = /^\/(?!\/)/
  , protocolre = /^([a-z0-9.+-]+:)?(\/\/)?(.*)$/i; // actual protocol is first match

/**
 * These are the parse instructions for the URL parsers, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */
var instructions = [
  ['#', 'hash'],                        // Extract from the back.
  ['?', 'query'],                       // Extract from the back.
  ['/', 'pathname'],                    // Extract from the back.
  ['@', 'auth', 1],                     // Extract from the front.
  [NaN, 'host', undefined, 1, 1],       // Set left over value.
  [/\:(\d+)$/, 'port'],                 // RegExp the back.
  [NaN, 'hostname', undefined, 1, 1]    // Set left over.
];

 /**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase
 * @property {Boolean} slashes Indicates whether the protocol is followed by double slash ("//")
 * @property {String} rest     Rest of the URL that is not part of the protocol
 */

 /**
  * Extract protocol information from a URL with/without double slash ("//")
  *
  * @param  {String} address   URL we want to extract from.
  * @return {ProtocolExtract}  Extracted information
  * @private
  */
function extractProtocol(address) {
  var match = protocolre.exec(address);
  return {
    protocol: match[1] ? match[1].toLowerCase() : '',
    slashes: !!match[2],
    rest: match[3] ? match[3] : ''
  };
}

/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my CDO.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} location Location defaults for relative paths.
 * @param {Boolean|Function} parser Parser for the query string.
 * @api public
 */
function URL(address, location, parser) {
  if (!(this instanceof URL)) {
    return new URL(address, location, parser);
  }

  var relative = relativere.test(address)
    , parse, instruction, index, key
    , type = typeof location
    , url = this
    , i = 0;

  //
  // The following if statements allows this module two have compatibility with
  // 2 different API:
  //
  // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
  //    where the boolean indicates that the query string should also be parsed.
  //
  // 2. The `URL` interface of the browser which accepts a URL, object as
  //    arguments. The supplied object will be used as default values / fall-back
  //    for relative paths.
  //
  if ('object' !== type && 'string' !== type) {
    parser = location;
    location = null;
  }

  if (parser && 'function' !== typeof parser) {
    parser = qs.parse;
  }

  location = lolcation(location);

  // extract protocol information before running the instructions
  var extracted = extractProtocol(address);
  url.protocol = extracted.protocol || location.protocol || '';
  url.slashes = extracted.slashes || location.slashes;
  address = extracted.rest;

  for (; i < instructions.length; i++) {
    instruction = instructions[i];
    parse = instruction[0];
    key = instruction[1];

    if (parse !== parse) {
      url[key] = address;
    } else if ('string' === typeof parse) {
      if (~(index = address.indexOf(parse))) {
        if ('number' === typeof instruction[2]) {
          url[key] = address.slice(0, index);
          address = address.slice(index + instruction[2]);
        } else {
          url[key] = address.slice(index);
          address = address.slice(0, index);
        }
      }
    } else if (index = parse.exec(address)) {
      url[key] = index[1];
      address = address.slice(0, address.length - index[0].length);
    }

    url[key] = url[key] || (instruction[3] || ('port' === key && relative) ? location[key] || '' : '');

    //
    // Hostname, host and protocol should be lowercased so they can be used to
    // create a proper `origin`.
    //
    if (instruction[4]) {
      url[key] = url[key].toLowerCase();
    }
  }

  //
  // Also parse the supplied query string in to an object. If we're supplied
  // with a custom parser as function use that instead of the default build-in
  // parser.
  //
  if (parser) url.query = parser(url.query);

  //
  // We should not add port numbers if they are already the default port number
  // for a given protocol. As the host also contains the port number we're going
  // override it with the hostname which contains no port number.
  //
  if (!required(url.port, url.protocol)) {
    url.host = url.hostname;
    url.port = '';
  }

  //
  // Parse down the `auth` for the username and password.
  //
  url.username = url.password = '';
  if (url.auth) {
    instruction = url.auth.split(':');
    url.username = instruction[0] || '';
    url.password = instruction[1] || '';
  }

  //
  // The href is just the compiled result.
  //
  url.href = url.toString();
}

/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} prop          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function used to parse
 *                               the query.
 *                               When setting the protocol, double slash will be removed from
 *                               the final url if it is true.
 * @returns {URL}
 * @api public
 */
URL.prototype.set = function set(part, value, fn) {
  var url = this;

  if ('query' === part) {
    if ('string' === typeof value && value.length) {
      value = (fn || qs.parse)(value);
    }

    url[part] = value;
  } else if ('port' === part) {
    url[part] = value;

    if (!required(value, url.protocol)) {
      url.host = url.hostname;
      url[part] = '';
    } else if (value) {
      url.host = url.hostname +':'+ value;
    }
  } else if ('hostname' === part) {
    url[part] = value;

    if (url.port) value += ':'+ url.port;
    url.host = value;
  } else if ('host' === part) {
    url[part] = value;

    if (/\:\d+/.test(value)) {
      value = value.split(':');
      url.hostname = value[0];
      url.port = value[1];
    }
  } else if ('protocol' === part) {
    url.protocol = value;
    url.slashes = !fn;
  } else {
    url[part] = value;
  }

  url.href = url.toString();
  return url;
};

/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String}
 * @api public
 */
URL.prototype.toString = function toString(stringify) {
  if (!stringify || 'function' !== typeof stringify) stringify = qs.stringify;

  var query
    , url = this
    , protocol = url.protocol;

  if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';

  var result = protocol + (url.slashes ? '//' : '');

  if (url.username) {
    result += url.username;
    if (url.password) result += ':'+ url.password;
    result += '@';
  }

  result += url.hostname;
  if (url.port) result += ':'+ url.port;

  result += url.pathname;

  query = 'object' === typeof url.query ? stringify(url.query) : url.query;
  if (query) result += '?' !== query.charAt(0) ? '?'+ query : query;

  if (url.hash) result += url.hash;

  return result;
};

//
// Expose the URL parser and some additional properties that might be useful for
// others.
//
URL.qs = qs;
URL.location = lolcation;
module.exports = URL;

},{"./lolcation":12,"querystringify":6,"requires-port":9}],12:[function(_dereq_,module,exports){
(function (global){
'use strict';

var slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//;

/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */
var ignore = { hash: 1, query: 1 }
  , URL;

/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @api public
 */
module.exports = function lolcation(loc) {
  loc = loc || global.location || {};
  URL = URL || _dereq_('./');

  var finaldestination = {}
    , type = typeof loc
    , key;

  if ('blob:' === loc.protocol) {
    finaldestination = new URL(unescape(loc.pathname), {});
  } else if ('string' === type) {
    finaldestination = new URL(loc, {});
    for (key in ignore) delete finaldestination[key];
  } else if ('object' === type) {
    for (key in loc) {
      if (key in ignore) continue;
      finaldestination[key] = loc[key];
    }

    if (finaldestination.slashes === undefined) {
      finaldestination.slashes = slashes.test(loc.href);
    }
  }

  return finaldestination;
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./":11}],13:[function(_dereq_,module,exports){
'use strict';

var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
  , length = 64
  , map = {}
  , seed = 0
  , i = 0
  , prev;

/**
 * Return a string representing the specified number.
 *
 * @param {Number} num The number to convert.
 * @returns {String} The string representation of the number.
 * @api public
 */
function encode(num) {
  var encoded = '';

  do {
    encoded = alphabet[num % length] + encoded;
    num = Math.floor(num / length);
  } while (num > 0);

  return encoded;
}

/**
 * Return the integer value specified by the given string.
 *
 * @param {String} str The string to convert.
 * @returns {Number} The integer value represented by the string.
 * @api public
 */
function decode(str) {
  var decoded = 0;

  for (i = 0; i < str.length; i++) {
    decoded = decoded * length + map[str.charAt(i)];
  }

  return decoded;
}

/**
 * Yeast: A tiny growing id generator.
 *
 * @returns {String} A unique id.
 * @api public
 */
function yeast() {
  var now = encode(+new Date());

  if (now !== prev) return seed = 0, prev = now;
  return now +'.'+ encode(seed++);
}

//
// Map each character to its index.
//
for (; i < length; i++) map[alphabet[i]] = i;

//
// Expose the `yeast`, `encode` and `decode` functions.
//
yeast.encode = encode;
yeast.decode = decode;
module.exports = yeast;

},{}],14:[function(_dereq_,module,exports){
/*globals require, define */
'use strict';

var EventEmitter = _dereq_('eventemitter3')
  , TickTock = _dereq_('tick-tock')
  , Recovery = _dereq_('recovery')
  , qs = _dereq_('querystringify')
  , destroy = _dereq_('demolish')
  , yeast = _dereq_('yeast')
  , u2028 = /\u2028/g
  , u2029 = /\u2029/g;

/**
 * Context assertion, ensure that some of our public Primus methods are called
 * with the correct context to ensure that
 *
 * @param {Primus} self The context of the function.
 * @param {String} method The method name.
 * @api private
 */
function context(self, method) {
  if (self instanceof Primus) return;

  var failure = new Error('Primus#'+ method + '\'s context should called with a Primus instance');

  if ('function' !== typeof self.listeners || !self.listeners('error').length) {
    throw failure;
  }

  self.emit('error', failure);
}

//
// Sets the default connection URL, it uses the default origin of the browser
// when supported but degrades for older browsers. In Node.js, we cannot guess
// where the user wants to connect to, so we just default to localhost.
//
var defaultUrl;

try {
  if (location.origin) {
    defaultUrl = location.origin;
  } else {
    defaultUrl = location.protocol +'//'+ location.host;
  }
} catch (e) {
  defaultUrl = 'http://127.0.0.1';
}

/**
 * Primus is a real-time library agnostic framework for establishing real-time
 * connections with servers.
 *
 * Options:
 * - reconnect, configuration for the reconnect process.
 * - manual, don't automatically call `.open` to start the connection.
 * - websockets, force the use of WebSockets, even when you should avoid them.
 * - timeout, connect timeout, server didn't respond in a timely manner.
 * - ping, The heartbeat interval for sending a ping packet to the server.
 * - pong, The heartbeat timeout for receiving a response to the ping.
 * - network, Use network events as leading method for network connection drops.
 * - strategy, Reconnection strategies.
 * - transport, Transport options.
 * - url, uri, The URL to use connect with the server.
 *
 * @constructor
 * @param {String} url The URL of your server.
 * @param {Object} options The configuration.
 * @api public
 */
function Primus(url, options) {
  if (!(this instanceof Primus)) return new Primus(url, options);
  if ('function' !== typeof this.client) {
    var message = 'The client library has not been compiled correctly, ' +
      'see https://github.com/primus/primus#client-library for more details';
    return this.critical(new Error(message));
  }

  if ('object' === typeof url) {
    options = url;
    url = options.url || options.uri || defaultUrl;
  } else {
    options = options || {};
  }

  var primus = this;

  // The maximum number of messages that can be placed in queue.
  options.queueSize = 'queueSize' in options ? options.queueSize : Infinity;

  // Connection timeout duration.
  options.timeout = 'timeout' in options ? options.timeout : 10e3;

  // Stores the back off configuration.
  options.reconnect = 'reconnect' in options ? options.reconnect : {};

  // Heartbeat ping interval.
  options.ping = 'ping' in options ? options.ping : 25000;

  // Heartbeat pong response timeout.
  options.pong = 'pong' in options ? options.pong : 10e3;

  // Reconnect strategies.
  options.strategy = 'strategy' in options ? options.strategy : [];

  // Custom transport options.
  options.transport = 'transport' in options ? options.transport : {};

  primus.buffer = [];                           // Stores premature send data.
  primus.writable = true;                       // Silly stream compatibility.
  primus.readable = true;                       // Silly stream compatibility.
  primus.url = primus.parse(url || defaultUrl); // Parse the URL to a readable format.
  primus.readyState = Primus.CLOSED;            // The readyState of the connection.
  primus.options = options;                     // Reference to the supplied options.
  primus.timers = new TickTock(this);           // Contains all our timers.
  primus.socket = null;                         // Reference to the internal connection.
  primus.latency = 0;                           // Latency between messages.
  primus.disconnect = false;                    // Did we receive a disconnect packet?
  primus.transport = options.transport;         // Transport options.
  primus.transformers = {                       // Message transformers.
    outgoing: [],
    incoming: []
  };

  //
  // Create our reconnection instance.
  //
  primus.recovery = new Recovery(options.reconnect);

  //
  // Parse the reconnection strategy. It can have the following strategies:
  //
  // - timeout: Reconnect when we have a network timeout.
  // - disconnect: Reconnect when we have an unexpected disconnect.
  // - online: Reconnect when we're back online.
  //
  if ('string' === typeof options.strategy) {
    options.strategy = options.strategy.split(/\s?\,\s?/g);
  }

  if (false === options.strategy) {
    //
    // Strategies are disabled, but we still need an empty array to join it in
    // to nothing.
    //
    options.strategy = [];
  } else if (!options.strategy.length) {
    options.strategy.push('disconnect', 'online');

    //
    // Timeout based reconnection should only be enabled conditionally. When
    // authorization is enabled it could trigger.
    //
    if (!this.authorization) options.strategy.push('timeout');
  }

  options.strategy = options.strategy.join(',').toLowerCase();

  //
  // Force the use of WebSockets, even when we've detected some potential
  // broken WebSocket implementation.
  //
  if ('websockets' in options) {
    primus.AVOID_WEBSOCKETS = !options.websockets;
  }

  //
  // Force or disable the use of NETWORK events as leading client side
  // disconnection detection.
  //
  if ('network' in options) {
    primus.NETWORK_EVENTS = options.network;
  }

  //
  // Check if the user wants to manually initialise a connection. If they don't,
  // we want to do it after a really small timeout so we give the users enough
  // time to listen for `error` events etc.
  //
  if (!options.manual) primus.timers.setTimeout('open', function open() {
    primus.timers.clear('open');
    primus.open();
  }, 0);

  primus.initialise(options);
}

/**
 * Simple require wrapper to make browserify, node and require.js play nice.
 *
 * @param {String} name The module to require.
 * @returns {Object|Undefined} The module that we required.
 * @api private
 */
Primus.requires = Primus.require = function requires(name) {
  if ('function' !== typeof _dereq_) return undefined;

  return !('function' === typeof define && define.amd)
    ? _dereq_(name)
    : undefined;
};

//
// It's possible that we're running in Node.js or in a Node.js compatible
// environment. In this cases we inherit from the Stream base class.
//
var Stream;

try {
  Primus.Stream = Stream = Primus.requires('stream');

  //
  // Normally inheritance is done in the same way as we do in our catch
  // statement. But due to changes to the EventEmitter interface in Node 0.10
  // this will trigger annoying memory leak warnings and other potential issues
  // outlined in the issue linked below.
  //
  // @see https://github.com/joyent/node/issues/4971
  //
  Primus.requires('util').inherits(Primus, Stream);
} catch (e) {
  Primus.Stream = EventEmitter;
  Primus.prototype = new EventEmitter();
}

/**
 * Primus readyStates, used internally to set the correct ready state.
 *
 * @type {Number}
 * @private
 */
Primus.OPENING = 1;   // We're opening the connection.
Primus.CLOSED  = 2;   // No active connection.
Primus.OPEN    = 3;   // The connection is open.

/**
 * Are we working with a potentially broken WebSockets implementation? This
 * boolean can be used by transformers to remove `WebSockets` from their
 * supported transports.
 *
 * @type {Boolean}
 * @private
 */
Primus.prototype.AVOID_WEBSOCKETS = false;

/**
 * Some browsers support registering emitting `online` and `offline` events when
 * the connection has been dropped on the client. We're going to detect it in
 * a simple `try {} catch (e) {}` statement so we don't have to do complicated
 * feature detection.
 *
 * @type {Boolean}
 * @private
 */
Primus.prototype.NETWORK_EVENTS = false;
Primus.prototype.online = true;

try {
  if (
       Primus.prototype.NETWORK_EVENTS = 'onLine' in navigator
    && (window.addEventListener || document.body.attachEvent)
  ) {
    if (!navigator.onLine) {
      Primus.prototype.online = false;
    }
  }
} catch (e) { }

/**
 * The Ark contains all our plugins definitions. It's namespaced by
 * name => plugin.
 *
 * @type {Object}
 * @private
 */
Primus.prototype.ark = {};

/**
 * Simple emit wrapper that returns a function that emits an event once it's
 * called. This makes it easier for transports to emit specific events.
 *
 * @returns {Function} A function that will emit the event when called.
 * @api public
 */
Primus.prototype.emits = _dereq_('emits');

/**
 * Return the given plugin.
 *
 * @param {String} name The name of the plugin.
 * @returns {Object|undefined} The plugin or undefined.
 * @api public
 */
Primus.prototype.plugin = function plugin(name) {
  context(this, 'plugin');

  if (name) return this.ark[name];

  var plugins = {};

  for (name in this.ark) {
    plugins[name] = this.ark[name];
  }

  return plugins;
};

/**
 * Checks if the given event is an emitted event by Primus.
 *
 * @param {String} evt The event name.
 * @returns {Boolean} Indication of the event is reserved for internal use.
 * @api public
 */
Primus.prototype.reserved = function reserved(evt) {
  return (/^(incoming|outgoing)::/).test(evt)
  || evt in this.reserved.events;
};

/**
 * The actual events that are used by the client.
 *
 * @type {Object}
 * @public
 */
Primus.prototype.reserved.events = {
  'reconnect scheduled': 1,
  'reconnect timeout': 1,
  'readyStateChange': 1,
  'reconnect failed': 1,
  'reconnected': 1,
  'reconnect': 1,
  'offline': 1,
  'timeout': 1,
  'online': 1,
  'error': 1,
  'close': 1,
  'open': 1,
  'data': 1,
  'end': 1
};

/**
 * Initialise the Primus and setup all parsers and internal listeners.
 *
 * @param {Object} options The original options object.
 * @returns {Primus}
 * @api private
 */
Primus.prototype.initialise = function initialise(options) {
  var primus = this
    , start;

  primus.recovery
  .on('reconnected', primus.emits('reconnected'))
  .on('reconnect failed', primus.emits('reconnect failed', function failed(next) {
    primus.emit('end');
    next();
  }))
  .on('reconnect timeout', primus.emits('reconnect timeout'))
  .on('reconnect scheduled', primus.emits('reconnect scheduled'))
  .on('reconnect', primus.emits('reconnect', function reconnect(next) {
    primus.emit('outgoing::reconnect');
    next();
  }));

  primus.on('outgoing::open', function opening() {
    var readyState = primus.readyState;

    primus.readyState = Primus.OPENING;
    if (readyState !== primus.readyState) {
      primus.emit('readyStateChange', 'opening');
    }

    start = +new Date();
  });

  primus.on('incoming::open', function opened() {
    var readyState = primus.readyState;

    if (primus.recovery.reconnecting()) {
      primus.recovery.reconnected();
    }

    //
    // The connection has been opened so we should set our state to
    // (writ|read)able so our stream compatibility works as intended.
    //
    primus.writable = true;
    primus.readable = true;

    //
    // Make sure we are flagged as `online` as we've successfully opened the
    // connection.
    //
    if (!primus.online) {
      primus.online = true;
      primus.emit('online');
    }

    primus.readyState = Primus.OPEN;
    if (readyState !== primus.readyState) {
      primus.emit('readyStateChange', 'open');
    }

    primus.latency = +new Date() - start;
    primus.timers.clear('ping', 'pong');
    primus.heartbeat();

    if (primus.buffer.length) {
      var data = primus.buffer.slice()
        , length = data.length
        , i = 0;

      primus.buffer.length = 0;

      for (; i < length; i++) {
        primus._write(data[i]);
      }
    }

    primus.emit('open');
  });

  primus.on('incoming::pong', function pong(time) {
    primus.online = true;
    primus.timers.clear('pong');
    primus.heartbeat();

    primus.latency = (+new Date()) - time;
  });

  primus.on('incoming::error', function error(e) {
    var connect = primus.timers.active('connect')
      , err = e;

    //
    // When the error is not an Error instance we try to normalize it.
    //
    if ('string' === typeof e) {
      err = new Error(e);
    } else if (!(e instanceof Error) && 'object' === typeof e) {
      //
      // BrowserChannel and SockJS returns an object which contains some
      // details of the error. In order to have a proper error we "copy" the
      // details in an Error instance.
      //
      err = new Error(e.message || e.reason);
      for (var key in e) {
        if (Object.prototype.hasOwnProperty.call(e, key))
          err[key] = e[key];
      }
    }
    //
    // We're still doing a reconnect attempt, it could be that we failed to
    // connect because the server was down. Failing connect attempts should
    // always emit an `error` event instead of a `open` event.
    //
    //
    if (primus.recovery.reconnecting()) return primus.recovery.reconnected(err);
    if (primus.listeners('error').length) primus.emit('error', err);

    //
    // We received an error while connecting, this most likely the result of an
    // unauthorized access to the server.
    //
    if (connect) {
      if (~primus.options.strategy.indexOf('timeout')) {
        primus.recovery.reconnect();
      } else {
        primus.end();
      }
    }
  });

  primus.on('incoming::data', function message(raw) {
    primus.decoder(raw, function decoding(err, data) {
      //
      // Do a "safe" emit('error') when we fail to parse a message. We don't
      // want to throw here as listening to errors should be optional.
      //
      if (err) return primus.listeners('error').length && primus.emit('error', err);

      //
      // Handle all "primus::" prefixed protocol messages.
      //
      if (primus.protocol(data)) return;
      primus.transforms(primus, primus, 'incoming', data, raw);
    });
  });

  primus.on('incoming::end', function end() {
    var readyState = primus.readyState;

    //
    // This `end` started with the receiving of a primus::server::close packet
    // which indicated that the user/developer on the server closed the
    // connection and it was not a result of a network disruption. So we should
    // kill the connection without doing a reconnect.
    //
    if (primus.disconnect) {
      primus.disconnect = false;

      return primus.end();
    }

    //
    // Always set the readyState to closed, and if we're still connecting, close
    // the connection so we're sure that everything after this if statement block
    // is only executed because our readyState is set to `open`.
    //
    primus.readyState = Primus.CLOSED;
    if (readyState !== primus.readyState) {
      primus.emit('readyStateChange', 'end');
    }

    if (primus.timers.active('connect')) primus.end();
    if (readyState !== Primus.OPEN) {
      return primus.recovery.reconnecting()
        ? primus.recovery.reconnect()
        : false;
    }

    this.writable = false;
    this.readable = false;

    //
    // Clear all timers in case we're not going to reconnect.
    //
    this.timers.clear();

    //
    // Fire the `close` event as an indication of connection disruption.
    // This is also fired by `primus#end` so it is emitted in all cases.
    //
    primus.emit('close');

    //
    // The disconnect was unintentional, probably because the server has
    // shutdown, so if the reconnection is enabled start a reconnect procedure.
    //
    if (~primus.options.strategy.indexOf('disconnect')) {
      return primus.recovery.reconnect();
    }

    primus.emit('outgoing::end');
    primus.emit('end');
  });

  //
  // Setup the real-time client.
  //
  primus.client();

  //
  // Process the potential plugins.
  //
  for (var plugin in primus.ark) {
    primus.ark[plugin].call(primus, primus, options);
  }

  //
  // NOTE: The following code is only required if we're supporting network
  // events as it requires access to browser globals.
  //
  if (!primus.NETWORK_EVENTS) return primus;

  /**
   * Handler for offline notifications.
   *
   * @api private
   */
  primus.offlineHandler = function offline() {
    if (!primus.online) return; // Already or still offline, bailout.

    primus.online = false;
    primus.emit('offline');
    primus.end();

    //
    // It is certainly possible that we're in a reconnection loop and that the
    // user goes offline. In this case we want to kill the existing attempt so
    // when the user goes online, it will attempt to reconnect freshly again.
    //
    primus.recovery.reset();
  };

  /**
   * Handler for online notifications.
   *
   * @api private
   */
  primus.onlineHandler = function online() {
    if (primus.online) return; // Already or still online, bailout.

    primus.online = true;
    primus.emit('online');

    if (~primus.options.strategy.indexOf('online')) {
      primus.recovery.reconnect();
    }
  };

  if (window.addEventListener) {
    window.addEventListener('offline', primus.offlineHandler, false);
    window.addEventListener('online', primus.onlineHandler, false);
  } else if (document.body.attachEvent){
    document.body.attachEvent('onoffline', primus.offlineHandler);
    document.body.attachEvent('ononline', primus.onlineHandler);
  }

  return primus;
};

/**
 * Really dead simple protocol parser. We simply assume that every message that
 * is prefixed with `primus::` could be used as some sort of protocol definition
 * for Primus.
 *
 * @param {String} msg The data.
 * @returns {Boolean} Is a protocol message.
 * @api private
 */
Primus.prototype.protocol = function protocol(msg) {
  if (
       'string' !== typeof msg
    || msg.indexOf('primus::') !== 0
  ) return false;

  var last = msg.indexOf(':', 8)
    , value = msg.slice(last + 2);

  switch (msg.slice(8,  last)) {
    case 'pong':
      this.emit('incoming::pong', +value);
    break;

    case 'server':
      //
      // The server is closing the connection, forcefully disconnect so we don't
      // reconnect again.
      //
      if ('close' === value) {
        this.disconnect = true;
      }
    break;

    case 'id':
      this.emit('incoming::id', value);
    break;

    //
    // Unknown protocol, somebody is probably sending `primus::` prefixed
    // messages.
    //
    default:
      return false;
  }

  return true;
};

/**
 * Execute the set of message transformers from Primus on the incoming or
 * outgoing message.
 * This function and it's content should be in sync with Spark#transforms in
 * spark.js.
 *
 * @param {Primus} primus Reference to the Primus instance with message transformers.
 * @param {Spark|Primus} connection Connection that receives or sends data.
 * @param {String} type The type of message, 'incoming' or 'outgoing'.
 * @param {Mixed} data The data to send or that has been received.
 * @param {String} raw The raw encoded data.
 * @returns {Primus}
 * @api public
 */
Primus.prototype.transforms = function transforms(primus, connection, type, data, raw) {
  var packet = { data: data }
    , fns = primus.transformers[type];

  //
  // Iterate in series over the message transformers so we can allow optional
  // asynchronous execution of message transformers which could for example
  // retrieve additional data from the server, do extra decoding or even
  // message validation.
  //
  (function transform(index, done) {
    var transformer = fns[index++];

    if (!transformer) return done();

    if (1 === transformer.length) {
      if (false === transformer.call(connection, packet)) {
        //
        // When false is returned by an incoming transformer it means that's
        // being handled by the transformer and we should not emit the `data`
        // event.
        //
        return;
      }

      return transform(index, done);
    }

    transformer.call(connection, packet, function finished(err, arg) {
      if (err) return connection.emit('error', err);
      if (false === arg) return;

      transform(index, done);
    });
  }(0, function done() {
    //
    // We always emit 2 arguments for the data event, the first argument is the
    // parsed data and the second argument is the raw string that we received.
    // This allows you, for example, to do some validation on the parsed data
    // and then save the raw string in your database without the stringify
    // overhead.
    //
    if ('incoming' === type) return connection.emit('data', packet.data, raw);

    connection._write(packet.data);
  }));

  return this;
};

/**
 * Retrieve the current id from the server.
 *
 * @param {Function} fn Callback function.
 * @returns {Primus}
 * @api public
 */
Primus.prototype.id = function id(fn) {
  if (this.socket && this.socket.id) return fn(this.socket.id);

  this._write('primus::id::');
  return this.once('incoming::id', fn);
};

/**
 * Establish a connection with the server. When this function is called we
 * assume that we don't have any open connections. If you do call it when you
 * have a connection open, it could cause duplicate connections.
 *
 * @returns {Primus}
 * @api public
 */
Primus.prototype.open = function open() {
  context(this, 'open');

  //
  // Only start a `connection timeout` procedure if we're not reconnecting as
  // that shouldn't count as an initial connection. This should be started
  // before the connection is opened to capture failing connections and kill the
  // timeout.
  //
  if (!this.recovery.reconnecting() && this.options.timeout) this.timeout();

  this.emit('outgoing::open');
  return this;
};

/**
 * Send a new message.
 *
 * @param {Mixed} data The data that needs to be written.
 * @returns {Boolean} Always returns true as we don't support back pressure.
 * @api public
 */
Primus.prototype.write = function write(data) {
  context(this, 'write');
  this.transforms(this, this, 'outgoing', data);

  return true;
};

/**
 * The actual message writer.
 *
 * @param {Mixed} data The message that needs to be written.
 * @returns {Boolean} Successful write to the underlaying transport.
 * @api private
 */
Primus.prototype._write = function write(data) {
  var primus = this;

  //
  // The connection is closed, normally this would already be done in the
  // `spark.write` method, but as `_write` is used internally, we should also
  // add the same check here to prevent potential crashes by writing to a dead
  // socket.
  //
  if (Primus.OPEN !== primus.readyState) {
    //
    // If the buffer is at capacity, remove the first item.
    //
    if (this.buffer.length === this.options.queueSize) {
      this.buffer.splice(0, 1);
    }

    this.buffer.push(data);
    return false;
  }

  primus.encoder(data, function encoded(err, packet) {
    //
    // Do a "safe" emit('error') when we fail to parse a message. We don't
    // want to throw here as listening to errors should be optional.
    //
    if (err) return primus.listeners('error').length && primus.emit('error', err);

    //
    // Hack 1: \u2028 and \u2029 are allowed inside a JSON string, but JavaScript
    // defines them as newline separators. Unescaped control characters are not
    // allowed inside JSON strings, so this causes an error at parse time. We
    // work around this issue by escaping these characters. This can cause
    // errors with JSONP requests or if the string is just evaluated.
    //
    if ('string' === typeof packet) {
      if (~packet.indexOf('\u2028')) packet = packet.replace(u2028, '\\u2028');
      if (~packet.indexOf('\u2029')) packet = packet.replace(u2029, '\\u2029');
    }

    primus.emit('outgoing::data', packet);
  });

  return true;
};

/**
 * Send a new heartbeat over the connection to ensure that we're still
 * connected and our internet connection didn't drop. We cannot use server side
 * heartbeats for this unfortunately.
 *
 * @returns {Primus}
 * @api private
 */
Primus.prototype.heartbeat = function heartbeat() {
  var primus = this;

  if (!primus.options.ping) return primus;

  /**
   * Exterminate the connection as we've timed out.
   *
   * @api private
   */
  function pong() {
    primus.timers.clear('pong');

    //
    // The network events already captured the offline event.
    //
    if (!primus.online) return;

    primus.online = false;
    primus.emit('offline');
    primus.emit('incoming::end');
  }

  /**
   * We should send a ping message to the server.
   *
   * @api private
   */
  function ping() {
    var value = +new Date();

    primus.timers.clear('ping');
    primus._write('primus::ping::'+ value);
    primus.emit('outgoing::ping', value);
    primus.timers.setTimeout('pong', pong, primus.options.pong);
  }

  primus.timers.setTimeout('ping', ping, primus.options.ping);
  return this;
};

/**
 * Start a connection timeout.
 *
 * @returns {Primus}
 * @api private
 */
Primus.prototype.timeout = function timeout() {
  var primus = this;

  /**
   * Remove all references to the timeout listener as we've received an event
   * that can be used to determine state.
   *
   * @api private
   */
  function remove() {
    primus.removeListener('error', remove)
          .removeListener('open', remove)
          .removeListener('end', remove)
          .timers.clear('connect');
  }

  primus.timers.setTimeout('connect', function expired() {
    remove(); // Clean up old references.

    if (primus.readyState === Primus.OPEN || primus.recovery.reconnecting()) {
      return;
    }

    primus.emit('timeout');

    //
    // We failed to connect to the server.
    //
    if (~primus.options.strategy.indexOf('timeout')) {
      primus.recovery.reconnect();
    } else {
      primus.end();
    }
  }, primus.options.timeout);

  return primus.on('error', remove)
    .on('open', remove)
    .on('end', remove);
};

/**
 * Close the connection completely.
 *
 * @param {Mixed} data last packet of data.
 * @returns {Primus}
 * @api public
 */
Primus.prototype.end = function end(data) {
  context(this, 'end');

  if (
      this.readyState === Primus.CLOSED
    && !this.timers.active('connect')
    && !this.timers.active('open')
  ) {
    //
    // If we are reconnecting stop the reconnection procedure.
    //
    if (this.recovery.reconnecting()) {
      this.recovery.reset();
      this.emit('end');
    }

    return this;
  }

  if (data !== undefined) this.write(data);

  this.writable = false;
  this.readable = false;

  var readyState = this.readyState;
  this.readyState = Primus.CLOSED;

  if (readyState !== this.readyState) {
    this.emit('readyStateChange', 'end');
  }

  this.timers.clear();
  this.emit('outgoing::end');
  this.emit('close');
  this.emit('end');

  return this;
};

/**
 * Completely demolish the Primus instance and forcefully nuke all references.
 *
 * @returns {Boolean}
 * @api public
 */
Primus.prototype.destroy = destroy('url timers options recovery socket transport transformers', {
  before: 'end',
  after: ['removeAllListeners', function detach() {
    if (!this.NETWORK_EVENTS) return;

    if (window.addEventListener) {
      window.removeEventListener('offline', this.offlineHandler);
      window.removeEventListener('online', this.onlineHandler);
    } else if (document.body.attachEvent){
      document.body.detachEvent('onoffline', this.offlineHandler);
      document.body.detachEvent('ononline', this.onlineHandler);
    }
  }]
});

/**
 * Create a shallow clone of a given object.
 *
 * @param {Object} obj The object that needs to be cloned.
 * @returns {Object} Copy.
 * @api private
 */
Primus.prototype.clone = function clone(obj) {
  return this.merge({}, obj);
};

/**
 * Merge different objects in to one target object.
 *
 * @param {Object} target The object where everything should be merged in.
 * @returns {Object} Original target with all merged objects.
 * @api private
 */
Primus.prototype.merge = function merge(target) {
  for (var i = 1, key, obj; i < arguments.length; i++) {
    obj = arguments[i];

    for (key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key))
        target[key] = obj[key];
    }
  }

  return target;
};

/**
 * Parse the connection string.
 *
 * @type {Function}
 * @param {String} url Connection URL.
 * @returns {Object} Parsed connection.
 * @api private
 */
Primus.prototype.parse = _dereq_('url-parse');

/**
 * Parse a query string.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object} Parsed query string.
 * @api private
 */
Primus.prototype.querystring = qs.parse;
/**
 * Transform a query string object back into string equiv.
 *
 * @param {Object} obj The query string object.
 * @returns {String}
 * @api private
 */
Primus.prototype.querystringify = qs.stringify;

/**
 * Generates a connection URI.
 *
 * @param {String} protocol The protocol that should used to crate the URI.
 * @returns {String|options} The URL.
 * @api private
 */
Primus.prototype.uri = function uri(options) {
  var url = this.url
    , server = []
    , qsa = false;

  //
  // Query strings are only allowed when we've received clearance for it.
  //
  if (options.query) qsa = true;

  options = options || {};
  options.protocol = 'protocol' in options
    ? options.protocol
    : 'http:';
  options.query = url.query && qsa
    ? url.query.slice(1)
    : false;
  options.secure = 'secure' in options
    ? options.secure
    : url.protocol === 'https:' || url.protocol === 'wss:';
  options.auth = 'auth' in options
    ? options.auth
    : url.auth;
  options.pathname = 'pathname' in options
    ? options.pathname
    : this.pathname;
  options.port = 'port' in options
    ? +options.port
    : +url.port || (options.secure ? 443 : 80);

  //
  // Allow transformation of the options before we construct a full URL from it.
  //
  this.emit('outgoing::url', options);

  //
  // We need to make sure that we create a unique connection URL every time to
  // prevent back forward cache from becoming an issue. We're doing this by
  // forcing an cache busting query string in to the URL.
  //
  var querystring = this.querystring(options.query || '');
  querystring._primuscb = yeast();
  options.query = this.querystringify(querystring);

  //
  // Automatically suffix the protocol so we can supply `ws:` and `http:` and
  // it gets transformed correctly.
  //
  server.push(options.secure ? options.protocol.replace(':', 's:') : options.protocol, '');

  server.push(options.auth ? options.auth +'@'+ url.host : url.host);

  //
  // Pathnames are optional as some Transformers would just use the pathname
  // directly.
  //
  if (options.pathname) server.push(options.pathname.slice(1));

  //
  // Optionally add a search query.
  //
  if (qsa) server[server.length - 1] += '?'+ options.query;
  else delete options.query;

  if (options.object) return options;
  return server.join('/');
};

/**
 * Register a new message transformer. This allows you to easily manipulate incoming
 * and outgoing data which is particularity handy for plugins that want to send
 * meta data together with the messages.
 *
 * @param {String} type Incoming or outgoing
 * @param {Function} fn A new message transformer.
 * @returns {Primus}
 * @api public
 */
Primus.prototype.transform = function transform(type, fn) {
  context(this, 'transform');

  if (!(type in this.transformers)) {
    return this.critical(new Error('Invalid transformer type'));
  }

  this.transformers[type].push(fn);
  return this;
};

/**
 * A critical error has occurred, if we have an `error` listener, emit it there.
 * If not, throw it, so we get a stack trace + proper error message.
 *
 * @param {Error} err The critical error.
 * @returns {Primus}
 * @api private
 */
Primus.prototype.critical = function critical(err) {
  if (this.listeners('error').length) {
    this.emit('error', err);
    return this;
  }

  throw err;
};

/**
 * Syntax sugar, adopt a Socket.IO like API.
 *
 * @param {String} url The URL we want to connect to.
 * @param {Object} options Connection options.
 * @returns {Primus}
 * @api public
 */
Primus.connect = function connect(url, options) {
  return new Primus(url, options);
};

//
// Expose the EventEmitter so it can be re-used by wrapping libraries we're also
// exposing the Stream interface.
//
Primus.EventEmitter = EventEmitter;

//
// These libraries are automatically inserted at the server-side using the
// Primus#library method.
//
Primus.prototype.client = function client() {
  var primus = this
    , socket;

  //
  // Select an available WebSocket factory.
  //
  var Factory = (function factory() {
    if ('undefined' !== typeof WebSocket) return WebSocket;
    if ('undefined' !== typeof MozWebSocket) return MozWebSocket;

    try { return Primus.requires('ws'); }
    catch (e) {}

    return undefined;
  })();

  if (!Factory) return primus.critical(new Error(
    'Missing required `ws` module. Please run `npm install --save ws`'
  ));

  //
  // Connect to the given URL.
  //
  primus.on('outgoing::open', function opening() {
    primus.emit('outgoing::end');

    //
    // FireFox will throw an error when we try to establish a connection from
    // a secure page to an unsecured WebSocket connection. This is inconsistent
    // behaviour between different browsers. This should ideally be solved in
    // Primus when we connect.
    //
    try {
      var prot = primus.url.protocol === 'ws+unix:' ? 'ws+unix:' : 'ws:'
        , qsa = prot === 'ws:';

      //
      // Only allow primus.transport object in Node.js, it will throw in
      // browsers with a TypeError if we supply to much arguments.
      //
      if (Factory.length === 3) {
        primus.socket = socket = new Factory(
          primus.uri({ protocol: prot, query: qsa }),   // URL
          [],                                           // Sub protocols
          primus.transport                              // options.
        );
      } else {
        primus.socket = socket = new Factory(primus.uri({
          protocol: prot,
          query: qsa
        }));

        socket.binaryType = 'arraybuffer';
      }
    } catch (e) { return primus.emit('error', e); }

    //
    // Setup the Event handlers.
    //
    socket.onopen = primus.emits('incoming::open');
    socket.onerror = primus.emits('incoming::error');
    socket.onclose = primus.emits('incoming::end');
    socket.onmessage = primus.emits('incoming::data', function parse(next, evt) {
      next(undefined, evt.data);
    });
  });

  //
  // We need to write a new message to the socket.
  //
  primus.on('outgoing::data', function write(message) {
    if (!socket || socket.readyState !== Factory.OPEN) return;

    try { socket.send(message); }
    catch (e) { primus.emit('incoming::error', e); }
  });

  //
  // Attempt to reconnect the socket.
  //
  primus.on('outgoing::reconnect', function reconnect() {
    primus.emit('outgoing::open');
  });

  //
  // We need to close the socket.
  //
  primus.on('outgoing::end', function close() {
    if (!socket) return;

    socket.onerror = socket.onopen = socket.onclose = socket.onmessage = function () {};
    socket.close();
    socket = null;
  });
};
Primus.prototype.authorization = false;
Primus.prototype.pathname = "/primus";
Primus.prototype.encoder = function encoder(data, fn) {
  var err;

  try { data = JSON.stringify(data); }
  catch (e) { err = e; }

  fn(err, data);
};
Primus.prototype.decoder = function decoder(data, fn) {
  var err;

  if ('string' !== typeof data) return fn(err, data);

  try { data = JSON.parse(data); }
  catch (e) { err = e; }

  fn(err, data);
};
Primus.prototype.version = "5.2.2";

if (
     'undefined' !== typeof document
  && 'undefined' !== typeof navigator
) {
  //
  // Hack 2: If you press ESC in FireFox it will close all active connections.
  // Normally this makes sense, when your page is still loading. But versions
  // before FireFox 22 will close all connections including WebSocket connections
  // after page load. One way to prevent this is to do a `preventDefault()` and
  // cancel the operation before it bubbles up to the browsers default handler.
  // It needs to be added as `keydown` event, if it's added keyup it will not be
  // able to prevent the connection from being closed.
  //
  if (document.addEventListener) {
    document.addEventListener('keydown', function keydown(e) {
      if (e.keyCode !== 27 || !e.preventDefault) return;

      e.preventDefault();
    }, false);
  }

  //
  // Hack 3: This is a Mac/Apple bug only, when you're behind a reverse proxy or
  // have you network settings set to `automatic proxy discovery` the safari
  // browser will crash when the WebSocket constructor is initialised. There is
  // no way to detect the usage of these proxies available in JavaScript so we
  // need to do some nasty browser sniffing. This only affects Safari versions
  // lower then 5.1.4
  //
  var ua = (navigator.userAgent || '').toLowerCase()
    , parsed = ua.match(/.+(?:rv|it|ra|ie)[\/: ](\d+)\.(\d+)(?:\.(\d+))?/) || []
    , version = +[parsed[1], parsed[2]].join('.');

  if (
       !~ua.indexOf('chrome')
    && ~ua.indexOf('safari')
    && version < 534.54
  ) {
    Primus.prototype.AVOID_WEBSOCKETS = true;
  }
}

//
// Expose the library.
//
module.exports = Primus;

},{"demolish":1,"emits":2,"eventemitter3":3,"querystringify":6,"recovery":7,"tick-tock":10,"url-parse":11,"yeast":13}]},{},[14])(14);
Primus.prototype.ark["emitter"] = function () {};
  return Primus;
},
[
function (Primus) {
;(function (Primus, undefined) {
function spark(Spark, Emitter) {
  'use strict';

  /**
   * `Primus#initialise` reference.
   */

  var initialise = Spark.prototype.initialise;

  /**
   * Initialise the Primus and setup all
   * parsers and internal listeners.
   *
   * @api private
   */

  Spark.prototype.initialise = function init() {
    if (!this.emitter) this.emitter = new Emitter(this);
    if (!this.__initialise) initialise.apply(this, arguments);
  };

  // Extend the Spark to add the send method. If `Spark.readable`
  // is not supported then we set the method on the prototype instead.
  if (!Spark.readable) Spark.prototype.send = send;
  else if (!Spark.prototype.send) Spark.readable('send', send);

  /**
   * Emits to this Spark.
   *
   * @param {String} ev The event
   * @param {Mixed} [data] The data to broadcast
   * @param {Function} [fn] The callback function
   * @return {Primus|Spark} this
   * @api public
   */

  function send(ev, data, fn) {
    /* jshint validthis: true */
    // ignore newListener event to avoid this error in node 0.8
    // https://github.com/cayasso/primus-emitter/issues/3
    if (/^(newListener|removeListener)/.test(ev)) return this;
    this.emitter.send.apply(this.emitter, arguments);
    return this;
  }
}
function emitter() {
  'use strict';

  var toString = Object.prototype.toString
    , slice = Array.prototype.slice;

  /**
   * Check if the given `value` is an `Array`.
   *
   * @param {*} value The value to check
   * @return {Boolean}
   */

  var isArray = Array.isArray || function isArray(value) {
    return '[object Array]' === toString.call(value);
  };

  /**
   * Event packets.
   */

  var packets = {
    EVENT:  0,
    ACK:    1
  };

  /**
   * Initialize a new `Emitter`.
   *
   * @param {Primus|Spark} conn
   * @return {Emitter} `Emitter` instance
   * @api public
   */

  function Emitter(conn) {
    if (!(this instanceof Emitter)) return new Emitter(conn);
    this.ids = 1;
    this.acks = {};
    this.conn = conn;
    if (this.conn) this.bind();
  }

  /**
   * Bind `Emitter` events.
   *
   * @return {Emitter} self
   * @api private
   */

  Emitter.prototype.bind = function bind() {
    var em = this;
    this.conn.on('data', function ondata(packet) {
      em.ondata.call(em, packet);
    });
    return this;
  };

  /**
   * Called with incoming transport data.
   *
   * @param {Object} packet
   * @return {Emitter} self
   * @api private
   */

  Emitter.prototype.ondata = function ondata(packet) {
    if (!isArray(packet.data) || packet.id && 'number' !== typeof packet.id) {
      return this;
    }
    switch (packet.type) {
      case packets.EVENT:
        this.onevent(packet);
        break;
      case packets.ACK:
        this.onack(packet);
    }
    return this;
  };

  /**
   * Send a message to client.
   *
   * @return {Emitter} self
   * @api public
   */

  Emitter.prototype.send = function send() {
    var args = slice.call(arguments);
    this.conn.write(this.packet(args));
    return this;
  };

  /**
   * Prepare packet for emitting.
   *
   * @param {Array} arguments
   * @return {Object} packet
   * @api private
   */

  Emitter.prototype.packet = function pack(args) {
    var packet = { type: packets.EVENT, data: args };
    // access last argument to see if it's an ACK callback
    if ('function' === typeof args[args.length - 1]) {
      var id = this.ids++;
      this.acks[id] = args.pop();
      packet.id = id;
    }
    return packet;
  };

  /**
   * Called upon event packet.
   *
   * @param {Object} packet object
   * @return {Emitter} self
   * @api private
   */

  Emitter.prototype.onevent = function onevent(packet) {
    var args = packet.data;
    if (this.conn.reserved(args[0])) return this;
    if (packet.id) args.push(this.ack(packet.id));
    this.conn.emit.apply(this.conn, args);
    return this;
  };

  /**
   * Produces an ack callback to emit with an event.
   *
   * @param {Number} packet id
   * @return {Function}
   * @api private
   */

  Emitter.prototype.ack = function ack(id) {
    var conn = this.conn
      , sent = false;
    return function () {
      if (sent) return; // prevent double callbacks
      sent = true;
      conn.write({
        id: id,
        type: packets.ACK,
        data: slice.call(arguments)
      });
    };
  };

  /**
   * Called upon ack packet.
   *
   * @param {Object} packet object
   * @return {Emitter} self
   * @api private
   */

  Emitter.prototype.onack = function onack(packet) {
    var ack = this.acks[packet.id];
    if ('function' === typeof ack) {
      ack.apply(this, packet.data);
      delete this.acks[packet.id];
    }
    return this;
  };

  // Expose packets
  Emitter.packets = packets;

  return Emitter;
}
 if (undefined === Primus) return;
 Primus.$ = Primus.$ || {};
 Primus.$.emitter = {};
 Primus.$.emitter.spark = spark;
 Primus.$.emitter.emitter = emitter;
 spark(Primus, emitter());
})(Primus);
}
]);
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('components', []);

})();


(function () {
  'use strict';

  var module = angular.module('pages', [
    'pages.autobot'
  ]).config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider) {
    $urlRouterProvider.otherwise('/r');
  }


  module.directive('ngConfirm', function ($window) {
    return {
      link: function (scope, element, attr) {
        var msg = attr.ngConfirm || "Are you sure?";
        var confirmAction = attr.confirmOk;
        var cancelAction = attr.confirmCancel;

        if (!confirmAction && !cancelAction) {
          return;
        }

        element.bind('click',function (event) {
          if ($window.confirm(msg)) {
            scope.$apply(confirmAction);
          } else {
            scope.$apply(cancelAction);
          }
        });
      }
    };
  });

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      // 'chart.js',
      // 'angular-chartist',
      // 'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

'use strict';

(function () {

  var app = angular.module('MTLChild', [
    'ngAnimate',
    'ui.bootstrap',
    'ui.sortable',
    'ui.router',
    'ui.select',
    'ngTouch',
    'toastr',
    'smart-table',
    'datatables',
    'xeditable',
    'ui.slimscroll',
    'angular-progress-button-styles',
    'fancyboxplus',
    'ngStorage',
    'angular-jwt',
    'color.picker',
    'angularMoment',

    'busy',
    'sso',
    'auth',
    'feathers',
    'lambda',
    'sharedState',

    'BlurAdmin.theme',
    'components',
    'pages'
  ]).run(run);

  app.config(function(toastrConfig) {
    angular.extend(toastrConfig, {
      timeOut: 6000,
      autoDismiss: true,
      maxOpened: 1,
      // progressBar: true,
    });
  });

  app.config(function ($uibTooltipProvider) {
    $uibTooltipProvider.options({ appendToBody: true });
  });

  function run($rootScope, $log, toastr, $state, $window, $progressModal, $trace, $transitions) {
    $rootScope.$state = $state;

    $transitions.onStart({}, function (trans) {
      if (!$progressModal.isOpen()) {
        $progressModal.open();

        trans.promise.finally(function () {
          if ($progressModal.isOpen()) {
            $progressModal.close();
          }

          // $rootScope.$pageFinishedLoading = true;
        });
      }
    });

    $transitions.onError({}, function (t) {
      $log.error('error', t.error(), t.$from(), t.$to());
      // maybe show a modal error
    });

  }

})();

(function () {
  angular.module('auth', ['sso', 'feathers'])
    .factory('$auth', $auth);

  /** @ngInject */
  function $auth($sso, $feathers) {
    return {
      identity: function () {
        return $sso.getToken()
          .then($feathers.login)
          .then($sso.getUser)
          .catch($sso.logout);
      },

      isAuthenticated: function () {
        return $sso.isLoggedIn();
      },

      isAuthenticatedNow: function () {
        return $sso.isLoggedIn(true);
      }
    };
  }

})();

(function () {
  angular.module('busy', [])
    .factory('$busy', $busy);

  /** @ngInject */
  function $busy($uibModal, $timeout) {

    return {
      show: show,
      showWithTimeout: showWithTimeout
    };

    function show($p) {
      var modalInstance = $uibModal.open({
        animation: false,
        backdrop: 'static',
        size: 'sm',
        template: '<h4 style="padding: 20px 30px; text-align: center;">Please wait...</h4>'
      });

      if (!$p) {
        return modalInstance;
      }

      return $p.finally(modalInstance.close);
    }

    function showWithTimeout($p, timeout) {
      var busy = {
        handle: null,
        timeout: null,
        _show: function () {
          busy.handle = show($p);
          busy.timeout = $timeout(busy.dismiss, timeout);
          return busy.handle;
        },
        dismiss: function () {
          if (busy.timeout) {
            $timeout.cancel(busy.timeout);
            busy.timeout = null;
          }

          if (busy.handle) {
            busy.handle.close();
            busy.handle = null;
          }
        }
      };

      busy._show();
      return busy;
    }

  }

})();

(function () {
  angular.module('$cloudinary', [ 'cloudinary', 'ngFileUpload' ])
    .config(['cloudinaryProvider', function (cloudinaryProvider) {
      cloudinaryProvider
        .set('cloud_name', 'mtlchild')
        .set('upload_preset', 'autobot-property');
    }])
    .factory('cloudinaryInterceptor', function () {
      var filterDomain = '.cloudinary.com';
      var removeHeaders = [ 'Authorization', 'x-api-key' ];
      return {
        request: function (config) {
          if ((config.url || '').indexOf(filterDomain) !== -1) {
            _.each(removeHeaders, function (k) {
              delete config.headers[k];
            });
          }
          return config;
        }
      };
    })
    .config(['$httpProvider', function ($httpProvider) {
      $httpProvider.interceptors.push('cloudinaryInterceptor');
    }])
    .factory('$cloudinary', $cloudinary);


  var CLOUDINARY_URL = 'https://api.cloudinary.com/v1_1';

  /** @ngInject */
  function $cloudinary($http, $q, cloudinary, Upload) {
    var service = {
      getImages: function (propertyId) {
        var deferred = $q.defer();

        $http({
          method: 'GET',
          url: service._getURL(cloudinary.config().upload_preset),
        }).then(function success(res) {
          deferred.resolve(_.get(res, 'data.resources', []));
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

      uploadFile: function (file, context) {
        var deferred = $q.defer();

        Upload.upload({
          url: [ CLOUDINARY_URL, cloudinary.config().cloud_name, 'upload' ].join('/'),
          data: {
            upload_preset: cloudinary.config().upload_preset,
            public_id: context.public_id,
            tags: context.tags,
            context: context.context,
            file: file,
          }
        }).progress(function (e) {
          context.progress = Math.round((e.loaded * 100.0) / e.total);
        }).success(function (data, status, headers, config) {
          _.assign(context, { success: data });
          deferred.resolve(data);
        }).error(function (data, status, headers, config) {
          _.assign(context, { error: data });
          deferred.reject(data);
        });

        return deferred.promise;
      },

      _getURL: function (propertyId) {
        return cloudinary.url(propertyId + '', { secure: true, format: 'json', type: 'list' }) +
          '?' + Math.ceil(new Date().getTime() / 1000);
      }
    };

    return service;
  }

})();

(function () {
  angular.module('feathers', [])
    .provider('$feathersConfig', function providerFeathers() {
      var host = 'https://api.mtlchild.com';
      // var host = 'http://localhost:3000';

      var serviceEndpoints = {
        propertyGroups: '/api/v1/property-groups',
        properties: '/api/v1/properties',
        units: '/api/v1/mrb/boards/:board_id/units',
        unitPrepare: '/api/v1/mrb/boards/:board_id/units/:unit_id/prepare',
        boards: '/api/v1/mrb/boards',
        boardComments: '/api/v1/mrb/boards/:board_id/comments',
        boardClone: '/api/v1/mrb/boards/:board_id/clones',
        staff: '/api/v1/mrb/boards/:board_id/staff',
        activity: '/api/v1/mrb/boards/:board_id/activity',
        workOrders: '/api/v1/mrb/boards/:board_id/worksets/:workset_id/workorders', // .patch to alloc/schedule
        workOrderUnits: '/api/v1/mrb/boards/:board_id/worksets/:workset_id/schedules/units',
        workOrderSchedules: '/api/v1/mrb/boards/:board_id/worksets/:workset_id/schedules/staff',
        workCategories: '/api/v1/mrb/boards/:board_id/workcategories',
        workCategoriesSort: '/api/v1/mrb/boards/:board_id/workcategories/sort',
      };

      var authOptions = {
        cookie: 'mtlchild-token',
        tokenKey: 'mtlchild-token',
        storage: window.localStorage,
        localEndpoint: '/api/v1/auth/local',
        tokenEndpoint: '/api/v1/token'
      };

      var primusOptions = {
        timeout: 50000
      };

      return {
        getHost: function () {
          return host;
        },
        getServiceEndpoints: function () {
          return serviceEndpoints;
        },
        getAuthOptions: function () {
          return authOptions;
        },
        getPrimusOptions: function () {
          return primusOptions;
        },
        $get: function () {
          return this;
        }
      };
    })
    .config(['$localStorageProvider', function ($localStorageProvider) {
      $localStorageProvider.setKeyPrefix('mtlchild-');
      $localStorageProvider.setDeserializer(function deserialize(value) {
        if (typeof value === 'string' && !value.match(/^["\{\[].*/)) {
          return value;
        }
        return angular.fromJson(value);
      });
    }])
    .factory('$feathers', $feathers);

  /** @ngInject */
  function $feathers($feathersConfig, $q, $http, $localStorage) {
    var host = $feathersConfig.getHost();
    var serviceEndpoints = $feathersConfig.getServiceEndpoints();
    var primus = new Primus(host);
    var feathersApp = feathers()
      .configure(feathers.hooks())
      .configure(feathers.primus(primus, $feathersConfig.getPrimusOptions()))
      .configure(feathers.authentication($feathersConfig.getAuthOptions()));

    return {
      app: feathersApp,
      service: service,
      host: host,
      login: login,
      logout: logout,
      getToken: getToken,
      getUser: getUser,
      disconnect: function () {
        try {
          primus.end();
        } catch (e) {
          console.log(e);
        }
      },
    };

    function service(name) {
      var srvPath = serviceEndpoints[name];
      if (!srvPath) {
        throw new Error('Invalid service');
      }

      var srv = feathersApp.service(srvPath);
      var service = {
        _wrapPromise: function (p, resolve, reject) {
          p.then(resolve).catch(reject);
        },
        _toPromise: function () {
          var args = Array.prototype.slice.call(arguments);
          var fn = args.shift();

          return $q(function (resolve, reject) {
            if (typeof srv[fn] !== 'function') {
              return reject('Invalid service method: ' + fn);
            }

            service._wrapPromise(srv[fn].apply(srv, args), resolve, reject);
          });
        },
        find: function (params) {
          return service._toPromise('find', params);
        },
        get: function (id, params) {
          return service._toPromise('get', id, params);
        },
        create: function (data, params) {
          return service._toPromise('create', data, params);
        },
        update: function (id, data, params) {
          return service._toPromise('update', data, params);
        },
        patch: function (id, data, params) {
          return service._toPromise('patch', id, data, params);
        },
        remove: function (id, params) {
          return service._toPromise('remove', id, params);
        },
        on: function (eventName, fn) {
          var subscription = service.subscribe(eventName);
          subscription.promise.then(subscription.off, subscription.off, fn);
          return subscription;
        },
        subscribe: function (eventName) {
          var deferred = $q.defer();
          srv.on(eventName, deferred.notify);
          var active = true;

          return {
            promise: deferred.promise,
            off: function () {
              if (!active) {
                return;
              }

              deferred.resolve();
              srv.removeListener(eventName, deferred.notify);
              active = false;
            }
          };
        }
      };

      return service;
    }

    function getToken() {
      return feathersApp.get('token');
    }

    function getUser() {
      return feathersApp.get('user');
    }

    function login(accessToken) {
      return $q(function (resolve, reject) {
        feathersApp.authenticate({ type: 'token', token: accessToken })
          .then(function (result) {
            $localStorage.user = result.data;
            $http.defaults.headers.common.Authorization = 'Bearer ' + result.token;
            return resolve();
          }).catch(function (err) {
            console.log('login error', err);
            reject(err);
          });
      });
    }

    function logout() {
      delete $localStorage.user;
      delete $localStorage.token;
      $http.defaults.headers.common.Authorization = '';
    }
  }
})();

(function () {
  var app = angular.module('MTLChild');

  // app.filter('monthName', [function() {
  //   return function (dt) { //1 = January
  //     var monthNames = [
  //       'January', 'February', 'March', 'April', 'May', 'June',
  //       'July', 'August', 'September', 'October', 'November', 'December'
  //     ];

  //     return monthNames[dt.getMonth()];
  //   }
  // }])

})();

(function () {
  angular.module('lambda', [])
    .factory('$lambda', $lambda);

  var ROOT_URL = 'https://lambda-api.mtlchild.com/autobot-v2';
  var PROPERTIES_URL = 'https://lambda-api.mtlchild.com/v1-p';
  var API_KEY = 'CWETuIK3ie5vIaJy4n9NhaTDizd20znt4Q1OBGkM';
  var REPORTS_URL = 'https://reports.mtlchild.com';
  var REPORTS_API_KEY = 'JIxUjb4EkwwD4T1b6PXJKC2I30dSiK2oIwsYs1biIT3cGkxM3DS70BWI';

  /** @ngInject */
  function $lambda($http, $q) {
    // $http.defaults.headers.common['x-api-key'] = API_KEY;

    var service = {};
    Properties(service, $http, $q);
    Defaults(service, $http, $q);
    Images(service, $http, $q);
    Listings(service, $http, $q);
    Templates(service, $http, $q);
    Reports(service, $http, $q);
    CL(service, $http, $q);
    Accounts(service, $http, $q);
    Global(service, $http, $q);
    return service;
  }

  function Properties(service, $http, $q) {
    var api = {
      getProperties: function (mode) {
        var deferred = $q.defer();

        $http({
          method: 'GET',
          headers: { 'x-api-key': API_KEY },
          url: [ PROPERTIES_URL, 'properties', 'list' ].join('/'),
          params: {
            mode: mode || 'lean'
          }
        }).then(function success(res) {
          deferred.resolve(res.data || []);
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

      getProperty: function (propertyId, mode) {
        var deferred = $q.defer();

        $http({
          method: 'GET',
          headers: { 'x-api-key': API_KEY },
          url: [ PROPERTIES_URL, 'properties', 'list', propertyId + '' ].join('/'),
          params: {
            mode: mode || 'lean'
          }
        }).then(function success(res) {
          deferred.resolve(res.data || []);
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

      getUnitTypes: function (propertyId) {
        var deferred = $q.defer();

        $http({
          method: 'GET',
          headers: { 'x-api-key': API_KEY },
          url: [ PROPERTIES_URL, 'properties', propertyId + '', 'unittypes' ].join('/')
        }).then(function success(res) {
          deferred.resolve(_.sortBy(res.data || [], 'name'));
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

    };

    return _.assign(service, api);
  }

  function Defaults(service, $http, $q) {
    var api = {
      getPropertyDefaults: function (propertyId) {
        var deferred = $q.defer();

        $http({
          method: 'GET',
          headers: { 'x-api-key': API_KEY },
          url: [ PROPERTIES_URL, 'properties', propertyId + '', 'autobot', 'defaults' ].join('/'),
        }).then(function success(res) {
          deferred.resolve(_.get(res, 'data', {}));
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

      savePropertyDefaults: function (propertyId, defaults) {
        var deferred = $q.defer();

        $http({
          method: 'POST',
          headers: { 'x-api-key': API_KEY },
          url: [ PROPERTIES_URL, 'properties', propertyId + '', 'autobot', 'defaults' ].join('/'),
          data: { defaults: defaults }
        }).then(function success(res) {
          deferred.resolve(_.get(res, 'data', {}));
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },
    };

    return _.assign(service, api);
  }

  function Images(service, $http, $q) {
    var api = {
      getImages: function (propertyId, folder) {
        var deferred = $q.defer();

        $http({
          method: 'GET',
          headers: { 'x-api-key': API_KEY },
          url: [ ROOT_URL, 'properties', propertyId + '', 'images', folder ].join('/')
        }).then(function success(res) {
          deferred.resolve(res.data || []);
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

      createImage: function (propertyId, image) {
        var deferred = $q.defer();

        $http({
          method: 'POST',
          headers: { 'x-api-key': API_KEY },
          url: [ ROOT_URL, 'properties', propertyId + '', 'images' ].join('/'),
          data: image,
        }).then(function success(res) {
          deferred.resolve(res.data || {});
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

      voteImage: function (propertyId, imageId, action, user) {
        var deferred = $q.defer();
        $http({
          method: 'PATCH',
          headers: { 'x-api-key': API_KEY },
          url: [ ROOT_URL, 'properties', propertyId + '', 'images', imageId + '' ].join('/'),
          data: { action: action, user: user },
        }).then(function success(res) {
          deferred.resolve(res.data || {});
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

      updateImage: function (propertyId, imageId, image) {
        var deferred = $q.defer();
        $http({
          method: 'PUT',
          headers: { 'x-api-key': API_KEY },
          url: [ ROOT_URL, 'properties', propertyId + '', 'images', imageId + '' ].join('/'),
          data: image,
        }).then(function success(res) {
          deferred.resolve(res.data || {});
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

      deleteImage: function (propertyId, imageId) {
        var deferred = $q.defer();

        $http({
          method: 'DELETE',
          headers: { 'x-api-key': API_KEY },
          url: [ ROOT_URL, 'properties', propertyId + '', 'images', imageId + '' ].join('/'),
        }).then(function success(res) {
          deferred.resolve(res.data || {});
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      }
    };

    return _.assign(service, api);
  }

  function Listings(service, $http, $q) {
    var api = {
      getListings: function (propertyId) {
        var deferred = $q.defer();

        $http({
          method: 'GET',
          headers: { 'x-api-key': API_KEY },
          url: [ ROOT_URL, 'properties', propertyId + '', 'listings' ].join('/')
        }).then(function success(res) {
          deferred.resolve(res.data || []);
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

      getListing: function (propertyId, listingId) {
        var deferred = $q.defer();

        $http({
          method: 'GET',
          headers: { 'x-api-key': API_KEY },
          url: [ ROOT_URL, 'properties', propertyId + '', 'listings', listingId + '' ].join('/')
        }).then(function success(res) {
          deferred.resolve(res.data || {});
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

      // deleteListing: function (propertyId, listingId) {
      //   var deferred = $q.defer();

      //   $http({
      //     method: 'DELETE',
      //    headers: { 'x-api-key': API_KEY },
      //     url: [ ROOT_URL, 'properties', propertyId + '', 'listings', listingId + '' ].join('/')
      //   }).then(function success(res) {
      //     deferred.resolve(res.data || {});
      //   }, function error(res) {
      //     deferred.reject(res);
      //   });

      //   return deferred.promise;
      // },

      // createListing: function (propertyId, data) {
      //   var deferred = $q.defer();

      //   $http({
      //     method: 'POST',
      //    headers: { 'x-api-key': API_KEY },
      //     url: [ ROOT_URL, 'properties', propertyId + '', 'listings' ].join('/'),
      //     data: data
      //   }).then(function success(res) {
      //     deferred.resolve(res.data || {});

      //     /* schedule listing for processing */
      //     setTimeout(function () {
      //       service.processListings();
      //     }, 5000);

      //   }, function error(res) {
      //     deferred.reject(res);
      //   });

      //   return deferred.promise;
      // },

      // processListings: function () {
        // console.log('processListings', 'requesting listings to be processed (async)');

        // $http({
        //   method: 'POST',
        //   headers: { 'x-api-key': API_KEY },
        //   url: [ ROOT_URL, 'listings', 'process' ].join('/'),
        //   transformRequest: function (data, headersGetter) {
        //     var headers = headersGetter();
        //     delete headers.authorization;
        //     return data;
        //   }
        // }).then(function success(res) {
        //   console.log('processListings', res.data);
        // }, function error(res) {
        //   console.log('processListings: ' + JSON.stringify(res));
        // });
      // },
    };

    return _.assign(service, api);
  }

  function Templates(service, $http, $q) {
    var api = {
      getTemplates: function (propertyId) {
        var deferred = $q.defer();

        $http({
          method: 'GET',
          headers: { 'x-api-key': API_KEY },
          url: [ ROOT_URL, 'properties', propertyId + '', 'templates' ].join('/')
        }).then(function success(res) {
          deferred.resolve(res.data || []);
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

      getListing: function (propertyId, listingId) {
        var deferred = $q.defer();

        $http({
          method: 'GET',
          headers: { 'x-api-key': API_KEY },
          url: [ ROOT_URL, 'properties', propertyId + '', 'listings', listingId + '' ].join('/')
        }).then(function success(res) {
          deferred.resolve(res.data || {});
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

      saveTemplate: function (propertyId, data) {
        var deferred = $q.defer();
        $http({
          method: 'POST',
         headers: { 'x-api-key': API_KEY },
          url: [ ROOT_URL, 'properties', propertyId + '', 'templates' ].join('/'),
          data: data
        }).then(function success(res) {
          deferred.resolve(res.data || {});
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },
    };

    return _.assign(service, api);
  }

  function Reports(service, $http, $q) {
    var api = {
      getReport: function (propertyId) {
        var deferred = $q.defer();

        $http({
          method: 'GET',
          headers: { 'x-api-key': REPORTS_API_KEY },
          url: [ REPORTS_URL, 'autobot', 'results', 'report' ].join('/'),
          params: { propertyId: propertyId }
        }).then(function success(res) {
          deferred.resolve(res.data || {});
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

      getResults: function (propertyId) {
        var deferred = $q.defer();

        $http({
          method: 'GET',
          headers: { 'x-api-key': REPORTS_API_KEY },
          url: [ REPORTS_URL, 'autobot', 'results' ].join('/'),
          params: { propertyId: propertyId, '$limit': 40, '$sort[completedAt]': -1 }
          // method: 'GET',
          // headers: { 'x-api-key': API_KEY },
          // url: [ ROOT_URL, 'properties', propertyId + '', 'results' ].join('/')
        }).then(function success(res) {
          deferred.resolve((res.data || {}).data);
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },
    };

    return _.assign(service, api);
  }

  function CL(service, $http, $q) {
    var api = {
      getPropertyCLRegions: function (propertyId) {
        var deferred = $q.defer();

        $http({
          method: 'GET',
          headers: { 'x-api-key': API_KEY },
          url: [ PROPERTIES_URL, 'properties', propertyId + '', 'config', 'autobot-regions' ].join('/'),
        }).then(function success(res) {
          deferred.resolve(_.get(res, 'data.regions', []));
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

      savePropertyCLRegion: function (propertyId, region) {
        return service.getPropertyCLRegions(propertyId)
          .then(function (regions) {
            if (regions.length) {
              // contains existing regions, check if dup
              var newKey = _toKey(region);
              var existingKeys = _.map(regions, _toKey);

              if (existingKeys.indexOf(newKey) !== -1) {
                return $q.reject('Region already selected.');
              }
            }

            regions.push(region);
            return service._updatePropertyCLRegions(propertyId, regions);

            function _toKey(o) {
              return _.transform(['region', 'subregion', 'neighborhood'], function (acc, k) {
                if (o[k]) {
                  acc.push(o[k]);
                }
              }, []).join('/');
            }
          });
      },

      deletePropertyCLRegion: function (propertyId, region) {
        return service.getPropertyCLRegions(propertyId)
          .then(function (regions) {
            if (!_.isEmpty(regions)) {
              var idx = _.findIndex(regions, region);
              if (idx === -1) {
                return $q.reject('Region not found');
              }

              regions.splice(idx, 1);
            }

            return service._updatePropertyCLRegions(propertyId, regions, true);
          });
      },

      _updatePropertyCLRegions: function (propertyId, regions, replace) {
        var deferred = $q.defer();

        $http({
          method: replace ? 'PUT' : 'PATCH',
          headers: { 'x-api-key': API_KEY },
          url: [ PROPERTIES_URL, 'properties', propertyId + '', 'config', 'autobot-regions' ].join('/'),
          data: { config: { regions: regions || [] } }
        }).then(function success(res) {
          deferred.resolve(_.get(res, 'data.regions', []));
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

      getCLRegions: function (state, zip) {
        var deferred = $q.defer();

        $http({
          method: 'GET',
          headers: { 'x-api-key': API_KEY },
          url: [ ROOT_URL, 'cl', 'regions' ].join('/'),
          params: { state: state, zip: zip }
        }).then(function success(res) {
          deferred.resolve(res.data || []);
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      }
    };

    return _.assign(service, api);
  }

  function Accounts(service, $http, $q) {
    var api = {
      getPropertyAccounts: function (propertyId) {
        var deferred = $q.defer();

        $http({
          method: 'GET',
          headers: { 'x-api-key': API_KEY },
          url: [ ROOT_URL, 'properties', propertyId + '', 'accounts' ].join('/'),
        }).then(function success(res) {
          deferred.resolve(res.data || []);
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

      updatePropertyAccount: function (propertyId, accountId, data) {
        var deferred = $q.defer();

        $http({
          method: 'PATCH',
          headers: { 'x-api-key': API_KEY },
          url: [ ROOT_URL, 'properties', propertyId + '', 'accounts', accountId ].join('/'),
          data: data
        }).then(function success(res) {
          deferred.resolve(res.data || {});
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

      savePropertyAccount: function (propertyId, account) {
        var deferred = $q.defer();

        $http({
          method: 'POST',
          headers: { 'x-api-key': API_KEY },
          url: [ ROOT_URL, 'properties', propertyId + '', 'accounts' ].join('/'),
          data: account
        }).then(function success(res) {
          deferred.resolve(res.data || {});
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

      deletePropertyAccount: function (propertyId, accountId) {
        var deferred = $q.defer();

        $http({
          method: 'DELETE',
          headers: { 'x-api-key': API_KEY },
          url: [ ROOT_URL, 'properties', propertyId + '', 'accounts', accountId + '' ].join('/'),
        }).then(function success(res) {
          deferred.resolve(res.data || {});
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

      getPropertyAccountsInPhoneVerif: function () {
        var deferred = $q.defer();

        $http({
          method: 'GET',
          headers: { 'x-api-key': API_KEY },
          url: [ ROOT_URL, 'properties', 'all', 'accounts' ].join('/'),
          params: { reason: 'PHONE VERIFICATION' }
        }).then(function success(res) {
          deferred.resolve(res.data || []);
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

      checkPhoneVerifDuplicates: function(propertyId,verif_phone) {
        console.log('Lambda: Phone to be verified...' + verif_phone)
        var deferred = $q.defer();
    
        $http({
          method: 'GET',
          headers: { 'x-api-key': API_KEY },
          url: [ ROOT_URL, 'properties', 'all', 'accounts' ].join('/'),
          params: { verif_phone: verif_phone }
        }).then(function success(res) {
          deferred.resolve(res.data || []);
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

    };

    return _.assign(service, api);
  }

  function Global(service, $http, $q) {
    var api = {
      getAutobotProperties: function () {
        var deferred = $q.defer();

        $http({
          method: 'GET',
          headers: { 'x-api-key': API_KEY },
          url: [ ROOT_URL, 'properties' ].join('/')
        }).then(function success(res) {
          deferred.resolve(res.data || {});
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

      getAutobotProperty: function (propertyId) {
        var deferred = $q.defer();

        $http({
          method: 'GET',
          headers: { 'x-api-key': API_KEY },
          url: [ ROOT_URL, 'properties', propertyId ].join('/')
        }).then(function success(res) {
          deferred.resolve(res.data || {});
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      },

      updateProperty: function (propertyId, data) {
        var deferred = $q.defer();
        $http({
          method: 'PATCH',
          headers: { 'x-api-key': API_KEY },
          url: [ ROOT_URL, 'properties', propertyId ].join('/'),
          data: data,
        }).then(function success(res) {
          deferred.resolve(res.data || {});
        }, function error(res) {
          deferred.reject(res);
        });

        return deferred.promise;
      }

      // updatePropertyWithLuxValFlag: function (propertyId, value) {
      //   var deferred = $q.defer();
      //   $http({
      //     method: 'PATCH',
      //     headers: { 'x-api-key': API_KEY },
      //     url: [ ROOT_URL, 'properties', propertyId ].join('/'),
      //     data: { property_type: value },
      //   }).then(function success(res) {
      //     deferred.resolve(res.data || {});
      //   }, function error(res) {
      //     deferred.reject(res);
      //   });

      //   return deferred.promise;
      // },
      // updatePropertyWithLanguageFlag: function (propertyId, value) {
      //   var deferred = $q.defer();
      //   $http({
      //     method: 'PATCH',
      //     headers: { 'x-api-key': API_KEY },
      //     url: [ ROOT_URL, 'properties', propertyId ].join('/'),
      //     data: { property_language: value },
      //   }).then(function success(res) {
      //     deferred.resolve(res.data || {});
      //   }, function error(res) {
      //     deferred.reject(res);
      //   });

      //   return deferred.promise;
      // }
    }

    return _.assign(service, api);
  }

})();
(function () {
  angular.module('sharedState', [])
    .factory('$sharedState', $sharedState);

  /** @ngInject */
  function $sharedState($rootScope, $localStorage, baSidebarService) {
    return {
      restore: load
    };

    function load() {
      restoreMenuState();
      captureSidebarState();
    }

    function restoreMenuState() {
      // NOTE: we only store strings in $localStorage
      if (typeof $localStorage.isSidebarCollapsed === 'undefined') {
        $localStorage.isSidebarCollapsed = 'true';
      }

      baSidebarService.setMenuCollapsed($localStorage.isSidebarCollapsed === 'true');
    }

    function captureSidebarState() {
      $rootScope.$on('sidebar::toggle', function (event, data) {
        if (data && typeof data.isSidebarCollapsed === 'boolean') {
          $localStorage.isSidebarCollapsed = data.isSidebarCollapsed ? 'true': 'false';
        }
      });
    }
  }
})();
(function () {
  angular.module('sso', ['feathers'])
    .factory('$sso', $sso);

  /** @ngInject */
  function $sso($rootScope, $q, $feathers, $window) {
    var sso = null;
    var state = null;

    (function init() {
      getInstance().catch(signOut);
    })();

    return {
      isLoggedIn: function (forceFetch) {
        return getStateAttr('status', forceFetch).then(function (status) {
          return $q.resolve(status === 'SIGNED_IN');
        });
      },

      getToken: function (forceFetch) {
        return getStateAttr('accessToken', forceFetch);
      },

      getUser: function (forceFetch) {
        return getStateAttr('user', forceFetch);
      },

      getPermissions: function (forceFetch) {
        return getStateAttr('user', forceFetch).then(function (user) {
          if (user.authorization && user.authorization.permissions) {
            return $q.resolve(user.authorization.permissions);
          }

          return $q.reject(new Error('NO_RESPONSE_ATTR'));
        });
      },

      logout: function () {
        $feathers.logout();

        return getInstance().then(function (api) {
          api.logout(signOut);
        }, function (err) {
          console.log('logout', err);
          signOut();
        });
      }
    };

    function signOut() {
      $window.location.href = '/login.html';
    }

    function getStateAttr(attr, forceFetch) {
      if (!forceFetch && state && typeof state[attr] !== 'undefined') {
        return $q.resolve(state[attr]);
      }

      return getInstance().then(function (api) {
        return $q(function (resolve, reject) {
          api.getState(function (err, res) {
            if (err) {
              return reject(err);
            }
            if (!res) {
              return reject(new Error('NO_RESPONSE'));
            }
            if (typeof res[attr] === 'undefined') {
              return reject(new Error('NO_RESPONSE_ATTR'));
            }

            state = res;
            resolve(res[attr]);
          });
        });
      });
    }

    function getInstance() {
      if (sso) {
        return $q.resolve(sso);
      }

      return $q(function (resolve, reject) {
        $window.sso.getInstance(function (err, api, res) {
          if (err || !res || res.status !== 'SIGNED_IN') {
            return reject(err || new Error('SIGNED_OUT'));
          }

          sso = api;
          resolve(sso);
        });
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('MTLChild')
      .directive('tagInput', tagInput);

  /** @ngInject */
  function tagInput() {
    return {
      restrict: 'A',
      scope: { tags: '=ngModel' },
      link: function( $scope, elem, attr) {
        var el = $(elem);
        el.tagsinput({
          tagClass:  'label label-' + attr.tagInput,
          trimValue: true
        });

        var tags = $scope.tags;
        if (typeof tags === 'string' && tags.length) {
          tags = tags.split(',');

          for (var i = 0, l = tags.length; i < l; i++) {
            el.tagsinput('add', tags[i], tags[i]);
          }
        }
      }
    };
  }
})();


(function () {
  'use strict';

  angular.module('MTLChild')
      .directive('telFormat', telFormatDir);

  /** @ngInject */
  function telFormatDir() {
    return {
      restrict: 'A',
      scope: { tel: '=ngModel' },
      link: function ($scope, elem, attr) {
        $(elem).keydown(function (e) {
          onKeydown.bind(this)(e);
          $scope.tel = this.value;
        }).blur(function (e) {
          onBlur.bind(this)(e);
          $scope.tel = this.value;
        });

        // migrate existing data
        // if (typeof $scope.tel === 'string' && $scope.tel.match(/\d{3}\-\d{3}\-\d{4}/)) {
        //   $scope.tel = $scope.tel.replace(/(\d{3})\-(\d{3})\-(\d{4})/, '($1)-$2-$3');
        // }
      }
    };
  }

  function onBlur(e) {
    if (!this.value) {
      return;
    }

    this.value = formatPhoneNumber(this.value)

    // if (this.value.match(/\d{10,}/)) {
    //   this.value = this.value.replace(/(\d{3})(\d{3})(\d{4,})/, '($1)-$2-$3');
    // } else if (this.value.match(/\d{3}\-\d{3}\-\d{4}/)) {
    //   this.value = this.value.replace(/(\d{3})\-(\d{3})\-(\d{4})/, '($1)-$2-$3');
    // }
  }

  function formatPhoneNumber(tel) {
    var sanitized_tel = (""+tel).replace(/\D/g, '');
    return sanitized_tel.replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');
    //var componentized_tel_arr = sanitized_tel.match(/^(\d{3})(\d{3})(\d{4})$/);
    // return (!componentized_tel_arr) ? null : "(" + componentized_tel_arr[1] + ") " + componentized_tel_arr[2] + "-" + componentized_tel_arr[3];
  }

  function onKeydown(e) {
    if (!this.value) {
      return;
    }

    var curchr = this.value.length, curval = this.value;

    if (e.keyCode !== 189 && e.keyCode !== 32 && e.keyCode !== 8) {
      if (curchr === 3) {
        this.value = ('(' + curval + ')' + ' ');
      } else if (curchr === 9 && e.keyCode !== 8) {
        this.value = curval + '-';
      }
    } else if (e.keyCode === 8) {
      if (curchr === 4) {
        var removeFormat = curval.replace('(', '');
        this.value = removeFormat;
      } else if (curchr === 10) {
        var removeDash = curval.replace(/-([^-]*)$/, '$1');
        this.value = removeDash;
      }
    } else {
      e.preventDefault();
    }
  }

})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    baConfigProvider.changeColors({
      default: 'rgba(#000000, 0.2)',
      defaultText: '#ffffff',
      dashboard: {
        white: '#ffffff',
      },
    });
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        theme: IMAGES_ROOT + 'theme/',
        amMap: 'assets/img/theme/vendor/ammap/dist/ammap/images/',
        amChart: 'assets/img/theme/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    /*
    var whatToWait = [
      // preloader.loadAmCharts(),
      // $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);
    */

    // $rootScope.$pageFinishedLoading = true;
    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    };
  }

})();

(function () {
  'use strict';

  angular.module('components')
    .controller('LoginSessionCtrl', LoginSessionCtrl);

  /** @ngInject */
  function LoginSessionCtrl($scope, $window, $sso) {
    $scope.logout = logout;
    $scope.profile = profile;

    $scope.user = null;

    function profile() {
      $sso.getUser().then(function (user) {
        $scope.user = user;
      }).catch(function (err) {
        $window.alert(err.message || 'Failed to load user');
      });
    }

    function logout() {
      return $sso.logout();
    }

    profile();
  }

})();

(function () {
  'use strict';

  angular.module('components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/pageTop/pageTop.html'
    };
  }

})();

(function () {
  'use strict';

  angular.module('components')
    .controller('SelectPropertyPanelCtrl', SelectPropertyPanelCtrl);

  /** @ngInject */
  function SelectPropertyPanelCtrl($rootScope, $scope, $lambda, $state, $timeout) {

    var vm = this;
    vm.loaded = false;

    load();

    vm.onSelect = function select(property) {
      if (!property || !property.propertyId) {
        console.log('model error', property);
        return;
      }

      vm.selected = property;
      $rootScope.property = null;
      $rootScope.$emit('property.select', { property: property });
    };

    function load() {
      $rootScope.loadingProperties = true;

      $lambda.getProperties()
        .then(function (data) {
          $rootScope.loadingProperties = false;

          var acl = $rootScope.acl;
          var aclApplied = false;

          if (acl && !acl.hasGlobalAccess()) {
            console.log('applied acl');
            aclApplied = true;

            data = data.filter(function (a) {
              return acl.hasPropertyAccess(a.propertyId);
            });
          }

          vm.properties = (data || []).sort(function (a, b) {
            return a.internal_name.localeCompare(b.internal_name);
          });

          if ($state.params && $state.params.propertyId) {
            var propertyId = $state.params.propertyId;
            vm.property = vm.properties.filter(function (p) {
              return p.propertyId === propertyId;
            }).shift();

            if (vm.property) {
              vm.onSelect(vm.property);
            }
          } else if (aclApplied && vm.properties.length === 1) {
            vm.property = vm.properties[0];
            vm.onSelect(vm.property);
          }

          $timeout(function () {
            // prevents jank
            vm.loaded = true;

            $rootScope.$on('property.change', function (event, data) {
              vm.property = data.property;
            });

          }, 50);
        })
        .catch(function (err) {
          $rootScope.loadingProperties = false;
          console.error(err);
        });
    }
  }
})();

/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('components')
        .factory('$progressModal', progressModal);

    /** @ngInject */
    function progressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            isOpen: function (value) {
                return opened;
            },
            getProgress: function () {
                return progress;
            },
            open: function(isStatic) {
                if (!opened) {
                    opened = true;

                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/components/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: (typeof isStatic === 'undefined' || isStatic) ? 'static' : true
                    });
                } else {
                    // throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    if (methods.opened) {
                        methods.opened.then(function () {
                            methods.close();
                        });
                    }

                    opened = false;
                } else {
                    // throw Error('Progress modal is not active');
                }

            }
        };
    }

})();

(function () {
  'use strict';

  angular.module('pages.autobot', [
    'pages.autobot.listings',
    'pages.autobot.templates',
    'pages.autobot.jobs',
    'pages.autobot.images',
    'pages.autobot.settings',
    'pages.autobot.global',
  ]).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('root', {
        url: '/r',
        templateUrl: 'app/pages/autobot/index.html',
        resolve: { $user: authenticatedUser, $acl: loadACL },
        controller: function ($rootScope, $scope, $user, $acl, $feathers, $sharedState, $state, $timeout) {
          $rootScope.user = $user;
          $rootScope.acl = $rootScope.acl || $acl;
          $rootScope.property = null;
          $feathers.disconnect();

          $rootScope.$on('property.select', function (event, data) {
            $rootScope.property = data.property;
            applyACL(data.property.propertyId, $state, $rootScope.acl);

            if (!$state.includes('root.autobot', { propertyId: data.property.propertyId })) {
              $state.go('root.autobot.listings', { propertyId: data.property.propertyId });
            } else {
              // console.log('skipped state.go', $state.current, data.property.propertyId);
            }
          });

          $sharedState.restore();
          // $rootScope.$pageFinishedLoading = true;
        }
      })
      .state('root.autobot', {
        abstract: true,
        url: '/:propertyId',
        template: '<ui-view></ui-view>',
        resolve: {
          $property: function ($user, $rootScope, $transition$, $lambda, $q) {
            var propertyId = $transition$.params().propertyId;
            if (!propertyId) {
              return $q.reject(new Error('Invalid property'));
            }

            // if ($rootScope.property && $rootScope.property.propertyId === propertyId) {
            //   // $rootScope.property loaded by selectPropertyPanel loads lean properties
            //   return $q.resolve($rootScope.property);
            // }

            return $lambda.getProperty(propertyId, 'listing')
              .then(function (p) {
                $rootScope.property = p;
                $rootScope.$emit('property.change', { property: p });
                return p;
              });
          },
          $acl: function ($rootScope, $property, $user, $state) {
            $rootScope.acl = $rootScope.acl || loadACL($user);
            applyACL($property.propertyId, $state, $rootScope.acl);
            return $rootScope.acl;
          },
          $report: function ($acl, $property, $transition$, $lambda, $q) {
            var propertyId = $transition$.params().propertyId;
            if (!propertyId) {
              return $q.reject(new Error('Invalid property group'));
            }

            return $lambda.getReport(propertyId)
              .then(function (report) {
                // console.log('report', report);
                var now = moment();

                report.titles = [
                  'Year (' + now.format('YYYY') + ') to date',
                  now.format('MMMM'),
                  'Week (' + report.meta.week.start + ' – ' + report.meta.week.end + ')',
                  'Today (' + report.meta.today + ')'
                ];

                report.keys = ['year', 'month', 'week', 'day'];

                return report;
              });
          }
        },
        controller: function ($rootScope, $scope, $user, $sharedState, $property, $acl, $state) {
          // console.log('$property', $property);

          $scope.isRecent = function (dtStr) {
            return (new Date().getTime()) - new Date(dtStr) < (6 * 3600 * 1000); // 6hrs
          };

        }
      });
  }

  function authenticatedUser($auth) {
    return $auth.identity();
  }

  function applyACL(propertyId, $state, acl) {
    if (acl.hasGlobalAccess()) {
      return;
    }

    var states = $state.get();
    _.each(states, function (s, i) {
      if (s.sidebarMeta) {
        var matches = s.name.match(/root.autobot.(\w+)$/);
        if (matches && !acl.hasPermission(propertyId, matches[1])) {
          s.disabled = true;
          console.log('acl: menu disabled');
        }
      }
    });
  }

  function loadACL($user) {
    var acl = {
      permissions: _.get($user, 'authorization.permissions', {}),
      propertyIds: [],

      hasPropertyAccess: function (propertyId) {
        // console.log('hasPropertyAccess', 'propertyId:', propertyId)
        var perms = _.get(acl.permissions, propertyId, {});
        return _.keys(perms).length > 0;
      },

      hasGlobalAccess: function () {
        return _.get(acl.permissions, 'global', false);
      },

      hasPermission: function (propertyId, resource) {
        // console.log('hasPermission:', 'propertyId:', propertyId, 'resource:', resource);
        return !!acl.lookupPermission(propertyId, resource);
      },

      lookupPermission: function (propertyId, resource) {
        var perms = _.get(acl.permissions, [ propertyId, 'autobot.' + resource ]);
        if (perms) {
          // console.log('permissions-local', 'propertyId:', propertyId, 'resource:', resource);
          return perms;
        }

        // console.log('permissions-global', 'propertyId:', propertyId, 'resource:', resource);
        return _.get(acl.permissions, [ 'global', 'autobot.' + resource ]);
      },

      canAccess: function (resource, propertyId) {
        var resourcePrefix = 'autobot.' + resource;
        var perms = propertyId ? acl.permissions[propertyId] : acl.permissions.global;

        if (perms && _.some(_.keys(perms), function (k) { return (k.indexOf(resourcePrefix) === 0) })) {
          return true;
        }

        return false;
      },

      hasRWPermission: function (propertyId, resource) {
        // console.log('hasRWPermission:', 'propertyId:', propertyId, 'resource:', resource);
        var perms = acl.lookupPermission(propertyId, resource);

        return perms && _.every([ 'create', 'edit', 'delete', 'list', 'show' ], function (o) {
          return perms.indexOf(o) !== -1;
        });
      },

      hasROPermission: function (propertyId, resource) {
        // console.log('hasROPermission:', 'propertyId:', propertyId, 'resource:', resource);
        var perms = acl.lookupPermission(propertyId, resource);

        return perms && _.every([ 'list', 'show' ], function (o) {
          return perms.indexOf(o) !== -1;
        });
      }
    };

    return acl;
  }

})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('pages.autobot.global', ['pages.autobot.controllers'])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    console.info('templates')
    $stateProvider
      .state('root.global', {
        title: 'Global',
        url: '/global',
        templateUrl: 'app/pages/autobot/global/index.html',

        resolve: {
          $previousState: function ($state) {
            return {
              name: $state.current.name || 'root',
              params: $state.params,
              url: $state.href($state.current.name || 'root', $state.params)
            };
          },
          $accessCheck: function ($acl, toastr, $q) {
            if (!$acl.canAccess('global.')) {
              toastr.error('You are not authorised to access this section.');
              return $q.reject(new Error('Unauthorised'));
            }
          },
          $templates: function ($lambda) {
            return $lambda.getTemplates('global');
          },
          $templatePropertyId: function ($accessCheck) {
            return 'global';
          },
          $templatePropertyDesc: function () {
            return '';
          },
          $autobotProperties: function ($lambda) {
            return $lambda.getAutobotProperties()
              .then(function (data) {
                return data.map(function (p) {
                  p.property_type = (p.property_type === 'LUXURY');
                  p.property_language = (p.property_language === 'ALL');
                  return p;
                })
              })
          },
          $accountsInPhoneVerif: function ($lambda, $autobotProperties) {
            var propertyLookup = _.keyBy($autobotProperties, 'propertyId');

            return $lambda.getPropertyAccountsInPhoneVerif()
              .then(function (accs) {
                var accounts = accs.map(function (acc) {
                  if (propertyLookup[acc.propertyId]) {
                    acc.property_name = propertyLookup[acc.propertyId].name;
                  }

                  return acc;
                });

                return _.sortBy(accounts, 'property_name');
              });
          },
          $accounts: function ($lambda, $autobotProperties) {
            var propertyLookup = _.keyBy($autobotProperties, 'propertyId');

            return $lambda.getPropertyAccounts()
              .then(function (accs) {
                var accounts = accs.map(function (acc) {
                  if (propertyLookup[acc.propertyId]) {
                    acc.property_name = propertyLookup[acc.propertyId].name;
                  }

                  return acc;
                });

                return _.sortBy(accounts, 'property_name');
              });
          }
        },
        controller: 'TemplateCtrl'
      });
  }

})();

(function () {
  'use strict';

  angular.module('pages.autobot.images', ['pages.autobot.images.folder'])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('root.autobot.images', {
        // parent: 'root.autobot',
        title: 'Images',
        level: 0,
        sidebarMeta: {
          icon: 'ion-images',
          order: 1,
        },
        url: '/images',
        templateUrl: 'app/pages/autobot/images/index.html',
        resolve: {
        },
        controller: function ($scope, $property) {
          $scope.folders = [
            {
              label: 'Beginning',
              name: 'beginning'
            },
            {
              label: 'Middle',
              name: 'middle'
            },
            {
              label: 'End',
              name: 'end'
            },
            {
              label: 'Map',
              name: 'map'
            },
            {
              label: 'Sign',
              name: 'sign'
            },
          ]
        }
      });
  }

  function Cloudinary(cloudinary) {
    var self = this;


  }

})();

(function () {
  'use strict';

  angular.module('pages.autobot.jobs', ['pages.autobot.jobs.view'])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('root.autobot.jobs', {
        // parent: 'root.autobot',
        title: 'Posts',
        level: 0,
        url: '/jobs',
        templateUrl: 'app/pages/autobot/jobs/index.html',
        resolve: {
          $jobs: function ($user, $rootScope, $transition$, $lambda, $q) {
            var propertyId = $transition$.params().propertyId;
            if (!propertyId) {
              return $q.reject(new Error('Invalid property group'));
            }

            return $lambda.getResults(propertyId);
          },
          $checkPerms: function ($rootScope, $property, toastr, $state) {
            var acl = $rootScope.acl;
            if (!acl.hasPermission($property.propertyId, 'jobs')) {
              toastr.error('Permission denied.');
              return $state.go('root.autobot.listings', { propertyId: $property.propertyId });
            }
          }
        },
        controller: function ($scope, $user, $jobs, $sharedState, $property, $state) {
          // console.log('$jobs', $jobs);
          $scope.jobs = $jobs;

          $scope.getCloudinaryId = function (url) {
            return url && url.replace(/.*sessions\//, 'sessions/');
          };

          $scope.getPostingScreenshot = function (j) {
            var regex = j.status === 'FAILED' ? /error.jpg$/ : /pre-publish.jpg$/;

            return (j.screenshots || []).filter(function (url) {
              return regex.test(url);
            }).shift();
          };

          $scope.dtOptions = {
            dom: 'tpr',
            paging: true,
            pageLength: 10,
            sortClasses: false,
            sortCellsTop: true,
            responsive: true,
            searching: false,
            loadingTemplate: '',

            order: [[8, 'desc']],
            columnDefs: [{
              targets: [ 0 ],
              orderable: true,
              searchable: false,
              visible: false,
            }, {
              targets: [ 1 ],
              orderable: false,
              searchable: false
            }, {
              targets: [ 8 ],
              orderData: [ 0 ],
            }],
          };
        }
      })
      .state('root.autobot.job', {
        abstract: true,
        // parent: 'root.autobot',
        url: '/jobs/:jobId',
        template: '<ui-view></ui-view>',
        resolve: {
          $job: function ($user, $rootScope, $transition$, $lambda, $q) {
            var params = $transition$.params();
            var propertyId = params.propertyId;
            var jobId = params.jobId;
            if (!propertyId || !jobId) {
              return $q.reject(new Error('Invalid job'));
            }

            return $lambda.getJob(propertyId, jobId);
          }
        },
        controller: function ($rootScope, $scope, $user, $job, $sharedState, $property) {
          console.log('$job', $job);
          $scope.job = $job;
        }
      });
  }

})();

(function () {
  'use strict';

  angular.module('pages.autobot.listings', ['pages.autobot.listings.view'])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('root.autobot.listings', {
        title: 'Listings',
        level: 0,
        sidebarMeta: {
          icon: 'ion-clipboard',
          order: 0,
        },
        url: '/listings',
        templateUrl: 'app/pages/autobot/listings/index.html',
        resolve: {
          $listings: function ($user, $rootScope, $transition$, $lambda, $q) {
            var propertyId = $transition$.params().propertyId;
            if (!propertyId) {
              return $q.reject(new Error('Invalid property group'));
            }

            return $lambda.getListings(propertyId);
          }
        },
        controller: function ($rootScope, $scope, $user, $listings, $sharedState, $property, $state) {
          // console.log('$listings', $listings);
          $scope.listings = $listings;
          $scope.canAccessJobs = $scope.$root.acl.hasPermission($property.propertyId, 'jobs');

          $scope.create = function () {
            $state.go('.create', { propertyGroupId: $property.id });
          };

          $scope.dtOptions = {
            dom: 'tpr',
            paging: false,
            pageLength: 50,
            sortClasses: false,
            sortCellsTop: true,
            responsive: true,
            searching: false,
            loadingTemplate: '',

            order: [[6, 'desc']],
            columnDefs: [{
              targets: [ 0 ],
              orderable: true,
              searchable: false,
              visible: false,
            }, {
              targets: [ 6 ],
              orderData: [ 0 ],
            }],

            rowCallback: function (nRow, aData) {
              var listingId = $(nRow).data('listingId');
              $(nRow).bind('click', function (ev) {
                $scope.$apply(function() {
                  $state.go('^.listing.view', { listingId: listingId });
                });
              });
            }
          };
        }
      })
      .state('root.autobot.listing', {
        abstract: true,
        // parent: 'root.autobot',
        url: '/listings/:listingId',
        template: '<ui-view></ui-view>',
        resolve: {
          $listing: function ($user, $rootScope, $transition$, $lambda, $q) {
            var params = $transition$.params();
            var propertyId = params.propertyId;
            var listingId = params.listingId;
            if (!propertyId || !listingId) {
              return $q.reject(new Error('Invalid listing'));
            }

            return $lambda.getListing(propertyId, listingId);
          }
        },
        controller: function ($rootScope, $scope, $user, $listing, $sharedState, $property) {
          console.log('$listing', $listing);
          $scope.listing = $listing;
        }
      });
  }

})();

(function () {
  'use strict';

  angular.module('pages.autobot.settings', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('root.autobot.settings', {
        // parent: 'root.autobot',
        title: 'Settings',
        level: 0,
        sidebarMeta: {
          icon: 'ion-android-settings',
          order: 2,
        },
        url: '/settings',
        templateUrl: 'app/pages/autobot/settings/index.html',
        resolve: {
          $regions: function ($property, $lambda) {
            return $lambda.getCLRegions($property.state, $property.zip);
          },
          $propertyCLRegions: function ($property, $lambda) {
            return $lambda.getPropertyCLRegions($property.propertyId);
          },
          $propertyDefaults: function ($property, $lambda) {
            return $lambda.getPropertyDefaults($property.propertyId);
          },
          $propertyAccounts: function ($property, $lambda) {
            return $lambda.getPropertyAccounts($property.propertyId);
          },
          $propertyConfig: function ($property, $lambda) {
            return $lambda.getAutobotProperty($property.propertyId);
          },
          $checkPerms: function ($rootScope, $property, toastr, $state) {
            var acl = $rootScope.acl;
            if (!acl.hasGlobalAccess() && !acl.hasPermission($property.propertyId, 'settings')) {
              toastr.error('Permission denied.');
              return $state.go('root.autobot.listings', { propertyId: $property.propertyId });
            }
          }
        },
        controller: function ($scope, $property, $regions, $propertyCLRegions, $propertyDefaults, $propertyAccounts, $propertyConfig, $lambda, $progressModal, toastr, $state, $q, $window, $timeout) {
          $scope.hasRWPerms = $scope.$root.acl.hasRWPermission($property.propertyId, 'settings');

          $scope.propertyDefaults = new PropertyDefaults($property, $propertyDefaults, $lambda, toastr, $progressModal);
          $scope.postingAccounts = new PostingAccounts($property, $propertyAccounts, $lambda, toastr, $progressModal, $q, $window, $timeout);
          $scope.postingRegions = new PostingRegions($property, $regions, $propertyCLRegions, $lambda, toastr, $progressModal);
          $scope.postingConfig = new PropertyConfig($property, $propertyConfig, $lambda, toastr, $progressModal);

        }
      });
  }

  // function PhoneVerification($property, $lambda, toastr, $progressModal) {
  //   var $scope = this;
  //   $scope.checkPhoneVerifDuplicates = function (form) {
  //     var phoneUsage = $lambda.checkPhoneVerifDuplicates($property.propertyId,form.verif_phone);
  //     if (phoneUsage) {
  //       var usage = phoneUsage.join(",")
  //       toastr.warning('Phone number used in ' + usage)
  //     }
  //   };
  // }

  function PropertyDefaults($property, $propertyDefaults, $lambda, toastr, $progressModal) {
    var $scope = this;
    var _defaults = $propertyDefaults;

    $scope.reset = function () {
      $scope.form = {};
      _.assign($scope.form, _defaults);
    };

    $scope.save = function (defaults) {
      if (_.isEmpty(defaults)) {
        return;
      }

      $progressModal.open();

      $lambda.savePropertyDefaults($property.propertyId, defaults)
        .then(function success(res) {
          $progressModal.close();
          toastr.success('Property defaults saved successfully.');
          _defaults = res;
          $scope.reset();
        }, function failure(err) {
          $progressModal.close();
          toastr.error(err.message || err);
        });
    };

    $scope.reset();
    return $scope;
  }


  function PostingAccounts($property, $propertyAccounts, $lambda, toastr, $progressModal, $q, $window, $timeout) {
    var $scope = this;
    $scope.accounts = $propertyAccounts;

    $scope.reset = function () {
      $scope.form = {};
      $scope.verif_form = {};

      $propertyAccounts.forEach(function (acc, i) {
        console.log(i,acc)
        $scope.verif_form[i] = { verif_phone: acc.verif_phone };
      });
    };

    $scope.add = function (form) {
      if (_.some($scope.accounts, function (o) {
        return o.username === form.username;
      })) {
        toastr.error('Posting account "' + form.username + '" already exists.');
        return;
      }

      $progressModal.open();

      $lambda.savePropertyAccount($property.propertyId, {
        username: form.username,
        password: form.password
        // verif_phone: form.verif_phone
      })
      .then(function success(acc) {
        $scope.reset();
        $progressModal.close();

        if (acc.accountId) {
          toastr.success('Posting account saved.');
          $scope.accounts.push(acc);
        }

      }, function failure(err) {
        console.log('adde', err);
        $progressModal.close();
        toastr.error('Failed to add posting account. Please try again.');
      });
    };

    $scope.enableAccount = function (acc, $index) {
      if (!acc || !acc.accountId) {
        return;
      }

      var wasPasswordIssue = (acc.status === 'DISABLED' && acc.reason === 'INVALID PASSWORD');
      $progressModal.open();

      $lambda.updatePropertyAccount($property.propertyId, acc.accountId, {
        status: wasPasswordIssue ? 'PENDING' : 'ACTIVE',
        reason: null,
        lastDraftURL: null
      }).then(function success(res) {
        $scope.reset();
        $progressModal.close();

        if (acc.accountId) {
          _.assign(acc, res);

          toastr.success('Posting account "' + acc.username + '" ' +
            (wasPasswordIssue ? 'will be active after credentials are verified by Autobot.' : 'is now active.'));
        } else {
          toastr.error('Posting account could not be updated. Please try again.');
        }

      }, function failure(err) {
        console.log('upde', err);
        toastr.error('Failed to update posting account. Please try again.');
        $progressModal.close();
      });
    };

    $scope.delete = function (acc) {
      if (!acc || !acc.accountId) {
        return;
      }

      $progressModal.open();

      $lambda.deletePropertyAccount($property.propertyId, acc.accountId)
        .then(function success(res) {
          console.log('dels', res);
          toastr.success('Posting account deleted.');
          $progressModal.close();

          _.remove($scope.accounts, function (o) {
            return o.accountId === acc.accountId;
          });

        }, function failure(err) {
          console.log('dele', err);
          toastr.error('Failed to delete posting account. Please try again.');
          $progressModal.close();
        });
    };

    $scope.checkPhoneVerifDuplicatesAndSave = function (account, verif_phone, arr_index, force_save) {
      console.log('Module: Phone to be verified...' + verif_phone);
      console.log(account.accountId, account.propertyId, arr_index, verif_phone);
      
      (!verif_phone ? $q.resolve(true) : $lambda.checkPhoneVerifDuplicates($property.propertyId,verif_phone))
      .then(function (phoneUsage) {
        var phoneUsageStr = Array.isArray(phoneUsage)
          ? 'Phone number in use by: ' + phoneUsage.map(function (a) { return a.username; }).join(", ")
          : null;

        if (phoneUsage === true || phoneUsage.length === 0 || (phoneUsage.length > 0 && $window.confirm(phoneUsageStr))) {

          toastr.success('Saving phone number')
          //api call
          $progressModal.open();

          $lambda.updatePropertyAccount($property.propertyId, account.accountId, {
            verif_phone: verif_phone || null
          }).then(function success(res) {
            toastr.success('Saved phone number')
            $propertyAccounts[arr_index].verif_phone = res.verif_phone
            $scope.reset();
            $progressModal.close();
          }, function failure(err) {
            toastr.error('Failed to update. Please try again')
            $scope.reset();
            $progressModal.close();
          });
        } else {
          $scope.verif_form[arr_index].verif_phone = $propertyAccounts[arr_index].verif_phone;
        }
      });
    };

    $scope.reset();
    return $scope;
  }


  function PostingRegions($property, $regions, $propertyCLRegions, $lambda, toastr, $progressModal) {
    var $scope = this;

    $scope.regions = $propertyCLRegions;
    $scope._regions = $regions;

    $scope.reset = function () {
      $scope.r = { $invalid: true };
    };

    $scope.checkDone = function (r) {
      r.$invalid = !(r.region &&
        (!r.region._has_subregions ||
          (r.subregion && r.region.subregions[r.subregion] &&
            (!r.region.subregions[r.subregion]._has_neighborhoods || r.region.subregions[r.subregion][r.neighborhood])
          )
        )
      );
    };

    $scope.addRegion = function (r) {
      if (!r || !r.region) {
        return;
      }

      $progressModal.open();

      $lambda.savePropertyCLRegion($property.propertyId, {
        region: r.region.region,
        subregion: r.subregion,
        neighborhood: r.neighborhood
      })
      .then(function success(res) {
        $progressModal.close();
        toastr.success('Region saved successfully.');

        $scope.reset();
        $scope.regions = res;
      }, function failure(err) {
        $progressModal.close();
        toastr.error(err.message || err);
      });
    };

    $scope.deleteRegion = function (r) {
      $progressModal.open();

      $lambda.deletePropertyCLRegion($property.propertyId, {
        region: r.region,
        subregion: r.subregion,
        neighborhood: r.neighborhood
      })
      .then(function success(res) {
        $progressModal.close();
        toastr.success('Region deleted.');

        $scope.regions = res;
      }, function failure(err) {
        console.log('err', err)
        console.log('toastr', toastr)
        $progressModal.close();
        toastr.error(err.message || err);
      });
    };

    $scope.reset();

    return $scope;
  }

  function PropertyConfig($property, $propertyConfig, $lambda, toastr, $progressModal) {
    var $scope = this;
    var _defaults = { postingFrequency: $propertyConfig.postingFrequency || 'medium' };

    var CONFIG_VALUES = {
      lowest: {
        // ipPostingIntervalMins
        propertyPostingIntervalMins: 360, // 6 hrs
        accountPostingIntervalMins: 600,  // 10 hrs
        statePostingIntervalMins: 120     // 2 hrs
      },
      low: {
        // ipPostingIntervalMins
        propertyPostingIntervalMins: 120, // 2 hrs
        accountPostingIntervalMins: 480,  // 8 hrs
        statePostingIntervalMins: 60      // 1 hr
      },
      medium: {
        // ipPostingIntervalMins
        propertyPostingIntervalMins: 90,  // 1.5 hrs
        accountPostingIntervalMins: 300,  // 5 hrs
        statePostingIntervalMins: 30
      },
      high: {
        // ipPostingIntervalMins
        propertyPostingIntervalMins: 60,  // 1 hr
        accountPostingIntervalMins: 180,  // 3 hrs
        statePostingIntervalMins: 15
      }
    };

    $scope.reset = function () {
      $scope.form = {};
      _.assign($scope.form, _defaults);
    };

    $scope.save = function (form) {
      if (_.isEmpty(form)) {
        return;
      }

      if (form.postingFrequency === _defaults.postingFrequency) {
        toastr.success('Property config saved successfully.');
        return;
      }

      var config = { postingFrequency: form.postingFrequency }

      if (CONFIG_VALUES[config.postingFrequency]) {
        _.assign(config, CONFIG_VALUES[config.postingFrequency]);
      }

      $progressModal.open();

      $lambda.updateProperty($property.propertyId, config)
        .then(function success(res) {
          $progressModal.close();
          toastr.success('Property config saved successfully.');
          _defaults = { postingFrequency: res.postingFrequency };
          $scope.reset();
        }, function failure(err) {
          $progressModal.close();
          toastr.error(err.message || err);
        });
    };

    $scope.reset();
    return $scope;
  }

})();

(function () {
  'use strict';

  angular.module('pages.autobot.controllers', [])
    .controller('TemplateCtrl', TemplateCtrl);

  /** @ngInject */
  function TemplateCtrl($rootScope, $scope, $templates, $templatePropertyDesc, $user, $sharedState, $state, $templatePropertyId, $lambda, toastr, $progressModal, $timeout) {
    var templates = _.keyBy($templates, 'templateId') || {};
    console.log('templates', templates);

    var tmplVars = ['rent', 'phone'];
    var tabs = [ 'title', 'description' ];
    var currTabIndex = tabs.indexOf(($state.current.url || '').slice(1));
    $scope.activeTab = currTabIndex !== -1 ? currTabIndex : 0;

    var today = new Date();
    var defaultFromDate = new Date(today.getFullYear(), 0, 1);
    var defaultToDate = new Date(today.getFullYear(), 11, 31); //11 is December

    // $scope.updatePropertyWithLuxValFlag = function (propertyId, value) {
    //   value ? value = "LUXURY" : value = "VALUE";
    //   $lambda.updatePropertyWithLuxValFlag(propertyId, value);
    // };

    // $scope.updatePropertyWithLanguageFlag = function (propertyId, value) {
    //   value ? value = "ALL" : value = "EN";
    //   $lambda.updatePropertyWithLanguageFlag(propertyId, value);
    // };

    $scope.updateProperty = function (propertyId, data) {
      var updates = {
        "property_type":data.property_type ? "LUXURY":"VALUE",
        "property_language":data.property_language ? "ALL":"EN",
        "posting_phone_number":data.posting_phone_number || null,
        "posting_email":data.posting_email || null,
        "postingEnabled": data.postingEnabled || false
      }
      console.log('updates',updates);
      $lambda.updateProperty(propertyId, updates)
      .then(function(){toastr.success('Data successfully saved')})
      .catch(function(){toastr.error('Error saving data')})
    };


    $scope.reset = function () {
      console.log($scope.listing);

      $scope.date = [];

      $scope.form = {
        // titles: _.get(templates, 'propertyCLTemplate.data.titles', [{ title: '', luxury: false, english: true}]),
        // seasonal_titles: _.get(templates, 'propertyCLTemplate.data.seasonal_titles', [{ title: '', luxury: false, english: true, fromdate: defaultFromDate, todate: defaultToDate }]),
        // luxury_titles: _.get(templates, 'propertyCLTemplate.data.luxury_titles', [{ title: '', luxury: true, english: true}]),
        // luxury_seasonal_titles: _.get(templates, 'propertyCLTemplate.data.luxury_seasonal_titles', [{ title: '', luxury: true, english: true, fromdate: defaultFromDate, todate: defaultToDate }]),
        // descriptions: _.get(templates, 'propertyCLTemplate.data.descriptions', [{ description: '', enabled: false}]),
        // amenities: _.get(templates, 'propertyCLTemplate.data.amenities', [{ amenity: '', enabled: false}]),
        // cities: _.get(templates, 'propertyCLTemplate.data.cities', [{ city: '', enabled: false}])
        titles: _.get(templates, 'propertyCLTemplate.data.titles', []),
        seasonal_titles: _.get(templates, 'propertyCLTemplate.data.seasonal_titles', []),
        luxury_titles: _.get(templates, 'propertyCLTemplate.data.luxury_titles', []),
        luxury_seasonal_titles: _.get(templates, 'propertyCLTemplate.data.luxury_seasonal_titles', []),
        // descriptions: _.get(templates, 'propertyDescTemplate.data.descriptions', []),
        amenities: _.get(templates, 'propertyCLTemplate.data.amenities', []),
        cities: _.get(templates, 'propertyCLTemplate.data.cities', [])
      };

      $scope.desc_form = {
        descriptions: _.get(templates, 'propertyDescTemplate.data.descriptions',[]),
        default_desc: ($templatePropertyDesc || '').replace(/welcome to [^\.]+\.\s+/i, '')
      };

      var anyInvalidDates = false;
      _.map([ $scope.form.seasonal_titles, $scope.form.luxury_seasonal_titles ], function (titles) {
        _.map(titles, function (t, i) {
          _.each(['fromdate', 'todate'], function (k) {
            if (!_.isEmpty(t[k]) && !_.isDate(t[k])) {
              t[k] = new Date(t[k]);
            }
          });
        });
      });

      console.log('form', $scope.form);
    };

    $scope.addDescription = function(descriptions) {
      descriptions.push({description:'', section:'intro', english: true});
    };

    $scope.addTitle = function (titles,seasonal_yes_no) {
      // titles.unshift({ title: '', luxury: true, english: true, fromdate: defaultFromDate, todate: defaultToDate });
      if (seasonal_yes_no) {
        titles.unshift({ title: '', luxury: true, english: true, fromdate: defaultFromDate, todate: defaultToDate });
      } else {
        titles.unshift({ title: '', luxury: true, english: true});
      }
      console.log('addTitle', $scope.form);
    };

    $scope.validateFromToDates = function (form, fromDate, toDate, elem) {
      console.log('fromToDate',fromDate,toDate, elem)
      if (fromDate && toDate && fromDate > toDate) {
        toastr.error('ACTIVE FROM date should be earlier than ACTIVE TO date')
        // form.$invalid = true;
        elem.$setValidity('required', false);
        // return false;
      } else {
        // form.$invalid = false;
        elem.$setValidity('required', true);
        // return true;
      }
    };

    $scope.deleteTitle = function (titles, index) {
      if (index > -1) {
        titles.splice(index, 1);
      }
      console.log('deleteTitle', titles);
      $scope.listing.$setDirty();
    };

    $scope.addAmenity = function (form) {
      form.amenities.unshift({ amenity: '', enabled: false });
      console.log('addAmenity', $scope.form);
    };

    $scope.deleteAmenities = function (amenities, index) {
      if (index > -1) {
        amenities.splice(index, 1);
      }
      console.log('deleteAmenities', amenities);
      $scope.listing.$setDirty();
    };

    $scope.addCity = function (form) {
      form.cities.unshift({ city: '', enabled: false });
      console.log('addCity', $scope.form);
    };

    $scope.deleteCities = function (cities, index) {
      // form.titles.push({ title: '', luxury: true, english: true });
      if (index > -1) {
        cities.splice(index, 1);
      }
      console.log('deleteCities', cities);
      $scope.listing.$setDirty();
    };

    // $scope.addDescriptions = function (form) {
    //   form.descriptions.push({ description: '', enabled: false });
    //   console.log('addDescriptions', $scope.form);
    // };

    $scope.deleteDescription = function (descriptions, index) {
      if (index > -1) {
        descriptions.splice(index, 1);
      }
      console.log('deleteDescriptions', descriptions);
      $scope.listing_desc.$setDirty();
    };

    $scope.saveTemplate = function (form) {
      console.log('save template form' + form)
      $progressModal.open();
      _.map([ form.seasonal_titles, form.luxury_seasonal_titles ], function (titles) {
        titles.forEach(function(title) {
          if (title.fromdate) {
            title.fromdate.setUTCHours(0, 0, 0, 0)
          }
          if (title.todate) {
            title.todate.setUTCHours(23, 59, 59, 999)
          }
        })
    })
      var exclusions = [];
      $templatePropertyId === 'global' ? exclusions = ['descriptions', 'cities'] : exclusions = ['descriptions', 'luxury_titles', 'luxury_seasonal_titles'];
      $lambda.saveTemplate($templatePropertyId, { templateId: 'propertyCLTemplate', data: _.omit(form, exclusions) })
        .then(function(data) {
          $progressModal.close();
          toastr.success('Template successfully saved')
        }, function(err) {
          $progressModal.close();
          console.log(err)
          toastr.error('Failed to save template. Please check your data and retry')
        })
      console.log('saveTemplate', form);
    };

    $scope.saveDescTemplate = function (form) {
      console.log('save desc template form' + form)
      $progressModal.open();
      var exclusions = [];
      // $templatePropertyId === 'global' ? exclusions = ['descriptions', 'cities'] : exclusions = ['descriptions', 'luxury_titles', 'luxury_seasonal_titles'];
      $lambda.saveTemplate($templatePropertyId, { templateId: 'propertyDescTemplate', data: form })
        .then(function(data) {
          $progressModal.close();
          toastr.success('Desc template successfully saved')
        }, function(err) {
          $progressModal.close();
          console.log(err)
          toastr.error('Failed to save desc template. Please check your data and retry')
        })
      console.log('saveTemplate', form);
    };

    // $scope.reset();

    function replaceTmplVars(str, form) {
      if (!str) return str;

      var x = str + '';
      _.each(tmplVars, function (prop) {
        if (form[prop] > 0) {
          x = x.replace('[' + prop + ']', form[prop]);
        }
      });

      return x;
    }

  }

  angular.module('pages.autobot.templates', ['pages.autobot.controllers'])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    console.info('templates')
    $stateProvider
      .state('root.autobot.templates', {
        title: 'Templates',
        level: 0,
        sidebarMeta: {
          icon: 'ion-compose',
          order: 1,
        },
        url: '/templates',
        templateUrl: 'app/pages/autobot/templates/index.html',
        resolve: {
          $templates: function ($property, $lambda) {
            return $lambda.getTemplates($property.propertyId);
          },
          $templatePropertyId: function ($property) {
            return $property.propertyId;
          },
          $templatePropertyDesc: function ($property) {
            return $property.description || '';
          }
        },
        controller: 'TemplateCtrl'
      })
      .state('root.autobot.templates.title', {
        url: '/title'
      })
      .state('root.autobot.templates.description', {
        url: '/description'
      })
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '');
        res += (attrs.baPanelZoomIn === 'true' ? ' full-invisible ' : '');
        res += (attrs.baPanelClass || '');
        res += '" ' + (attrs.baPanelZoomIn === 'true' ? 'zoom-in ' : '');
        res += (baConfig.theme.blur ? 'ba-panel-blur ' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title cut-with-dots nowrap">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, $rootScope, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
          notifyStateChange();
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
          notifyStateChange();
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function notifyStateChange() {
          $rootScope.$emit('sidebar::toggle', {
            isSidebarCollapsed: isMenuCollapsed
          });
        }

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: !isNaN(s.level) ? s.level : (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                  disabled: s.disabled,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.theme + 'no-photo.png';
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherRef: '@',
        switcherValue: '=',
        switcherOnchange: '&',
        switcherOnLabel: '@',
        switcherOffLabel: '@'
      }
    };
  }

})();

(function () {
  'use strict';

  angular.module('pages.autobot.images.folder', [ 'ngFileUpload', '$cloudinary' ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('root.autobot.images-folder', {
        // parent: 'root.autobot.images',
        // title: 'Images',
        url: '/images/:folder',
        templateUrl: 'app/pages/autobot/images/folder/index.html',
        resolve: {
          $images: [ '$property', '$lambda', '$transition$', function ($property, $lambda, $transition$) {
            return $lambda.getImages($property.propertyId, $transition$.params().folder);
          }],
          $unittypes: ['$property', '$lambda', function ($property, $lambda) {
            return $lambda.getUnitTypes($property.propertyId);
          }],
        },
        controller: [ '$scope', '$images', '$unittypes', '$user', '$property', '$cloudinary', '$lambda', '$uibModal', 'toastr', '$state',
          function ($scope, $images, $unittypes, $user, $property, $cloudinary, $lambda, $uibModal, toastr, $state) {
            $scope.imgs = $images;
            $scope.images = $images;
            $scope.currentUser = $user.employee_id;

            var propertyId = '' + $property.propertyId;
            var folder = $state.params.folder;
            $state.current.title = folder;

            UploadImage($scope, propertyId, folder, $unittypes, $uibModal, $user, $cloudinary, $lambda, toastr, $state);
            ImageRank($scope, propertyId, $user, $lambda, toastr, $state);
          }
        ]
      });
  }

  function ImageRank($scope, propertyId, $user, $lambda, toastr, $state) {

    $scope.hasUpvoted = function (image) {
      return _.some(image.upvotedBy || [], function (o) {
        return $user.employee_id === o.username;
      });
    };

    $scope.hasDownvoted = function (image) {
      return _.some(image.downvotedBy || [], function (o) {
        return $user.employee_id === o.username;
      });
    };

    $scope.upvoteImage = function (image) {
      if ($scope.hasUpvoted(image)) {
        voteImage(image, 'unvote');
      } else {
        voteImage(image, 'upvote');
      }
    };

    $scope.downvoteImage = function (image) {
      if ($scope.hasDownvoted(image)) {
        voteImage(image, 'unvote');
      } else {
        voteImage(image, 'downvote');
      }
    };

    $scope.unvoteImage = function (image) {
      voteImage(image, 'unvote');
    };

    function voteImage(image, action) {
      image._updating = true;

      return $lambda.voteImage(propertyId, image.imageId, action, {
        id: $user.id,
        username: $user.employee_id,
        name: $user.display_name,
      })
      .then(function success(data) {
        console.log('success', data);
        _.assign(image, data);
        image._updating = false;
      }, function failure(data) {
        console.log('failure', data);
        image._updating = false;
      });
    }

  }

  function UploadImage($scope, propertyId, folder, unittypes, $uibModal, $user, $cloudinary, $lambda, toastr, $state) {
    var imageTags = [ 'autobot', 'property-' + propertyId, 'folder-' + folder ].join(',');

    $scope.uploadFile = function (file) {
      if (!file || file.$error) {
        return;
      }

      var ctx = _.map({
        product: 'autobot',
        propertyId: propertyId,
        folder: folder,
        uploadedBy: $user.employee_id,
      }, function (v, k) {
        return k + '=' + v;
      }).join('|');

      var context = {
        title: 'Upload Image',
        propertyId: propertyId,
        folder: folder,
        tags: imageTags,
        unittypes: unittypes,
        context: ctx,
        public_id: [ propertyId, folder ].join('/'),
      };

      var modal = confirmUpload($uibModal, context, $user, $lambda);
      modal.result.then(function success(res) {
        $state.reload($state.current.name);
        toastr.success('Upload completed successfully.');
      }, function failure(res) {
        if (!res) {
          return;
        }

        var err = _.get(res, 'error.data.error', false);
        if (err || (res.error && res.error.status === -1)) {
          toastr.error('Upload failed. Please try again.');
        }
      });

      $cloudinary.uploadFile(file, context)
        .then(function success() {
        }, function failure(data) {
          modal.$dismiss({ success: false, error: data });
        });
    };

    $scope.updateImageData = function (im) {
      if (!im || !im.imageId) {
        return;
      }

      var acl = $scope.$root.acl;
      var context = {
        title: 'Edit',
        propertyId: propertyId,
        folder: folder,
        unittypes: unittypes,
        image: im,
        success: im,
        canAdmin: ($user.employee_id === im.uploadedBy || acl.hasGlobalAccess() || acl.hasRWPermission(propertyId, 'images')),
      };

      var modal = updateImageData($uibModal, context, $user, $lambda);
      modal.result.then(function success(res) {
        if (res && res.status) {
          switch (res.status) {
            case 'UPDATED':
              _.assign(im, res.data);
              toastr.success('Image data updated.');
              break;

            case 'DELETED':
              toastr.success('Image deleted.');
              var imgIndex = $scope.images.indexOf(im);
              if (imgIndex !== -1) {
                $scope.images.splice(imgIndex, 1);
              }

              // $state.reload($state.current.name);
              break;
          }
        }

        // console.log('success', res);
        // $state.reload($state.current.name);

      }, function failure(res) {
        console.log('failure', res);
        if (!res) {
          return;
        }

        var err = _.get(res, 'error.data.error', false);
        if (err || (res.error && res.error.status === -1)) {
          toastr.error('Failed to update image data. Please try again.');
        }
      });
    }
  }


  function confirmUpload($uibModal, context, user, lambda) {
    return $uibModal.open({
      animation: false,
      templateUrl: 'app/pages/autobot/images/folder/upload.html',
      size: 'md',
      backdrop: 'static',
      resolve: { $context: context, $user: user, $lambda: lambda },
      controller: ['$scope', '$context', '$user', '$lambda', function ($scope, $context, $user, $lambda) {
        $scope.context = $context;
        $scope.unittypes = _.clone($context.unittypes);
        $scope.form = {};

        if (!_.isEmpty($scope.unittypes)) {
          $scope.unittypes.unshift({ id: -1, name: 'None' });
          $scope.form.unittype = $scope.unittypes[0];
        }

        $scope.save = function (form) {
          var imageData = getImageData(form);
          $context.submit = true;

          $lambda.createImage($context.propertyId, _.assign({
            cloudinaryId: $context.success.public_id,
            url: $context.success.secure_url,
            folder: $context.folder,
            score: 0,
            upvotedBy: [],
            downvotedBy: [],
            uploadedBy: $user.employee_id,
            users: _.fromPairs([
              [
                $user.employee_id,
                {
                  id: $user.id,
                  name: $user.display_name
                }
              ]
            ]),
          }, imageData))
          .then(function success(data) {
            $scope.$close();
          }, function failure(data) {
            $scope.$dismiss({ success: false, error: data });
          });
        };

        $scope.cancel = function () {
          $scope.$dismiss();
        };

      }]
    });
  }

  function updateImageData($uibModal, context, user, lambda) {
    return $uibModal.open({
      animation: false,
      templateUrl: 'app/pages/autobot/images/folder/upload.html',
      size: 'md',
      backdrop: 'static',
      resolve: { $context: context, $user: user, $lambda: lambda },
      controller: ['$scope', '$context', '$user', '$lambda', function ($scope, $context, $user, $lambda) {
        $scope.context = $context;
        $scope.unittypes = _.clone($context.unittypes);
        $scope.form = {};

        var image = $context.image;

        $scope.reset = function () {
          if (!_.isEmpty($scope.unittypes)) {
            $scope.unittypes.unshift({ id: -1, name: 'None' });
          }

          var imageData = {
            propertyAmenities: tagsToCsv(image.propertyAmenities || []),
            unitAmenities: tagsToCsv(image.unitAmenities || []),
            locations: tagsToCsv(image.locations || []),
            views: tagsToCsv(image.views || []),
          };

          if (image.unittypeId && image.unittype) {
            imageData.unittype = {
              id: image.unittypeId,
              name: image.unittype
            };

            imageData.isModelUnit = (image.isModelUnit === true);
          } else if (!_.isEmpty($scope.unittypes)) {
            imageData.unittype = $scope.unittypes[0];
          }

          _.assign($scope.form, imageData);
          console.log('ut', $scope.form.unittype);
        };

        $scope.save = function (form) {
          var imageData = getImageData(form);
          $context.submit = true;

          $lambda.updateImage($context.propertyId, image.imageId, imageData)
            .then(function success(data) {
              $scope.$close({ status: 'UPDATED', data: data });
            }, function failure(data) {
              $scope.$dismiss({ success: false, error: data });
            });
        };

        $scope.delete = function (image) {
          if (!image || !image.imageId) {
            return;
          }

          $context.submit = true;
          $context.title = 'Deleting Image';

          $lambda.deleteImage($context.propertyId, image.imageId)
            .then(function success(data) {
              $scope.$close({ status: 'DELETED', data: data });
            }, function failure(data) {
              $scope.$dismiss({ success: false, error: data });
            });
        };

        $scope.cancel = function () {
          $scope.$dismiss();
        };

        $scope.reset();
      }]
    });
  }

  function getImageData(form) {
    var imageData = {
      propertyAmenities: csvToTags(form.propertyAmenities),
      unitAmenities: csvToTags(form.unitAmenities),
      locations: csvToTags(form.locations),
      views: csvToTags(form.views),
    };

    if (form.unittype && form.unittype.id !== -1 && form.unittype.name) {
      imageData.unittypeId = form.unittype.id;
      imageData.unittype = form.unittype.name;
      imageData.isModelUnit = (form.isModelUnit === true);
    } else {
      imageData.unittypeId = null;
      imageData.unittype = null;
      imageData.isModelUnit = false;
    }

    return imageData;
  }

  function csvToTags(csv) {
    return _.map((csv || '').toLowerCase().split(','), _.trim).filter(function (s) {
      return !_.isEmpty(s);
    });
  }

  function tagsToCsv(tags) {
    return _.map(tags, _.trim).join(',');
  }

})();

(function () {
  'use strict';

  angular.module('pages.autobot.jobs.view', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('root.autobot.job.view', {
        // parent: 'root.autobot.job',
        url: '/view',
        templateUrl: 'app/pages/autobot/jobs/view/index.html',
        controller: function ($rootScope, $scope, $user, $job, $property, $lambda, toastr, $state) {
          $scope.form = $job;

          var tabs = [ 'unittype', 'title', 'description', 'contact', 'options' ];
          var tabIndex = tabs.indexOf(_.get($state, 'current.name', '').split('.').pop());
          $scope.activeTab = tabIndex !== -1 ? tabIndex : 0;
        }
      })
      .state('root.autobot.jobs.view.unittype', {
        // parent: 'root.autobot.jobs.view',
        url: '/unittype'
      })
      .state('root.autobot.jobs.view.title', {
        // parent: 'root.autobot.jobs.view',
        url: '/title'
      })
      .state('root.autobot.jobs.view.description', {
        // parent: 'root.autobot.jobs.view',
        url: '/description'
      })
      .state('root.autobot.jobs.view.contact', {
        // parent: 'root.autobot.jobs.view',
        url: '/contact'
      })
      .state('root.autobot.jobs.view.options', {
        // parent: 'root.autobot.jobs.view',
        url: '/options'
      });
  }

})();

(function () {
  'use strict';

  angular.module('pages.autobot.listings.create', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('root.autobot.listings.create', {
        parent: 'root.autobot',
        url: '/create',
        templateUrl: 'app/pages/autobot/listings/create/index.html',
        controller: function ($rootScope, $scope, $user, $sharedState, $state, $property, $lambda, toastr, $progressModal) {

          var tabs = [ 'floorplan', 'title', 'description', 'contact', 'options' ];
          var currTabIndex = tabs.indexOf(($state.current.url || '').slice(1));
          $scope.activeTab = currTabIndex !== -1 ? currTabIndex : 0;

          var repeatCount = 5;
          var specials = [
            'Summer price drop',
            'One month free, no deposit',
            'Blowout rents, $99 security deposit',
            'Limited time. No admin fee',
            '$$$ off your rent',
          ];

          var titles = [
            'Your new home at [name]',
            'Brand new appliances, beautiful landscaping',
            'Your luxury home at [name]',
            'Come join our beautiful community',
            'Join us at [name]',
          ].map(function (s) {
            return s.replace('[name]', $property.name);
          });

          var callToAct = [
            'Call [phone] now',
            'call at [phone]',
            'Contact [phone]'
          ];

          var blings = [ '✿', '★', '❤', '✦', '✪', '☼', '♔', '✤', '❀', '❂', '⨀', '❖', '❈', '✲', '❁', '☀', '☀', '✫' ];
          var priceBlings = [ '☛', '▼', '⋙', '➣' ];
          var callToActBlings = [ '☎', '☏', '⇒', '✱', '⋗', '➠', '☛' ];

          $scope.reset = function () {
            $scope.validations = {};

            $scope.form = {
              sqft: '',
              beds: '1',
              baths: '1',
              region: $property.state,
              email: $property.email,
              phone: $property.phone,
              website: $property.website,
              cats: true,
              dogs: true,
            };

            generateTitles($scope.form);
            generateDescriptions($scope.form);
          };

          $scope.createListing = function (form) {
            var listing = angular.copy(form);
            // listing.debug = true;
            listing.titles = [];
            listing.descriptions = [];
            $scope.validations = {};

            _.times(repeatCount, function (i) {
              var idx = i + 1;
              var prop = 'title' + idx;
              if (!_.isEmpty(listing[prop])) {
                listing.titles.push(replaceTmplVars(_.trim(listing[prop]), listing));
                delete listing[prop];
              }

              prop = 'description' + idx;
              if (!_.isEmpty(listing[prop])) {
                listing.descriptions.push(replaceTmplVars(_.trim(listing[prop]), listing));
                delete listing[prop];
              }
            });

            if (!listing.titles.length) {
              $scope.validations.titles = { error: true };
              $scope.validations.error = true;
              return;
            }

            if (!listing.descriptions.length) {
              $scope.validations.descriptions = { error: true };
              $scope.validations.error = true;
              return;
            }

            console.log('listing', listing);

            // if (form)

            // alert(JSON.stringify($scope.form));
            // var data = { listing: form };
            // $state.go('root.autobot.listings');
            $progressModal.open();

            $lambda.createListing($state.params.propertyId, { listing: listing })
              .then(function success(res) {
                console.log('new listing', res);
                $progressModal.close();
                toastr.success('Listing created successfully!');

                $state.go('root.autobot.listings');
              }, function error(res) {
                $progressModal.close();
                console.log('error', res);
                toastr.error('An error occurred. Please try again.');
              });
          };

          $scope.generateTitles = generateTitles;
          $scope.generateDescriptions = generateDescriptions;

          $scope.reset();

          var tmplVars = ['rent', 'phone'];

          function updateGenerated() {
            _.times(repeatCount, function (i) {
              var idx = '' + (i + 1);

              if ($scope.form['title' + idx]) {
                $scope.form['title' + idx] = replaceTmplVars($scope.form['title' + idx], $scope.form);
              }

              if ($scope.form['description' + idx]) {
                $scope.form['description' + idx] = replaceTmplVars($scope.form['description' + idx], $scope.form);
              }
            });
          }

          function replaceTmplVars(str, form) {
            if (!str) return str;

            var x = str + '';
            _.each(tmplVars, function (prop) {
              if (form[prop] > 0) {
                x = x.replace('[' + prop + ']', form[prop]);
              }
            });

            return x;
          }

          function generateTitles(form) {
            var ph = (form.phone || '').replace(/ /, '-').replace(/[\(\)]/g, '');
            var maxLength = 70;
            // var callToActMsgs = ph ? callToAct.map(function (s) {
            //   return s.replace('[phone]', ph);
            // }) : callToAct;

            _.times(repeatCount, function (i) {
              var useBling = _.sample([ true , false ]);
              var priceBling = useBling ? _.sample(_.sample([ priceBlings, blings ])) : '';
              var specialsBling = useBling ? _.sample(blings) : '';
              var callBling = useBling ? _.sample(callToActBlings) : '';
              var sep = _.sample([ !useBling ? '. ' : ' ', ' – ', ' – ' ]);

              var title = [
                (priceBling + ' $' + (form.rent || '[rent]')).trim(),
                ([ specialsBling, _.sample(specials), specialsBling ].join(' ')).trim(),
              ].join(sep);

              // attempt to fit titles
              _.times(titles.length, function () {
                var t = _.sample(titles);
                var temp = [ title, t ].join(sep);

                if (temp.length <= maxLength) {
                  console.log('set title', temp);
                  title = temp;
                  return false;
                } else {
                  console.log('too long', temp, temp.length);
                }
              });

              // if (form.phone) {
              //   parts.push((callBling + ' ' + _.sample(callToActMsgs)).trim());
              // }

              form['title' + (i + 1)] = title.slice(0, maxLength);
            });

            if ($scope.validations.titles) {
              delete $scope.validations.titles;
            }
          }

          function generateDescriptions(form) {
            form = form || {};
            var genDesc = ($property.description || '').replace(/welcome to [^\.]+\.\s+/i, '');
            var commAmenities = $property.amenities.community || [];
            var aptAmenities = $property.amenities.apartment || [];

            _.times(repeatCount, function (i) {
              var sep = _.sample([ '*', '-', 'o', '•', '◦', '⁃', '–', '‒', '᠆' ]) + '  ';
              var commDesc = generateAmenitiesDesc(commAmenities, sep);
              var aptDesc = generateAmenitiesDesc(aptAmenities,sep);
              form['description' + (i + 1)] = genDesc + "\r\n\r\n" + _.shuffle([ commDesc, aptDesc ]).join("\r\n");
            });

            if ($scope.validations.descriptions) {
              delete $scope.validations.descriptions;
            }
          }

          function generateAmenitiesDesc(amenities, sep) {
            amenities = amenities.map(function (am) {
              return am.replace(/\*/, '');
            });

            var len = Math.min(Math.max(3, _.random(0, amenities.length)), amenities.length >> 1);
            return sep + _.shuffle(_.sampleSize(amenities, len)).join("\r\n" + sep);
          }
        }
      })
      .state('root.autobot.listings.create.title', {
        parent: 'root.autobot.listings.create',
        url: '/title'
      })
      .state('root.autobot.listings.create.description', {
        parent: 'root.autobot.listings.create',
        url: '/description'
      })
      .state('root.autobot.listings.create.contact', {
        parent: 'root.autobot.listings.create',
        url: '/contact'
      })
      .state('root.autobot.listings.create.options', {
        parent: 'root.autobot.listings.create',
        url: '/options'
      })
      .state('root.autobot.listings.create.floorplan', {
        parent: 'root.autobot.listings.create',
        url: '/floorplan'
      });
  }

})();

(function () {
  'use strict';

  angular.module('pages.autobot.listings.edit', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('root.autobot.listing.edit', {
        parent: 'root.autobot.listing',
        url: '/edit',
        templateUrl: 'app/pages/autobot/listings/edit/index.html',
        controller: function ($rootScope, $scope, $user, $listing, $sharedState, $property) {
          console.log('edit', $listing);
          $scope.listing = $listing;
        }
      });
  }

})();

(function () {
  'use strict';

  angular.module('pages.autobot.listings.view', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('root.autobot.listing.view', {
        // parent: 'root.autobot.listing',
        url: '/view',
        templateUrl: 'app/pages/autobot/listings/view/index.html',
        controller: function ($rootScope, $scope, $user, $listing, $property, $lambda, toastr, $state) {
          $scope.form = $listing;

          var tabs = [ 'unittype', 'title', 'description', 'contact', 'options' ];
          var tabIndex = tabs.indexOf(_.get($state, 'current.name', '').split('.').pop());
          $scope.activeTab = tabIndex !== -1 ? tabIndex : 0;

          $scope.deleteListing = function () {
            $lambda.deleteListing($property.propertyId, $listing.listingId)
              .then(function success(res) {
                toastr.success('Listing deleted successfully.');
                $state.go('root.autobot.listings', { propertyGroupId: $property.propertyId });
              }, function error(res) {
                toastr.error('Failed to delete listing.');
              });
          };
        }
      })
      .state('root.autobot.listing.view.unittype', {
        // parent: 'root.autobot.listing.view',
        url: '/unittype'
      })
      .state('root.autobot.listing.view.title', {
        // parent: 'root.autobot.listing.view',
        url: '/title'
      })
      .state('root.autobot.listing.view.description', {
        // parent: 'root.autobot.listing.view',
        url: '/description'
      })
      .state('root.autobot.listing.view.contact', {
        // parent: 'root.autobot.listing.view',
        url: '/contact'
      })
      .state('root.autobot.listing.view.options', {
        // parent: 'root.autobot.listing.view',
        url: '/options'
      });
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('MTLChild').run(['$templateCache', function($templateCache) {$templateCache.put('app/components/pageTop/pageTop.html','<div ng-if="$root.user" class="page-top clearfix" max-height="50" scroll-position="scrolled" ng-class="{\'scrolled\': scrolled}"><a href="" class="al-logo hidden-xs clearfix"><h1 class="al-title">{{ activePageTitle }}</h1></a> <a ng-if="$state.current.name !== \'root.global\' && $root.property" href="" class="ng-cloak collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div ng-if="$state.current.name !== \'root.global\'" ng-controller="SelectPropertyPanelCtrl as vm" class="ng-cloak mc-search"><ui-select ng-model="vm.property" ng-show="vm.loaded" ng-disabled="!vm.properties.length" search-enabled="true" skip-focusser="true" on-select="vm.onSelect($item)" class="btn-group bootstrap-select form-control"><ui-select-match placeholder="Choose Property">{{ vm.selected.name }}</ui-select-match><ui-select-choices repeat="b in vm.properties | filter: $select.search" position="down"><span ng-bind-html="b.name | highlight: $select.search"></span><br><small ng-bind-html="((b.city) + \', \' + (b.state)) | highlight: $select.search"></small></ui-select-choices></ui-select><p ng-if="!vm.loaded" class="label-light" style="margin: 10px;">Loading properties...</p></div><button ng-if="$state.current.name !== \'root.global\' && $root.acl.canAccess(\'global.\')" ng-click="$state.go(\'root.global\');" class="ng-cloak btn btn-primary btn-with-icon" style="background-color:transparent; color:#209e91"><i class="ion-earth"></i>Global</button><div ng-controller="LoginSessionCtrl" class="user-profile clearfix"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><span class="fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x"></i> <i class="fa fa-user fa-stack-1x fa-inverse"></i></span></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li ng-if="user"><a><i class="fa fa-user"></i>{{ user.display_name }}</a></li><li><a href="#/logout" ng-click="logout()" class="signout"><i class="fa fa-power-off"></i>Sign out</a></li></ul></div></div></div>');
$templateCache.put('app/components/progressModal/progressModal.html','<div class="loading-container center-block progress-bar-round"><div class="loading"></div></div>');
$templateCache.put('app/pages/autobot/index.html','<ba-sidebar ng-if="$state.current.name !== \'root.global\' && $root.property"></ba-sidebar><page-top></page-top><div class="al-main"><div class="al-content"><content-top></content-top><div ng-if="$state.current.name === \'root\'" class="banner"><div class="large-banner-wrapper"></div><div class="banner-text-wrapper"><div class="banner-text"><h1>Autobot</h1><p ng-if="!$root.loadingProperties && !$root.property">Please select a property.</p></div></div></div><div ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div><footer class="al-footer clearfix"></footer><back-top></back-top>');
$templateCache.put('app/pages/autobot/global/index.html','<ba-sidebar ng-if="$state.current.name != \'root.global\'"></ba-sidebar><div class="row" style="margin-top: 2rem; padding: 4px"><div class="col-sm-12"><a ng-if="$resolve.$previousState.name" href="{{ $resolve.$previousState.url }}" class="btn btn-default btn-with-icon"><i class="ion-android-arrow-back"></i>Back</a></div></div><div style="margin-top: 1rem;" ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Properties" ng-if="$root.acl.canAccess(\'global.properties\')"><div ng-include="\'app/pages/autobot/global/properties.html\'"></div></uib-tab><uib-tab heading="Captions" ng-if="$root.acl.canAccess(\'global.templates\')"><form name="listing" class="form-horizontal" ng-init="reset()"><div style="margin-top: 0rem; margin-right: 0rem; margin-bottom: 2rem; border-bottom: 1px #444 solid; padding:6px;" class="text-right"><button type="button" class="btn btn-primary btn-with-icon" ng-click="saveTemplate(form)" ng-disabled="listing.$pristine || listing.$invalid"><i class="ion-paper-airplane"></i> Save</button></div><div class="row" style="margin-bottom: 4rem;"><div class="col-sm-6 text-center" style="padding:16px; font-size: 160%; text-decoration: underline;"><strong>Value Titles</strong></div><div class="col-sm-6 text-center" style="padding:16px; font-size: 160%; text-decoration: underline;"><strong>Luxury Titles</strong></div></div><div class="row" style="margin-bottom: 4rem;border-bottom: 1px solid #444;"><div class="col-sm-6 col-xs-6" style="border-right: 1px solid #444;"><div ng-include="\'app/pages/autobot/templates/titles.html\'"></div></div><div class="col-sm-6 col-xs-6"><div ng-include="\'app/pages/autobot/global/luxury_titles.html\'"></div></div></div><div class="row" style="margin-bottom: 4rem;"><div class="col-sm-6 text-center" style="padding:16px; font-size: 160%; text-decoration: underline;"><strong>Seasonal Value Titles</strong></div><div class="col-sm-6 text-center" style="padding:16px; font-size: 160%; text-decoration: underline;"><strong>Seasonal Luxury Titles</strong></div></div><div class="row" style="margin-bottom: 4rem;border-bottom: 1px solid #444;"><div class="col-sm-6 col-xs-6" style="border-right: 1px solid #444;"><div ng-include="\'app/pages/autobot/templates/seasonal_titles.html\'"></div></div><div class="col-sm-6 col-xs-6"><div ng-include="\'app/pages/autobot/global/luxury_seasonal_titles.html\'"></div></div></div><div class="row" style="margin-bottom: 4rem;"><div class="col-sm-6 text-center" style="padding:16px; font-size: 160%; text-decoration: underline;"><strong>Amenities</strong></div></div><div class="row" style="margin-bottom: 4rem;border-bottom: 1px solid #444;"><div class="col-sm-6 col-xs-6" style="border-right: 1px solid #444;"><div ng-include="\'app/pages/autobot/templates/amenities.html\'"></div></div></div></form></uib-tab><uib-tab heading="Phone Verification Required" ng-if="$root.acl.canAccess(\'global.phoneverif\')"><div ng-include="\'app/pages/autobot/global/phoneVerifRequired.html\'"></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/autobot/global/luxury_seasonal_titles.html','<div class="text-right" style="padding: 8px 16px 32px 16px;"><button type="button" class="btn btn-default btn-with-icon btn-sm" ng-click="addTitle(form.luxury_seasonal_titles,true)"><i class="ion-plus-round"></i> Add title</button></div><div class="row" style="margin-bottom: 1.6rem;"><div class="col-sm-5 text-left" style="padding-left:40px;"><strong>Title</strong></div><div class="col-sm-2 text-center" style="padding-right: 40px;"><strong>English/Spanish</strong></div><div class="col-sm-2 text-center" style="padding-right: 40px;"><strong>Active from</strong></div><div class="col-sm-2 text-center" style="padding-right: 40px;"><strong>Active until</strong></div><div class="col-sm-1"></div></div><div style="min-height: 270px;"><div ng-repeat="t in form.luxury_seasonal_titles" id="field-luxury_seasonal_title-{{ $index }}" class="form-group"><div class="col-sm-5"><input name="luxury_seasonal_title_{{ $index }}" type="text" class="form-control" maxlength="2000" ng-model="t.title" ng-required="true" ng-class="{\'has-error\': listing.luxury_seasonal_title_{{ $index }}.$dirty && listing.luxury_seasonal_title_{{ $index }}.$invalid }"></div><div class="col-sm-2 text-center"><ba-switcher switcher-value="t.english" switcher-style="info" switcher-on-label="EN" switcher-off-label="ES"></ba-switcher></div><div class="col-sm-2 text-center"><p class="input-group"><input type="text" name="luxury_seasonal_title_fromdate_{{ $index }}" class="form-control" onkeydown="return false" uib-datepicker-popup="dd-MMM" ng-class="{\'has-error\': listing.luxury_seasonal_title_fromdate_{{ $index }}.$dirty && listing.luxury_seasonal_title_fromdate_{{ $index }}.$invalid }" ng-model="t.fromdate" ng-model-options="{ timezone: \'UTC\' }" is-open="luxury_seasonal_title_date[$index].$from_opened" ng-required="true" ng-change="validateFromToDates(form,t.fromdate,t.todate, listing.luxury_seasonal_title_fromdate_{{ $index }})" close-text="Close" show-button-bar="false" datepicker-options="{showWeeks:false}"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="luxury_seasonal_title_date[$index].$from_opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2 text-center"><p class="input-group"><input type="text" name="luxury_seasonal_title_todate_{{ $index }}" class="form-control" onkeydown="return false" uib-datepicker-popup="dd-MMM" ng-class="{\'has-error\': listing.luxury_seasonal_title_todate_{{ $index }}.$dirty && listing.luxury_seasonal_title_todate_{{ $index }}.$invalid }" ng-model="t.todate" ng-model-options="{ timezone: \'UTC\' }" is-open="luxury_seasonal_title_date[$index].$to_opened" ng-required="true" ng-change="validateFromToDates(form,t.fromdate,t.todate, listing.luxury_seasonal_title_todate_{{ $index }})" close-text="Close" show-button-bar="false" datepicker-options="{showWeeks:false}"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="luxury_seasonal_title_date[$index].$to_opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-1 text-right"><button type="button" class="btn btn-danger" ng-confirm="" confirm-ok="deleteTitle(form.luxury_seasonal_titles, $index)"><i class="ion-trash-b"></i></button></div></div></div>');
$templateCache.put('app/pages/autobot/global/luxury_titles.html','<div class="text-right" style="padding: 8px 16px 32px 16px;"><button type="button" class="btn btn-default btn-with-icon btn-sm" ng-click="addTitle(form.luxury_titles,false)"><i class="ion-plus-round"></i> Add title</button></div><div class="row" style="margin-bottom: 1.6rem;"><div class="col-sm-8 text-left" style="padding-left:40px;"><strong>Title</strong></div><div class="col-sm-2 text-center" style="padding-right: 40px;"><strong>English/Spanish</strong></div><div class="col-sm-2"></div></div><div style="min-height: 270px;"><div ng-repeat="t in form.luxury_titles" id="field-luxury_title-{{ $index }}" class="form-group"><div class="col-sm-8"><input name="luxury_title_{{ $index }}" type="text" class="form-control" maxlength="2000" ng-model="t.title" ng-required="true" ng-class="{\'has-error\': listing.luxury_title_{{ $index }}.$dirty && listing.luxury_title_{{ $index }}.$invalid }"></div><div class="col-sm-2 text-center"><ba-switcher switcher-value="t.english" switcher-style="info" switcher-on-label="EN" switcher-off-label="ES"></ba-switcher></div><div class="col-sm-2 text-right"><button type="button" class="btn btn-danger" ng-confirm="" confirm-ok="deleteTitle(form.luxury_titles, $index)"><i class="ion-trash-b"></i></button></div></div></div>');
$templateCache.put('app/pages/autobot/global/phoneVerifRequired.html','<table ng-if="$resolve.$accountsInPhoneVerif.length > 0" datatable="ng" dt-options="{ dom: \'trp\', paging: true, pageLength: 50 }" class="table table-hover"><thead><tr class="black-muted-bg2 table-hdr"><th>Property</th><th>Account</th><th>Post Link</th><th>Account created on</th><th>Last posted on</th></tr></thead><tbody><tr ng-repeat="account in $resolve.$accountsInPhoneVerif" data-property-id="{{ account.propertyId }}"><td style="cursor: pointer;"><a target="_blank" href="{{ $state.href(\'root.autobot.settings\', { \'propertyId\': account.propertyId }) }}">{{ ::account.property_name }}</a></td><td>{{ ::account.username }}</td><td>{{ ::account.lastDraftURL }}</td><td>{{ ::account.createdAt | date:\'MM/dd/yyyy\' }}</td><td><span am-time-ago="(account.lastUsedAt / 1000) | amFromUnix"></span></td></tr></tbody></table><div ng-if="!$resolve.$accountsInPhoneVerif.length" class="banner"><div class="large-banner-wrapper"></div><div class="banner-text-wrapper"><div class="banner-text"><p>No accounts found.</p></div></div></div>');
$templateCache.put('app/pages/autobot/global/properties.html','<div class="row"><div class="col-xs-6 col-sm-12 col-lg-10"><div class="row" style="margin-bottom: 1.6rem;"><div class="col-sm-3 text-left" style="padding-left:40px;"><strong>Property</strong></div><div class="col-sm-1 text-center" style="padding-right: 40px;"><strong>Posting Enabled</strong></div><div class="col-sm-1 text-center" style="padding-right: 40px;"><strong>Language</strong></div><div class="col-sm-1 text-center" style="padding-right: 40px;"><strong>Luxury/Value</strong></div><div class="col-sm-2 text-center" style="padding-right: 40px;"><strong>Phone #</strong></div><div class="col-sm-3 text-center" style="padding-right: 40px;"><strong>Email</strong></div><div class="col-sm-1"></div></div><div ng-repeat="p in $resolve.$autobotProperties | orderBy:\'name\'" id="field-property-{{ $index }}" class="row form-group clearfix"><div class="col-sm-3" style="padding-right: 2px;"><label class="form-control">{{p.name}}</label></div><div class="col-sm-1 text-center" style="padding-right: 2px;"><ba-switcher switcher-ref="{{ $index }}" switcher-value="p.postingEnabled" switcher-style="info" switcher-on-label="YES" switcher-off-label="NO"></ba-switcher></div><div class="col-sm-1 text-center" style="padding-right: 2px;"><ba-switcher switcher-ref="{{ $index }}" switcher-value="p.property_language" switcher-style="info" switcher-on-label="ALL" switcher-off-label="EN"></ba-switcher></div><div class="col-sm-1 text-center" style="padding-right: 2px;"><ba-switcher switcher-ref="{{ $index }}" switcher-value="p.property_type" switcher-style="info" switcher-on-label="LUX" switcher-off-label="VAL"></ba-switcher></div><div class="col-sm-2"><input name="posting_phone_number_{{ $index }}" tel-format="" type="text" class="form-control" maxlength="14" ng-model="p.posting_phone_number" ng-required="true" ng-class="{\'has-error\': listing.posting_phone_number_{{ $index }}.$dirty && listing.posting_phone_number_{{ $index }}.$invalid }"></div><div class="col-sm-3"><input name="posting_email_{{ $index }}" type="text" class="form-control" maxlength="50" ng-model="p.posting_email" ng-required="true" ng-class="{\'has-error\': listing.posting_email_{{ $index }}.$dirty && listing.posting_email_{{ $index }}.$invalid }"></div><div class="col-sm-1 text-left"><button type="button" class="btn btn-primary" ng-click="updateProperty(p.propertyId, p)"><i class="ion-paper-airplane"></i></button></div></div></div></div>');
$templateCache.put('app/pages/autobot/images/index.html','<div class="row pie-charts"><div class="pie-chart-item-container" ng-repeat="f in folders"><a ui-sref="^.images-folder({ folder: \'{{ f.name }}\' })"><div ba-panel=""><div class="pie-chart-item" style="margin-top: 5px;"><div class="chart"><i class="ion-ios-folder-outline" style="font-size: 6rem;"></i></div><div class="description" style="padding-top: 26px;"><div>{{ ::f.label }}</div><div class="description-stats"></div></div></div></div></a></div></div>');
$templateCache.put('app/pages/autobot/jobs/index.html','<div ng-include="\'app/pages/autobot/jobs/report.html\'"></div><br><h2>Recent Posts</h2><br><table ng-if="jobs.length > 0" datatable="ng" dt-options="dtOptions" ng-init="columns = [\'Sort\', \'Image\', \'Unit Type\', \'Floorplan\', \'Title\', \'Posting Region\', \'Status\', \'Link\', \'Posted at\']" class="table table-hover"><thead><tr class="black-muted-bg2 table-hdr"><th ng-repeat="col in columns" title="{{ col }}">{{ col }}</th></tr></thead><tbody><tr ng-repeat="j in jobs" ng-init="cloudinaryURL = getPostingScreenshot(j)" data-property-id="{{ j.propertyId }}" data-listing-id="{{ j.jobId }}"><td>{{ ::j.completedAt }}</td><td><a target="_blank" href="{{ ::cloudinaryURL }}"><cl-image public-id="{{ ::getCloudinaryId(cloudinaryURL) }}" class="thumbnail" secure="true" width="150" height="150" crop="fill" gravity="north" quality="80" format="jpg" style="margin: 12px 0;"></cl-image></a></td><td>{{ ::j.unittypeName }}</td><td>{{ ::j.floorplanName }}</td><td style="text-align: left" class="nowrap cut-with-dots">{{ ::j.title }}</td><td class="nowrap"><span style="margin: 0 4px;">{{ ::j.region }}</span> <i class="ion-arrow-right-b text-muted" ng-if="::j.subregion"></i> <span style="margin: 0 4px;">{{ ::j.subregion }}</span> <i class="ion-arrow-right-b text-muted" ng-if="::j.neighborhood"></i> <span>{{ ::j.neighborhood }}</span></td><td><label ng-if="!j.isApp && !j.postingURL && j.draftURL && isRecent(j.completedAt)" title="{{ j.account }}" class="tag label label-default"><i class="ion-clock"></i> Awaiting verification</label> <label ng-if="!j.isApp && !j.postingURL && j.draftURL && !isRecent(j.completedAt) && j.raw_verify.error_reason === \'PHONE VERIFICATION\'" title="{{ j.account }}" class="tag label label-default"><i class="ion-alert-circled"></i> {{ j.account }} required phone verification</label> <label ng-if="!j.isApp && (!j.postingURL && j.status !== \'VERIFIED\') && j.draftURL && !isRecent(j.completedAt) && j.raw_verify.error_reason !== \'PHONE VERIFICATION\'" title="{{ j.account }}" class="tag label label-default"><i class="ion-alert-circled"></i> {{ j.account }} possible mail forwarding error</label> <label ng-if="!j.draftURL && j.status === \'FAILED\'" title="{{ j.account }}" class="tag label label-danger"><i class="ion-alert-circled"></i> ERROR</label> <label ng-if="!j.isApp && (j.postingURL || j.status === \'VERIFIED\')" title="{{ j.account }}" class="tag label label-success"><i class="ion-checkmark-circled"></i> Verified</label> <label ng-if="j.isApp" title="{{ j.account }}" class="tag label label-info" style="background-color: #5bc0de;"><i class="ion-laptop"></i> App</label> <label ng-if="j.isApp && j.status === \'COMPLETED\'" title="{{ j.account }}" class="tag label label-success" style="margin-left: 1rem"><i class="ion-paper-airplane"></i> Posted</label> <label ng-if="!j.isApp && j.status === \'VERIFIED\' && j.flagged" title="{{ j.flaggedAt | date:\'medium\' }}" class="tag label label-danger" style="margin-left: 1rem"><i class="ion-flag"></i> Flagged</label> <label ng-if="!j.isApp && j.status === \'VERIFIED\' && !j.flagCheckedAt && !isRecent(j.completedAt)" title="Flagging check skipped" class="tag label label-grayed" style="margin-left: 1rem"><i class="ion-help-circled"></i> Flagging check skipped</label> <label ng-if="!j.isApp && j.status === \'VERIFIED\' && !j.flagCheckedAt && isRecent(j.completedAt)" title="Flagging check pending" class="tag label label-grayed" style="margin-left: 1rem"><i class="ion-help-circled"></i> Flagging check pending</label></td><td><a ng-if="!j.postingURL && j.draftURL" href="{{ j.draftURL }}" rel="roopener noreferrer" target="_blank" class="btn btn-xs btn-default">View Draft</a> <a ng-if="j.postingURL" href="{{ j.postingURL }}" rel="roopener noreferrer" target="_blank" class="btn btn-xs btn-default">View Post</a></td><td><span title="{{ j.completedAt | date:\'medium\' }}" am-time-ago="j.completedAt"></span></td></tr></tbody></table><div ng-if="!jobs.length" class="banner"><div class="large-banner-wrapper"></div><div class="banner-text-wrapper"><div class="banner-text"><p>No jobs found.</p></div></div></div>');
$templateCache.put('app/pages/autobot/jobs/report.html','<div class="row"><div ng-repeat="r in $resolve.$report.keys" class="col-md-3 report-panel" ba-panel="" ba-panel-title="{{ $resolve.$report.titles[$index] }}"><div class="row"><div class="col-md-3 text-center"><div class="info cut-with-dots nowrap" title="Attempted"><span>Attempted</span></div><h2>{{ ::$resolve.$report[r].verified + $resolve.$report[r].completed }}</h2></div><div class="col-md-3 text-center"><div class="info cut-with-dots nowrap" title="Verified"><span>Verified</span></div><h2>{{ ::$resolve.$report[r].verified }}</h2></div><div class="col-md-3 text-center"><div class="info cut-with-dots nowrap" title="Flagged"><span>Flagged</span></div><h2>{{ ::$resolve.$report[r].flagged }}</h2></div><div class="col-md-3 text-center"><div class="info cut-with-dots nowrap" title="Accounts Used"><span>Accts. Used</span></div><h2>{{ ::$resolve.$report[r].accounts }}</h2></div></div></div></div><div ng-if="$resolve.$report.year.verified < $resolve.$report.year.completed" class="row"><div class="col-xs-12"><div class="alert bg-warning inline-block"><i class="ion-alert-circled"></i>&nbsp; <strong>Please reach out to your IT department to ensure e-mail accounts are configured for forwarding emails to&nbsp; <label class="tag label label-default">autobot+{{ $state.params.propertyId }}@mtlchild.com</label></strong></div></div></div>');
$templateCache.put('app/pages/autobot/listings/index.html','<ui-view></ui-view><div ng-include="\'app/pages/autobot/jobs/report.html\'"></div><div class="text-right" style="padding: 16px;"><button ng-if="::canAccessJobs" type="button" class="btn btn-primary btn-with-icon" ng-click="$state.go(\'root.autobot.jobs\')"><i class="ion-ios-paperplane"></i> Posts</button></div><table ng-if="listings.length > 0" datatable="ng" dt-options="dtOptions" ng-init="columns = [\'Sort\', \'Unit Type\', \'Floorplan\', \'Title\', \'Beds\', \'Baths\', \'Updated\']" class="table table-hover"><thead><tr class="black-muted-bg2 table-hdr"><th ng-repeat="col in columns" title="{{ col }}">{{ col }}</th></tr></thead><tbody><tr ng-repeat="l in listings" data-property-id="{{ l.propertyId }}" data-listing-id="{{ l.listingId }}" style="cursor: pointer;"><td>{{ ::l.updatedAt }}</td><td>{{ ::l.unittypeName }}</td><td>{{ ::l.floorplanName }}</td><td style="text-align: left" class="nowrap cut-with-dots">{{ ::l.titles[0] }}</td><td>{{ ::l.beds }}</td><td>{{ ::l.baths }}</td><td><span am-time-ago="(l.updatedAt / 1000) | amFromUnix"></span></td></tr></tbody></table><div ng-if="!listings.length" class="banner"><div class="large-banner-wrapper"></div><div class="banner-text-wrapper"><div class="banner-text"><p>No listings found.</p></div></div></div>');
$templateCache.put('app/pages/autobot/settings/index.html','<div class="row"><div class="col-sm-6 col-xs-12" ng-init="pr = postingRegions" ba-panel="" ba-panel-class="extra-medium-panel-height with-scroll" ba-panel-title="Posting Regions"><div ng-include="\'app/pages/autobot/settings/postingRegions.html\'"></div></div><div class="col-sm-6 col-xs-12" ng-init="pa = postingAccounts" ba-panel="" ba-panel-class="extra-medium-panel-height with-scroll" ba-panel-title="Posting Accounts"><div ng-include="\'app/pages/autobot/settings/postingAccounts.html\'"></div></div><div class="col-sm-6 col-xs-12" ng-init="pd = propertyDefaults" ba-panel="" ba-panel-title="Property Defaults"><div ng-include="\'app/pages/autobot/settings/propertyDefaults.html\'"></div></div><div class="col-sm-6 col-xs-12" ng-init="pc = postingConfig" ba-panel="" ba-panel-class="extra-medium-panel-height with-scroll" ba-panel-title="Posting Config"><div ng-include="\'app/pages/autobot/settings/postingConfig.html\'"></div></div><div class="col-sm-6 col-xs-12" ng-init="pac = postingAccounts" ba-panel="" ba-panel-class="extra-medium-panel-height" ba-panel-title="Phone verification"><div ng-include="\'app/pages/autobot/settings/phoneVerification.html\'"></div></div></div>');
$templateCache.put('app/pages/autobot/settings/phoneVerification.html','<div class="row"><div class="col-sm-8"><div class="row" style="margin-bottom: 1.6rem;"><div class="col-sm-5 text-center" style="padding-right:40px;"><strong>Account</strong></div><div class="col-sm-5 text-center" style="padding-right: 40px;"><strong>Phone</strong></div><div class="col-sm-2"></div></div><div ng-repeat="a in pac.accounts" class="form-group clearfix"><div class="row settings-account"><div class="col-sm-5"><span class="account-index">{{ ($index + 1) }})</span>&nbsp;&nbsp;{{ a.username }}</div><div class="col-sm-5"><input name="verif_phone_{{ $index }}" tel-format="" type="text" class="form-control label-select" maxlength="14" ng-model="pac.verif_form[$index].verif_phone" ng-required="true"></div><div class="col-sm-2 text-left"><button type="button" class="btn btn-primary label-select" ng-click="pac.checkPhoneVerifDuplicatesAndSave(a,pac.verif_form[$index].verif_phone, $index, false)"><i class="ion-paper-airplane"></i></button></div></div></div></div></div>');
$templateCache.put('app/pages/autobot/settings/postingAccounts.html','<div class="row"><div ng-repeat="a in pa.accounts" class="col-sm-12"><div class="row settings-account"><div class="col-sm-6"><span class="account-index">{{ ($index + 1) }})</span>&nbsp;&nbsp;{{ a.username }}</div><div class="col-sm-5"><div ng-if="a.status === \'ACTIVE\' && (a.verified || a.lastUsedAt > 0)" class="account-labels"><label class="tag label label-success" uib-tooltip="This account is currently used for posting.">{{ a.status }}</label></div><div ng-if="a.status === \'PENDING\'" class="account-labels"><label class="tag label label-info pending" uib-tooltip="This account will be used once account credentials have been verified by Autobot.">PENDING VERIFICATION</label></div><div ng-if="a.status === \'VERIFYING\'" class="account-labels"><label class="tag label label-info pending" uib-tooltip="Credentials for this account are being verified.">VERIFYING CREDENTIALS</label></div><div ng-if="a.status === \'PAUSED\' || a.status === \'DISABLED\'" class="account-labels"><label class="tag label label-default" uib-tooltip="Posting from this account has been {{ a.status.toLowerCase() }}.">{{ a.status }}</label> <label ng-if="a.reason" class="tag label label-default">{{ a.reason }}</label> <button ng-if="hasRWPerms && a.reason !== \'BLOCKED\'" type="button" ng-confirm="Are you sure you want to activate this account?" confirm-ok="pa.enableAccount(a, $index)" class="btn btn-default btn-xs btn-with-icon" style="margin-left: 1rem;"><i class="ion-checkmark"></i>Activate</button></div></div><div class="col-sm-1 text-right"><button ng-if="hasRWPerms" type="button" ng-confirm="" confirm-ok="pa.delete(a)" class="btn btn-default btn-xs"><i class="ion-close-round"></i></button></div></div><div ng-if="a.status !== \'ACTIVE\' && a.reason === \'PHONE VERIFICATION\' && a.lastDraftURL" class="row settings-account-drafturl"><div class="col-sm-12">{{ a.lastDraftURL }}</div></div></div><div ng-if="!pa.accounts || !pa.accounts.length" style="margin: 0 16px;"><div class="alert bg-warning"><i class="ion-android-warning" style="margin-right: 6px;"></i><strong>Please add an account to begin posting.</strong></div></div></div><hr><div ng-if="hasRWPerms" class="row ng-cloak" style="margin: 12px;"><form name="form"><div class="form-group"><label>E-mail</label> <input name="username" type="text" ng-model="pa.r.username" ng-required="true" ng-minlength="4" placeholder="E-mail" class="form-control"></div><div class="form-group"><label>Password</label> <input name="password" type="password" ng-model="pa.r.password" ng-required="true" ng-minlength="4" placeholder="Password" class="form-control"></div><div class="text-right" style="padding: 16px;"><button type="button" class="btn btn-primary btn-with-icon" ng-click="pa.add(pa.r)" ng-disabled="form.$invalid || pa.r.$invalid"><i class="ion-checkmark"></i>Add account</button></div></form></div>');
$templateCache.put('app/pages/autobot/settings/postingConfig.html','<form name="config"><fieldset ng-disabled="!hasRWPerms"><div class="form-group"><label class="col-sm-3 control-label label-select">Posting Frequency:</label><div class="col-sm-9"><select ng-model="pc.form.postingFrequency" class="form-control input-autowidth"><option value="lowest">On boarding</option><option value="low">Low</option><option value="medium">Medium</option><option value="high">High</option></select></div></div><div ng-if="hasRWPerms" class="row" style="margin-top: 60px;"><div class="col-sm-12 text-right"><button type="button" class="btn btn-default" ng-click="pc.reset()" ng-disabled="config.$pristine">Reset</button> <button type="button" class="btn btn-primary btn-with-icon" ng-click="pc.save(pc.form)" ng-disabled="config.$pristine || pc.$invalid"><i class="ion-checkmark"></i>Save config</button></div></div></fieldset></form>');
$templateCache.put('app/pages/autobot/settings/postingRegions.html','<div class="row" style="margin: 12px;"><p ng-repeat="r in pr.regions" style="line-height: 2.4rem;"><i class="ion-arrow-right-c text-muted"></i> <span style="margin: 0 4px;">{{ r.region }}</span> <i class="ion-arrow-right-b text-muted" ng-if="r.subregion"></i> <span ng-if="r.subregion" style="margin: 0 4px;">{{ r.subregion }}</span> <i class="ion-arrow-right-b text-muted" ng-if="r.neighborhood"></i> <span ng-if="r.neighborhood" style="margin: 0 4px;">{{ r.neighborhood }}</span> <button ng-if="hasRWPerms" type="button" ng-confirm="" confirm-ok="pr.deleteRegion(r)" class="btn btn-default btn-xs pull-right"><i class="ion-close-round pull-right"></i></button></p><div ng-if="!pr.regions || !pr.regions.length" style="margin: 0 16px;"><div class="alert bg-warning"><i class="ion-android-warning" style="margin-right: 6px;"></i><strong>Please set a region to post.</strong></div></div></div><hr><div ng-if="hasRWPerms" class="row ng-cloak" style="margin: 12px;"><div class="form-group"><ui-select ng-model="pr.r.region" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="pr.r.subregion = null; pr.r.neighborhood = null; pr.r._subregions = $select.selected.subregions._index; pr.checkDone(pr.r)"><ui-select-match placeholder="Select region"><span>{{ $select.selected.region }}</span></ui-select-match><ui-select-choices repeat="_r in pr._regions | filter: $select.search"><span ng-bind-html="_r.region"></span></ui-select-choices></ui-select></div><div class="form-group" ng-if="pr.r.region._has_subregions"><ui-select ng-model="pr.r.subregion" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="pr.r.neighborhood = null; pr.r._neighborhoods = pr.r.region.subregions[$select.selected]._index; pr.checkDone(pr.r)"><ui-select-match placeholder="Select nearest area"><span>{{ $select.selected }}</span></ui-select-match><ui-select-choices repeat="_s in pr.r._subregions | filter: $select.search"><span ng-bind-html="_s"></span></ui-select-choices></ui-select></div><div class="form-group" ng-if="pr.r.region.subregions[pr.r.subregion]._has_neighborhoods"><ui-select ng-model="pr.r.neighborhood" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="pr.checkDone(pr.r)"><ui-select-match placeholder="Select neighborhood"><span>{{ $select.selected }}</span></ui-select-match><ui-select-choices repeat="_n in pr.r._neighborhoods | filter: $select.search"><span ng-bind-html="_n"></span></ui-select-choices></ui-select></div><div class="text-right" style="padding: 16px;"><button type="button" class="btn btn-primary btn-with-icon" ng-click="pr.addRegion(pr.r)" ng-disabled="pr.r.$invalid"><i class="ion-checkmark"></i>Add region</button></div></div>');
$templateCache.put('app/pages/autobot/settings/propertyDefaults.html','<form name="defaults"><fieldset ng-disabled="!hasRWPerms"><div class="row" style="margin: 12px; line-height: 3rem;"><div class="col-sm-6"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="pd.form.contactByPhone"><span>Contact by phone</span></label></div><div class="col-sm-6"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="pd.form.contactByText"><span>Contact by text</span></label></div><div class="col-sm-6"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="pd.form.cats"><span>Cats</span></label></div><div class="col-sm-6"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="pd.form.dogs"><span>Dogs</span></label></div><div class="col-sm-6"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="pd.form.furnished"><span>Furnished</span></label></div><div class="col-sm-6"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="pd.form.noSmoking"><span>No smoking</span></label></div><div class="col-sm-6"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="pd.form.wheelchairAcc"><span>Wheelchair Accessible</span></label></div></div><div ng-if="hasRWPerms" class="row"><div class="col-sm-12 text-right"><button type="button" class="btn btn-default" ng-click="pd.reset()" ng-disabled="defaults.$pristine">Reset</button> <button type="button" class="btn btn-primary btn-with-icon" ng-click="pd.save(pd.form)" ng-disabled="defaults.$pristine || pd.$invalid"><i class="ion-checkmark"></i>Save defaults</button></div></div></fieldset></form>');
$templateCache.put('app/pages/autobot/templates/amenities.html','<div class="text-right" style="padding: 8px 16px 32px 16px;"><button type="button" class="btn btn-default btn-with-icon btn-sm" ng-click="addAmenity(form)"><i class="ion-plus-round"></i> Add amenity</button></div><div class="row" style="margin-bottom: 1.6rem;"><div class="col-sm-8 text-left" style="padding-left:40px;"><strong>Amenity</strong></div><div class="col-sm-2 text-center" style="padding-right: 40px;"><strong>Enabled</strong></div><div class="col-sm-2"></div></div><div style="min-height: 270px;"><div ng-repeat="t in form.amenities" id="field-amenity-{{ $index }}" class="form-group"><div class="col-sm-8"><input name="amenity_{{ $index }}" type="text" class="form-control" maxlength="70" ng-model="t.amenity" ng-required="true" ng-class="{\'has-error\': listing.amenity_{{ $index }}.$dirty && listing.amenity_{{ $index }}.$invalid }"></div><div class="col-sm-2 text-center"><ba-switcher switcher-value="t.enabled" switcher-style="success" switcher-on-label="YES" switcher-off-label="NO"></ba-switcher></div><div class="col-sm-2 text-right"><button type="button" class="btn btn-danger" ng-confirm="" confirm-ok="deleteTitle(form.amenities, $index)"><i class="ion-trash-b"></i></button></div></div></div>');
$templateCache.put('app/pages/autobot/templates/cities.html','<div class="text-right" style="padding: 8px 16px 32px 16px;"><button type="button" class="btn btn-default btn-with-icon btn-sm" ng-click="addCity(form)"><i class="ion-plus-round"></i> Add city</button></div><div class="row" style="margin-bottom: 1.6rem;"><div class="col-sm-8 text-left" style="padding-left:40px;"><strong>City</strong></div><div class="col-sm-2 text-center" style="padding-right: 40px;"><strong>Enabled</strong></div><div class="col-sm-2"></div></div><div style="min-height: 270px;"><div ng-repeat="t in form.cities" id="field-city-{{ $index }}" class="form-group"><div class="col-sm-8"><input name="city_{{ $index }}" type="text" class="form-control" maxlength="70" ng-model="t.city" ng-required="true" ng-class="{\'has-error\': listing.city_{{ $index }}.$dirty && listing.city_{{ $index }}.$invalid }"></div><div class="col-sm-2 text-center"><ba-switcher switcher-value="t.enabled" switcher-style="success" switcher-on-label="YES" switcher-off-label="NO"></ba-switcher></div><div class="col-sm-2 text-right"><button type="button" class="btn btn-danger" ng-confirm="" confirm-ok="deleteTitle(form.cities, $index)"><i class="ion-trash-b"></i></button></div></div></div>');
$templateCache.put('app/pages/autobot/templates/descriptions.html','<div class"row"="" style="margin: 16px; padding: 16px;"><div class="col-sm-11 col-xs-11" style="border: 1px solid #444; border-radius: 6px; margin: 4px; padding: 8px; max-height: 600px; overflow-y: scroll"><h3 style="margin-bottom: 16px; margin-left: 8px" class="panel-title cut-with-dots">Website text</h3><div class="form-group"><label class="text-left col-sm-1 control-label">Text:</label><div class="col-sm-10"><textarea class="form-control" style="height: 360px" ng-model="desc_form.default_desc" ng-readonly="true" ng-minlength="40">\n        </textarea></div></div></div></div><div class"row"="" style="margin: 16px; padding: 16px;"><div class="col-sm-11 col-xs-11" style="border: 1px solid #444; border-radius: 6px; margin: 4px; padding: 8px; max-height: 600px; overflow-y: scroll"><h3 style="margin-bottom: 16px; margin-left: 8px" class="panel-title cut-with-dots">Descriptions</h3><div class="text-right" style="padding: 0px 16px 32px 16px;"><button type="button" class="btn btn-default btn-with-icon btn-sm" ng-click="addDescription(desc_form.descriptions)"><i class="ion-plus-round"></i> Add section</button></div><div class="form-group" ng-repeat="t in desc_form.descriptions track by $index"><div class="col-sm-1"><select id="Description {{$index + 1}}" name="section" class="form-control" ng-model="t.section" ng-class="{\'has-error\': desc_form.description_{{ $index }}.$dirty && desc_form.description_{{ $index }}.$invalid }"><option value="intro">Intro</option><option value="mid1">Middle-1</option><option value="mid2">Middle-2</option><option value="amenities">Amenities</option><option value="specials">Specials</option><option value="contact">Contact</option><option value="end">End</option></select></div><div class="col-sm-10"><div class="backdrop" style="overflow:auto"><div class="highlights" style="word-wrap:break-word"><textarea name="description_{{ $index }}" class="form-control" style="height: 100px; margin:0; border-radius:2" ng-model="t.description" ng-required="true" ng-class="{\'has-error\': desc_form.description_{{ $index }}.$dirty && desc_form.description_{{ $index }}.$invalid }">\n                </textarea></div></div></div><div class="col-sm-1 text-right"><button type="button" class="btn btn-danger" ng-confirm="" confirm-ok="deleteDescription(desc_form.descriptions, $index)" ng-class="{\'has-error\': desc_form.description_{{ $index }}.$dirty && desc_form.description_{{ $index }}.$invalid }"><i class="ion-trash-b"></i></button></div></div></div></div>');
$templateCache.put('app/pages/autobot/templates/index.html','<div class="section-nav-top"></div><div style="margin-top: 1rem;" ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Captions"><div class"row"=""><div class"col-sm-12"=""><form name="listing" class="form-horizontal" ng-init="reset()"><div class="row"><div style="margin-top: 0rem; margin-right: 0rem; margin-bottom: 2rem; border-bottom: 1px #444 solid; padding:6px;" class="text-right"><button type="button" class="btn btn-primary btn-with-icon" ng-click="saveTemplate(form)" ng-disabled="listing.$pristine || listing.$invalid"><i class="ion-paper-airplane"></i> Save</button></div><div class="col-sm-8 col-xs-8" style="border: 1px solid #444; border-radius: 6px; margin: 16px; padding: 16px; max-height: 600px; overflow-y: scroll"><h3 style="margin-bottom: 16px; margin-left: 8px" class="panel-title cut-with-dots">Titles</h3><div style="border-top: 1px solid #444; margin-bottom: 16px" ng-include="\'app/pages/autobot/templates/titles.html\'"></div></div><div class="col-sm-8 col-xs-8" style="border: 1px solid #444; border-radius: 6px; margin: 16px; padding: 16px;"><h3 style="margin-bottom: 16px; margin-left: 8px" class="panel-title cut-with-dots">Seasonal Titles</h3><div style="border-top: 1px solid #444; margin-bottom: 16px" ng-include="\'app/pages/autobot/templates/seasonal_titles.html\'"></div></div><div class="col-sm-8 col-xs-8" style="border: 1px solid #444; border-radius: 6px; margin: 16px; padding: 16px;"><h3 style="margin-bottom: 16px; margin-left: 8px" class="panel-title cut-with-dots">Amenities</h3><div style="border-top: 1px solid #444; margin-bottom: 16px" ng-include="\'app/pages/autobot/templates/amenities.html\'"></div></div><div class="col-sm-8 col-xs-8" style="border: 1px solid #444; border-radius: 6px; margin: 16px; padding: 16px;"><h3 style="margin-bottom: 16px; margin-left: 8px" class="panel-title cut-with-dots">Cities</h3><div style="border-top: 1px solid #444; margin-bottom: 16px" ng-include="\'app/pages/autobot/templates/cities.html\'"></div></div></div></form></div></div></uib-tab><uib-tab heading="Descriptions"><div class"row"=""><div class"col-sm-12"=""><form name="listing_desc" class="form-horizontal" ng-init="reset()"><div class="row"><div style="margin-top: 0rem; margin-right: 0rem; margin-bottom: 2rem; border-bottom: 1px #444 solid; padding:6px;" class="text-right"><button type="button" class="btn btn-primary btn-with-icon" ng-click="saveDescTemplate(desc_form)" ng-disabled="listing_desc.$pristine || listing_desc.$invalid"><i class="ion-paper-airplane"></i> Save</button></div><div ng-include="\'app/pages/autobot/templates/descriptions.html\'"></div></div></form></div></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/autobot/templates/seasonal_titles.html','<div class="text-right" style="padding: 8px 16px 32px 16px;"><button type="button" class="btn btn-default btn-with-icon btn-sm" ng-click="addTitle(form.seasonal_titles,true)"><i class="ion-plus-round"></i> Add title</button></div><div class="row" style="margin-bottom: 1.6rem;"><div class="col-sm-5 text-left" style="padding-left:40px;"><strong>Title</strong></div><div class="col-sm-2 text-center" style="padding-right: 40px;"><strong>English/Spanish</strong></div><div class="col-sm-2 text-center" style="padding-right: 40px;"><strong>Active from</strong></div><div class="col-sm-2 text-center" style="padding-right: 40px;"><strong>Active until</strong></div><div class="col-sm-1"></div></div><div style="min-height: 270px;"><div ng-repeat="t in form.seasonal_titles" id="field-title-{{ $index }}" class="form-group"><div class="col-sm-5"><input name="title_{{ $index }}" type="text" class="form-control" maxlength="2000" ng-model="t.title" ng-required="true" ng-class="{\'has-error\': listing.title_{{ $index }}.$dirty && listing.title_{{ $index }}.$invalid }"></div><div class="col-sm-2 text-center"><ba-switcher switcher-value="t.english" switcher-style="info" switcher-on-label="EN" switcher-off-label="ES"></ba-switcher></div><div class="col-sm-2 text-center"><p class="input-group"><input type="text" name="fromdate_{{ $index }}" class="form-control" onkeydown="return false" uib-datepicker-popup="dd-MMM" ng-class="{\'has-error\': listing.fromdate_{{ $index }}.$dirty && listing.fromdate_{{ $index }}.$invalid }" ng-model="t.fromdate" ng-model-options="{ timezone: \'UTC\' }" is-open="date[$index].$from_opened" ng-required="true" ng-change="validateFromToDates(form,t.fromdate,t.todate, listing.fromdate_{{ $index }})" close-text="Close" show-button-bar="false" datepicker-options="{showWeeks:false}"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="date[$index].$from_opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2 text-center"><p class="input-group"><input type="text" name="todate_{{ $index }}" class="form-control" onkeydown="return false" uib-datepicker-popup="dd-MMM" ng-class="{\'has-error\': listing.todate_{{ $index }}.$dirty && listing.todate_{{ $index }}.$invalid }" ng-model="t.todate" ng-model-options="{ timezone: \'UTC\' }" is-open="date[$index].$to_opened" ng-required="true" ng-change="validateFromToDates(form,t.fromdate,t.todate, listing.todate_{{ $index }})" close-text="Close" show-button-bar="false" datepicker-options="{showWeeks:false}"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="date[$index].$to_opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-1 text-right"><button type="button" class="btn btn-danger" ng-confirm="" confirm-ok="deleteTitle(form.seasonal_titles, $index)"><i class="ion-trash-b"></i></button></div></div></div>');
$templateCache.put('app/pages/autobot/templates/titles.html','<div class="text-right" style="padding: 8px 16px 32px 16px;"><button type="button" class="btn btn-default btn-with-icon btn-sm" ng-click="addTitle(form.titles,false)"><i class="ion-plus-round"></i> Add title</button></div><div class="row" style="margin-bottom: 1.6rem;"><div class="col-sm-8 text-left" style="padding-left:40px;"><strong>Title</strong></div><div class="col-sm-2 text-center" style="padding-right: 40px;"><strong>English/Spanish</strong></div><div class="col-sm-2"></div></div><div style="min-height: 270px;"><div ng-repeat="t in form.titles" id="field-title-{{ $index }}" class="form-group"><div class="col-sm-8"><input name="title_{{ $index }}" type="text" class="form-control" maxlength="2000" ng-model="t.title" ng-required="true" ng-class="{\'has-error\': listing.title_{{ $index }}.$dirty && listing.title_{{ $index }}.$invalid }"></div><div class="col-sm-2 text-center"><ba-switcher switcher-value="t.english" switcher-style="info" switcher-on-label="EN" switcher-off-label="ES"></ba-switcher></div><div class="col-sm-2 text-right"><button type="button" class="btn btn-danger" ng-confirm="" confirm-ok="deleteTitle(form.titles, $index)"><i class="ion-trash-b"></i></button></div></div></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item" ng-if="!item.disabled"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue" ng-change="switcherOnchange({ ref: switcherRef, value: switcherValue })"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">{{ switcherOnLabel || \'ON\' }}</span> <span class="handle"></span> <span class="handle handle-off">{{ switcherOffLabel || \'OFF\' }}</span></div></div></label>');
$templateCache.put('app/pages/autobot/images/folder/index.html','<div class="row page-content"><div class="col-sm-12"><div class="row" style="margin-bottom: 20px;"><div class="col-xs-6 text-left"><button class="btn btn-default btn-with-icon" ng-click="$state.go(\'^.images\')"><i class="ion-android-arrow-back"></i> Images</button></div><div class="col-xs-6 text-right"><div ngf-drop="uploadFile($file)" ngf-drag-over-class="dragOverClass($event)" ng-model="file" ng-multiple="false"><button class="btn btn-primary btn-with-icon" resetonclick="true" ngf-select="uploadFile($file)"><i class="ion-upload"></i> Upload image</button></div></div></div></div><div class="col-sm-12"><div class="row"><table ng-if="images.length > 0" class="table" st-table="imgs" st-safe-src="images"><thead><tr class="sortable black-muted-bg2 table-hdr"><th class="non-clickable"></th><th></th><th class="non-clickable">Amenities</th><th st-sort="unittype">Unit Type</th><th class="non-clickable">Locations</th><th class="non-clickable">Views</th><th st-sort="uploadedBy">Uploaded by</th><th st-sort="createdAt" st-sort-default="true" st-descending-first="true">Created at</th></tr></thead><tbody><tr ng-repeat="im in imgs track by im.imageId"><td><div class="rank"><div ng-click="!im._updating && upvoteImage(im)" class="score-upvote clickable ng-class:{ \'score-upvote-active\': hasUpvoted(im) }"><i class="fa fa-thumbs-o-up" aria-hidden="true"></i></div><div ng-click="!im._updating && downvoteImage(im)" class="score-downvote clickable ng-class:{ \'score-upvote-active\': hasDownvoted(im) }"><i class="fa fa-thumbs-o-down" aria-hidden="true"></i></div><div ng-show="im._updating"><i class="ion-load-c spin"></i></div></div></td><td><a cl-href="{{ ::im.cloudinaryId }}" format="jpg" fancyboxable="{ padding: 18 }"><cl-image public-id="{{ im.cloudinaryId }}" class="thumbnail" secure="true" width="150" height="150" crop="fit" quality="80" format="jpg" style="margin: 12px 0;"></cl-image></a></td><td class="clickable" ng-click="updateImageData(im)"><span class="label label-primary label-tag" ng-repeat="t in im.propertyAmenities">{{ t }}</span><br ng-if="im.propertyAmenities.length > 0"><span class="label label-success label-tag" ng-repeat="t in im.unitAmenities">{{ t }}</span></td><td class="clickable" ng-click="updateImageData(im)">{{ im.unittype }} <span ng-if="im.isModelUnit" class="text-muted"><small>(model)</small></span></td><td class="clickable" ng-click="updateImageData(im)">{{ (im.locations || []).join(\', \') }}</td><td class="clickable" ng-click="updateImageData(im)">{{ (im.views || []).join(\', \') }}</td><td class="clickable" ng-click="updateImageData(im)">{{ ::im.users[im.uploadedBy].name }}</td><td class="clickable" ng-click="updateImageData(im)"><span am-time-ago="(im.createdAt / 1000) | amFromUnix"></span></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="10"></div></td></tr></tfoot></table><div ng-if="images.length === 0" class="banner"><div class="large-banner-wrapper"></div><div class="banner-text-wrapper"><div class="banner-text"><p>No images found.</p></div></div></div></div></div></div>');
$templateCache.put('app/pages/autobot/images/folder/upload.html','<div class="modal-content"><div class="modal-header"><button ng-if="context.success && !context.success.cloudinaryId && !context.submit" type="button" class="close" ng-confirm="Uploaded image will be discarded. Are you sure?" confirm-ok="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button> <button ng-if="context.success && context.success.cloudinaryId && !context.submit" type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">{{ context.title }}</h4></div><div class="modal-body"><div ng-if="!context.success" class="row"><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="{{ context.progress }}" aria-valuemin="0" aria-valuemax="100" ng-style="{ \'width\': context.progress + \'%\' }">Uploading ({{ context.progress }}% complete)</div></div></div><div ng-if="context.success && context.submit" class="row"><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div></div></div><div ng-if="context.success && !context.submit" class="row"><div class="col-sm-4 text-center" ng-init="public_id = context.success.public_id || context.success.cloudinaryId"><a cl-href="{{ public_id }}" format="jpg" fancyboxable="{ padding: 18 }"><cl-image class="thumbnail inline block-center" public-id="{{ public_id }}" secure="true" width="150" height="150" crop="fit" quality="80" format="jpg"></cl-image></a></div><div class="col-sm-8"><div class="row"><div class="form-group"><label>Property amenity:</label> <input class="form-control" ng-model="form.propertyAmenities" type="text" tag-input="primary" data-role="tagsinput" placeholder="Add amenity"></div></div><div class="row"><div class="form-group"><label>Unit amenity:</label> <input class="form-control" ng-model="form.unitAmenities" type="text" tag-input="success" data-role="tagsinput" placeholder="Add amenity"></div></div><div class="row"><div class="form-group"><label>Unit type:</label><ui-select ng-model="form.unittype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false"><ui-select-match placeholder="Select unit type"><span>{{ $select.selected.name }}</span></ui-select-match><ui-select-choices repeat="ut in unittypes | filter: $select.search"><span ng-bind-html="ut.name"></span></ui-select-choices></ui-select></div></div><div class="row" ng-if="form.unittype.id !== -1"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="form.isModelUnit"><span>Is model unit?</span></label></div></div><div class="row"><div class="form-group"><label>Location:</label> <input class="form-control" ng-model="form.locations" type="text" tag-input="primary" data-role="tagsinput" placeholder="Add location"></div></div><div class="row"><div class="form-group"><label>Views:</label> <input class="form-control" ng-model="form.views" type="text" tag-input="primary" data-role="tagsinput" placeholder="Add view"></div></div></div></div></div><div class="modal-footer"><button ng-if="context.canAdmin" ng-disabled="context.submit" type="button" class="btn btn-danger btn-with-icon pull-left" ng-confirm="" confirm-ok="delete(context.success)"><i class="ion-trash-b"></i>Delete</button> <button ng-if="context.success" ng-disabled="context.submit" type="button" class="btn btn-primary btn-with-icon" ng-click="save(form)"><i class="ion-checkmark"></i>Save changes</button></div></div>');
$templateCache.put('app/pages/autobot/jobs/view/index.html','<div class="section-nav-top row"><div class="col-sm-2"><button type="button" class="btn btn-default btn-with-icon" ng-click="$state.go(\'root.autobot.listings\')"><i class="ion-android-arrow-back"></i> Jobs</button></div></div><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel"><form name="job" class="form-horizontal"><uib-tabset active="activeTab"><uib-tab index="0" heading="Unit Type" ui-sref=".unittype"><div class="form-group"><label class="col-sm-2 control-label">Unit Type:</label><div class="col-sm-3"><p class="form-control-static2">{{ ::form.unittypeName }}</p></div><label class="col-sm-2 control-label">Floorplan:</label><div class="col-sm-3"><p class="form-control-static2">{{ ::form.floorplanName }}</p></div></div><div class="form-group"><label class="col-sm-2 control-label">Beds:</label><div class="col-sm-3"><p class="form-control-static2">{{ ::form.beds }}</p></div><label class="col-sm-2 control-label">Bathrooms:</label><div class="col-sm-3"><p class="form-control-static2">{{ ::form.baths }}</p></div></div><div id="field-area" class="form-group"><label class="col-sm-2 control-label">Area:</label><div class="col-sm-3"><p class="form-control-static2">{{ ::form.sqft }} sqft</p></div><label ng-if="form.generated !== true" class="col-sm-2 control-label">Rent:</label><div ng-if="form.generated !== true" class="col-sm-3"><p class="form-control-static2">${{ ::form.rent }}</p></div></div></uib-tab><uib-tab index="1" heading="Title" ui-sref=".title"><div class="form-group" ng-repeat="title in form.titles track by $index"><label class="col-sm-2 control-label">Title {{ $index + 1 }}:</label><div class="col-sm-10"><p class="form-control-static2">{{ ::title }}</p></div></div></uib-tab><uib-tab index="2" heading="Description" ui-sref=".description"><div class="form-group" ng-repeat="description in form.descriptions track by $index"><label class="col-sm-2 control-label">Description {{ $index + 1 }}:</label><div class="col-sm-10"><p class="form-control-static2"><pre style="white-space:pre-line;">{{ ::description }}</pre></p></div></div></uib-tab><uib-tab index="3" heading="Contact" ui-sref=".contact"><div class="form-group"><label class="col-sm-2 control-label">E-mail:</label><div class="col-sm-5"><p class="form-control-static2">{{ ::form.email }}</p></div></div><div class="form-group"><label class="col-sm-2 control-label">Contact Name:</label><div class="col-sm-5"><p class="form-control-static2">{{ ::form.contactName }}</p><small class="text-muted"><i>{{ ::form.contactJobPosition ? \'(\' + form.contactJobPosition + \')\' : \'\' }}</i></small></div></div><div class="form-group"><label class="col-sm-2 control-label">Phone:</label><div class="col-sm-5"><p class="form-control-static2">{{ ::form.phone }}</p></div></div><div class="form-group"><label class="col-sm-2 control-label">Website:</label><div class="col-sm-5"><p class="form-control-static2"><a href="{{ form.website }}" target="_blank">{{ ::form.website }}</a></p></div></div></uib-tab></uib-tabset></form></div>');
$templateCache.put('app/pages/autobot/listings/create/index.html','<div class="section-nav-top"><button type="button" class="btn btn-default btn-with-icon" ng-click="$state.go(\'root.autobot.listings\')"><i class="ion-android-arrow-back"></i> Listings</button></div><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel"><form name="listing" class="form-horizontal"><uib-tabset active="activeTab"><uib-tab index="0" heading="Floor Plan" ui-sref=".floorplan"><div class="form-group"><label class="col-sm-2 control-label">Beds:</label><div class="col-sm-10"><select ng-model="form.beds" class="form-control input-autowidth"><option value="0">0</option><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option><option value="5">5</option><option value="6">6</option><option value="7">7</option><option value="8">8</option></select></div></div><div class="form-group"><label class="col-sm-2 control-label">Bathrooms:</label><div class="col-sm-10"><select ng-model="form.baths" class="form-control input-autowidth"><option value="shared">shared</option><option value="split">split</option><option value="1">1</option><option value="1.5">1.5</option><option value="2">2</option><option value="2.5">2.5</option><option value="3">3</option><option value="3.5">3.5</option><option value="4">4</option><option value="4.5">4.5</option><option value="5">5</option><option value="5.5">5.5</option><option value="6">6</option><option value="6.5">6.5</option><option value="7">7</option><option value="7.5">7.5</option><option value="8">8</option><option value="8.5">8.5</option><option value="9+">9+</option></select></div></div><div id="field-area" class="form-group" ng-class="{\'has-error\': listing.sqft.$dirty && listing.sqft.$invalid}"><label class="col-sm-2 control-label">* Area:</label><div class="col-sm-3"><div class="input-group" style="margin-bottom: 0px;"><input type="number" class="form-control with-addon" ng-minlength="2" maxlength="6" name="sqft" ng-model="form.sqft" required=""> <span class="input-group-addon addon-right input-group-addon-primary">sqft</span></div></div></div><div id="field-rent" class="form-group" ng-class="{\'has-error\': listing.rent.$dirty && listing.rent.$invalid}"><label class="col-sm-2 control-label">* Rent:</label><div class="col-sm-3"><div class="input-group" style="margin-bottom: 0px;"><span class="input-group-addon addon-left input-group-addon-primary">$</span> <input type="number" class="form-control with-addon" ng-minlength="2" ng-maxlength="8" name="rent" ng-model="form.rent" required=""></div></div></div></uib-tab><uib-tab index="1" heading="Title" ui-sref=".title"><div class="text-right" style="padding: 0 16px 16px 16px;"><button type="button" class="btn btn-default btn-with-icon" ng-click="generateTitles(form)"><i class="ion-ios-color-wand-outline"></i> Generate</button></div><div id="field-title1" class="form-group" ng-class="{\'has-error\': validations.title1}"><label class="col-sm-2 control-label">Title 1:</label><div class="col-sm-10"><input type="text" class="form-control" maxlength="70" ng-model="form.title1"></div></div><div class="form-group" ng-class="{\'has-error\': validations.title2}"><label class="col-sm-2 control-label">Title 2:</label><div class="col-sm-10"><input type="text" class="form-control" maxlength="70" ng-model="form.title2"></div></div><div class="form-group" ng-class="{\'has-error\': validations.title3}"><label class="col-sm-2 control-label">Title 3:</label><div class="col-sm-10"><input type="text" class="form-control" maxlength="70" ng-model="form.title3"></div></div><div class="form-group" ng-class="{\'has-error\': validations.title4}"><label class="col-sm-2 control-label">Title 4:</label><div class="col-sm-10"><input type="text" class="form-control" maxlength="70" ng-model="form.title4"></div></div><div class="form-group" ng-class="{\'has-error\': validations.title5}"><label class="col-sm-2 control-label">Title 5:</label><div class="col-sm-10"><input type="text" class="form-control" maxlength="70" ng-model="form.title5"></div></div></uib-tab><uib-tab index="2" heading="Description" ui-sref=".description"><div class="text-right" style="padding: 0 16px 16px 16px;"><button type="button" class="btn btn-default btn-with-icon" ng-click="generateDescriptions(form)"><i class="ion-ios-color-wand-outline"></i> Generate</button></div><div class="form-group" ng-class="{\'has-error\': validations.description1}"><label class="col-sm-2 control-label">Description 1:</label><div class="col-sm-10"><textarea style="width: 100%; min-height: 350px;" placeholder="" class="form-control" ng-model="form.description1"></textarea></div></div><div class="form-group" ng-class="{\'has-error\': validations.description2}"><label class="col-sm-2 control-label">Description 2:</label><div class="col-sm-10"><textarea style="width: 100%; min-height: 350px;" placeholder="" class="form-control" ng-model="form.description2"></textarea></div></div><div class="form-group" ng-class="{\'has-error\': validations.description3}"><label class="col-sm-2 control-label">Description 3:</label><div class="col-sm-10"><textarea style="width: 100%; min-height: 350px;" placeholder="" class="form-control" ng-model="form.description3"></textarea></div></div><div class="form-group" ng-class="{\'has-error\': validations.description4}"><label class="col-sm-2 control-label">Description 4:</label><div class="col-sm-10"><textarea style="width: 100%; min-height: 350px;" placeholder="" class="form-control" ng-model="form.description4"></textarea></div></div><div class="form-group" ng-class="{\'has-error\': validations.description5}"><label class="col-sm-2 control-label">Description 5:</label><div class="col-sm-10"><textarea style="width: 100%; min-height: 350px;" placeholder="" class="form-control" ng-model="form.description5"></textarea></div></div></uib-tab><uib-tab index="3" heading="Contact" ui-sref=".contact"><div class="form-group" ng-class="{\'has-error\': validations.location}"><label class="col-sm-2 control-label">Location:</label><div class="col-sm-5"><input type="text" class="form-control" maxlength="150" ng-model="form.location"></div></div><div class="form-group" ng-class="{\'has-error\': validations.email}"><label class="col-sm-2 control-label">E-mail:</label><div class="col-sm-5"><input type="email" class="form-control" maxlength="150" ng-model="form.email"></div></div><div class="form-group" ng-class="{\'has-error\': validations.contactName}"><label class="col-sm-2 control-label">Contact Name:</label><div class="col-sm-5"><input type="text" class="form-control" maxlength="32" ng-model="form.contactName"></div></div><div class="form-group" ng-class="{\'has-error\': listing.phone.$dirty && listing.phone.$invalid}"><label class="col-sm-2 control-label">Phone:</label><div class="col-sm-5"><input type="tel" class="form-control" maxlength="16" name="phone" ng-model="form.phone"></div></div><div class="form-group"><label class="col-sm-2 control-label"></label><div class="col-sm-10"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="form.contactByPhone"><span>Contact by phone</span></label></div></div><div class="form-group"><label class="col-sm-2 control-label"></label><div class="col-sm-10"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="form.contactByText"><span>Contact by text</span></label></div></div><div class="form-group" ng-class="{\'has-error\': validations.website}"><label class="col-sm-2 control-label">Website:</label><div class="col-sm-5"><input type="url" class="form-control" maxlength="150" ng-model="form.website"></div></div></uib-tab><uib-tab index="4" heading="Options" ui-sref=".options"><div class="form-group"><div class="col-sm-10"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="form.cats"><span>Cats</span></label></div></div><div class="form-group"><div class="col-sm-10"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="form.dogs"><span>Dogs</span></label></div></div><div class="form-group"><div class="col-sm-10"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="form.furnished"><span>Furnished</span></label></div></div><div class="form-group"><div class="col-sm-10"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="form.noSmoking"><span>No smoking</span></label></div></div><div class="form-group"><div class="col-sm-10"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="form.wheelchairAcc"><span>Wheelchair Accessible</span></label></div></div></uib-tab></uib-tabset><div ng-if="listing.$pristine" style="margin: 16px;"><span>* Required field</span></div><div ng-if="(listing.$dirty && listing.$invalid) || validations.error" style="margin: 0 16px;"><div ng-if="listing.sqft.$dirty && listing.sqft.$invalid" class="alert bg-warning"><strong>Please enter a valid sqft area.</strong></div><div ng-if="listing.rent.$dirty && listing.rent.$invalid" class="alert bg-warning"><strong>Please enter a valid rent amount.</strong></div><div ng-if="validations.titles.error" class="alert bg-warning"><strong>Please enter valid titles or click \'Generate\'.</strong></div><div ng-if="validations.descriptions.error" class="alert bg-warning"><strong>Please enter valid descriptions or click \'Generate\'.</strong></div></div><div class="text-right" style="padding: 16px;"><button type="button" class="btn btn-primary btn-with-icon" ng-click="createListing(form)" ng-disabled="listing.$invalid"><i class="ion-paper-airplane"></i> Create listing</button></div></form></div>');
$templateCache.put('app/pages/autobot/listings/edit/index.html','<div class="section-nav-top"><button type="button" class="btn btn-default btn-with-icon" ng-click="$state.go(\'root.autobot.listings\')"><i class="ion-android-arrow-back"></i> Listings</button></div><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Title"><h1>Title</h1></uib-tab><uib-tab heading="Body"><h1>Body</h1></uib-tab><uib-tab heading="Floor Plan"><h1>Floor Plan</h1></uib-tab><uib-tab heading="Images"><h1>Images</h1></uib-tab><uib-tab heading="Info"><h1>Info</h1><h3>Location</h3><h3>Contact</h3></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/autobot/listings/view/index.html','<div class="section-nav-top row"><div class="col-sm-2"><button type="button" class="btn btn-default btn-with-icon" ng-click="$state.go(\'root.autobot.listings\')"><i class="ion-android-arrow-back"></i> Listings</button></div><div class="col-sm-10 text-right"><button ng-if="form.generated !== true" type="button" class="btn btn-danger btn-with-icon" ng-click="deleteListing()"><i class="ion-trash-a"></i> Delete</button></div></div><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel"><form name="listing" class="form-horizontal"><uib-tabset active="activeTab"><uib-tab index="0" heading="Unit Type" ui-sref=".unittype"><div class="form-group"><label class="col-sm-2 control-label">Unit Type:</label><div class="col-sm-3"><p class="form-control-static2">{{ ::form.unittypeName }}</p></div><label class="col-sm-2 control-label">Floorplan:</label><div class="col-sm-3"><p class="form-control-static2">{{ ::form.floorplanName }}</p></div></div><div class="form-group"><label class="col-sm-2 control-label">Beds:</label><div class="col-sm-3"><p class="form-control-static2">{{ ::form.beds }}</p></div><label class="col-sm-2 control-label">Bathrooms:</label><div class="col-sm-3"><p class="form-control-static2">{{ ::form.baths }}</p></div></div><div id="field-area" class="form-group"><label class="col-sm-2 control-label">Area:</label><div class="col-sm-3"><p class="form-control-static2">{{ ::form.sqft }} sqft</p></div><label ng-if="form.generated !== true" class="col-sm-2 control-label">Rent:</label><div ng-if="form.generated !== true" class="col-sm-3"><p class="form-control-static2">${{ ::form.rent }}</p></div></div></uib-tab><uib-tab index="1" heading="Title" ui-sref=".title"><div class="form-group" ng-repeat="title in form.titles track by $index"><label class="col-sm-2 control-label">Title {{ $index + 1 }}:</label><div class="col-sm-10"><p class="form-control-static2">{{ ::title }}</p></div></div></uib-tab><uib-tab index="2" heading="Description" ui-sref=".description"><div class="form-group" ng-repeat="description in form.descriptions track by $index"><label class="col-sm-2 control-label">Description {{ $index + 1 }}:</label><div class="col-sm-10"><p class="form-control-static2"><pre style="white-space:pre-line;">{{ ::description }}</pre></p></div></div></uib-tab><uib-tab index="3" heading="Contact" ui-sref=".contact"><div class="form-group"><label class="col-sm-2 control-label">E-mail:</label><div class="col-sm-5"><p class="form-control-static2">{{ ::form.email }}</p></div></div><div class="form-group"><label class="col-sm-2 control-label">Contact Name:</label><div class="col-sm-5"><p class="form-control-static2">{{ ::form.contactName }}</p><small class="text-muted"><i>{{ ::form.contactJobPosition ? \'(\' + form.contactJobPosition + \')\' : \'\' }}</i></small></div></div><div class="form-group"><label class="col-sm-2 control-label">Phone:</label><div class="col-sm-5"><p class="form-control-static2">{{ ::form.phone }}</p></div></div><div class="form-group"><label class="col-sm-2 control-label">Website:</label><div class="col-sm-5"><p class="form-control-static2"><a href="{{ form.website }}" target="_blank">{{ ::form.website }}</a></p></div></div></uib-tab></uib-tabset></form></div>');}]);